import * as React from 'react';


export function PairingUIIcon_Knuckles( bHighlightPairingControls: boolean )
{
	return (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 158.9 198.9" className="KnucklesPairingSVG">
		{ bHighlightPairingControls && <ellipse transform="matrix(0.2654 -0.9641 0.9641 0.2654 -28.3693 97.6447)" className="st0 BindingControlHighlight" cx="49.9" cy="67.4" rx="2.1" ry="2.9"/> }
		{ bHighlightPairingControls && <ellipse transform="matrix(0.2121 -0.9773 0.9773 0.2121 -39.1422 73.8828)" className="st0 BindingControlHighlight" cx="26.2" cy="61.2" rx="2.5" ry="4.5"/> }
		{ bHighlightPairingControls && <ellipse transform="matrix(0.2121 -0.9773 0.9773 0.2121 -40.9959 75.2781)" className="st0 BindingControlHighlight" cx="26.2" cy="63.1" rx="2.5" ry="4.5"/> }
		<g id="Group_356" transform="matrix(0.985, -0.174, 0.174, 0.985, -1527.873, 93.429)">
			<g id="LINE" transform="translate(1607.682 346.316)">
				<line id="Line_797" className="st1" x1="3.2" y1="0" x2="0" y2="0.6"/>
			</g>
			<g id="LINE-2" transform="translate(1609.449 356.379)">
				<line id="Line_798" className="st1" x1="0" y1="0.6" x2="3.2" y2="0"/>
			</g>
			<g id="SPLINE" transform="translate(1610.892 346.3)">
				<path id="Path_702" className="st1" d="M3.6,4.4c-0.1-0.5-0.2-1-0.4-1.4C3.1,2.6,3,2.2,2.8,1.9C2.7,1.6,2.5,1.4,2.4,1.1
					C2.3,1,2.1,0.8,2,0.7C1.9,0.6,1.8,0.5,1.7,0.4C1.6,0.3,1.5,0.3,1.3,0.2C1.1,0.1,1,0,0.8,0C0.5,0,0.2,0,0,0"/>
			</g>
			<g id="SPLINE-2" transform="translate(1612.623 350.644)">
				<path id="Path_703" className="st1" d="M0,5.7c0.3-0.1,0.5-0.1,0.8-0.3c0.2-0.1,0.3-0.2,0.5-0.4C1.4,5,1.5,4.8,1.5,4.7
					c0.1-0.1,0.1-0.2,0.2-0.4c0.1-0.2,0.1-0.4,0.2-0.6C2,3.4,2,3.1,2,2.8c0-0.4,0-0.8,0-1.3C2,1.3,2,1.1,2,0.8c0-0.3-0.1-0.6-0.1-0.8"
					/>
			</g>
			<g id="SPLINE-3" transform="translate(1601.514 383.755)">
				<path id="Path_704" className="st1" d="M0,1.1C0.3,1,0.5,1,0.8,0.9c0.5-0.1,1-0.3,1.5-0.4C2.9,0.4,3.5,0.2,4.1,0"/>
			</g>
			<g id="SPLINE-4" transform="translate(1609.377 198.038)">
				<path id="Path_705" className="st1" d="M13.8,17.1c-0.1-0.1-0.2-0.3-0.3-0.4c-0.9-1.4-1.9-2.7-2.9-4c-1-1.3-2-2.6-3-3.9
					c-1-1.3-2.1-2.6-3.2-3.8S2.3,2.4,1.1,1.2C0.8,0.8,0.4,0.4,0,0"/>
			</g>
			<g id="SPLINE-5" transform="translate(1639.386 326.082)">
				<path id="Path_706" className="st1" d="M0,21.2c0-0.1,0-0.1,0.1-0.2c0.6-1.4,1-2.9,1.6-4.4c0.5-1.5,1-2.9,1.4-4.4s0.9-3,1.3-4.5
					c0.4-1.5,0.8-3,1.1-4.5C5.7,2.2,5.9,1.1,6.1,0"/>
			</g>
			<g id="LINE-3" transform="translate(1597.546 370.158)">
				<line id="Line_799" className="st1" x1="0.2" y1="0" x2="0" y2="0.1"/>
			</g>
			<g id="SPLINE-6" transform="translate(1609.413 352.881)">
				<path id="Path_707" className="st1" d="M0,29.6c0.6-0.3,1.3-0.5,1.9-0.8c0.6-0.3,1.1-0.5,1.7-0.8c0.5-0.3,1-0.5,1.4-0.8
					c0.4-0.3,0.8-0.5,1.2-0.7l1-0.6c0.3-0.2,0.5-0.4,0.8-0.6c0.4-0.3,0.9-0.6,1.3-0.9s0.9-0.7,1.3-1l1.3-1.1c0.4-0.4,0.8-0.7,1.2-1.1
					c0.4-0.4,0.7-0.7,1.1-1l1.2-1.2c0.5-0.5,0.9-1,1.3-1.5s0.9-1,1.3-1.6c0.6-0.7,1.2-1.5,1.7-2.2l1.6-2.3c0.5-0.8,1-1.6,1.6-2.4
					c0.5-0.8,1-1.7,1.5-2.5c0.5-0.9,1-1.8,1.4-2.7c0.5-0.9,1-1.9,1.4-2.9L27.7,0"/>
			</g>
			<g id="SPLINE-7" transform="translate(1605.914 194.54)">
				<path id="Path_708" className="st1" d="M3.4,3.4C2.8,2.8,2.3,2.2,1.7,1.7S0.6,0.5,0,0"/>
			</g>
			<g id="SPLINE-8" transform="translate(1601.658 224.008)">
				<path id="Path_709" className="st1" d="M0,0c1,1.7,2.1,3.3,3.1,5c1.2,2,2.3,4,3.3,6.2s2.1,4.3,3.1,6.5c1,2.2,1.9,4.5,2.8,6.7
					c0.9,2.3,1.7,4.6,2.5,7s1.5,4.8,2.2,7.2c0.6,2.4,1.3,4.8,1.8,7.3s1,4.9,1.5,7.4s0.8,4.9,1.1,7.4s0.6,5,0.8,7.4
					c0.2,2.5,0.3,4.9,0.4,7.4s0.1,4.9,0,7.3c0,2.4-0.1,4.8-0.3,7.1s-0.4,4.7-0.7,7c-0.3,2.3-0.6,4.5-1,6.7c-0.3,1.3-0.6,2.6-0.9,3.9"
					/>
			</g>
			<g id="SPLINE-9" transform="translate(1584.526 344.044)">
				<path id="Path_710" className="st1" d="M0,0c0.5,1.2,0.9,2.3,1.4,3.4l2.9,7.1c1,2.5,2,4.9,3,7.4c1,2.6,2.1,5.1,3.1,7.6
					c0.2,0.5,0.4,0.9,0.6,1.4"/>
			</g>
			<g id="SPLINE-10" transform="translate(1540.666 273.999)">
				<path id="Path_711" className="st1" d="M0,0l0.8,0.3c0.7,0.3,1.3,0.6,2,0.9c0.3,0.1,0.6,0.3,0.9,0.5"/>
			</g>
			<g id="SPLINE-11" transform="translate(1574.607 249.76)">
				<path id="Path_712" className="st1" d="M39.2,97.6c-0.3-1.5-0.5-3-0.8-4.4c-0.5-2.5-0.9-4.9-1.4-7.4c-0.5-2.3-0.9-4.6-1.4-6.9
					c-0.5-2.1-0.9-4.1-1.4-6.2c-0.4-1.9-0.9-3.8-1.4-5.7c-0.4-1.7-0.9-3.5-1.3-5.2c-0.4-1.6-0.8-3.2-1.3-4.8c-0.5-1.8-1-3.5-1.5-5.2
					c-0.5-1.6-0.9-3.2-1.4-4.8c-0.5-1.5-0.9-3-1.4-4.4c-0.5-1.4-0.9-2.7-1.4-4c-0.5-1.3-0.9-2.5-1.4-3.8c-0.5-1.2-0.9-2.3-1.4-3.5
					c-0.8-1.9-1.7-3.8-2.6-5.6c-0.9-1.8-1.8-3.5-2.8-5.2c-1-1.7-2-3.3-3.1-4.9c-1-1.6-2.2-3.1-3.3-4.6c-0.5-0.7-1.1-1.4-1.7-2.2
					c-0.5-0.6-1-1.3-1.6-1.9C5.9,6.4,5.5,5.9,5,5.4C4.7,5,4.3,4.6,4,4.1C3.8,4,3.7,3.9,3.6,3.8C3.5,3.6,3.3,3.4,3.2,3.3
					C2.9,3.1,2.7,2.8,2.5,2.6C2.1,2.2,1.7,1.7,1.3,1.3C0.9,0.8,0.4,0.4,0,0"/>
			</g>
			<g id="SPLINE-12" transform="translate(1615.184 354.973)">
				<path id="Path_713" className="st1" d="M1.6,9C1.3,7.4,1,5.8,0.7,4.1C0.5,2.7,0.3,1.4,0,0"/>
			</g>
			<g id="SPLINE-13" transform="translate(1544.778 275.982)">
				<path id="Path_714" className="st1" d="M0,0c0.3,0.1,0.6,0.3,0.9,0.5c0.6,0.3,1.2,0.6,1.8,1c0.5,0.3,1,0.6,1.5,0.9
					C4.6,2.7,5,3,5.4,3.3C5.9,3.6,6.3,4,6.8,4.4C7.1,4.7,7.5,5,7.9,5.3c0.3,0.3,0.5,0.5,0.8,0.8c0.3,0.3,0.5,0.5,0.8,0.8
					c0.3,0.3,0.6,0.6,0.8,0.9c0.3,0.4,0.6,0.7,1,1.1c0.4,0.4,0.8,0.9,1.1,1.4c0.6,0.7,1.1,1.5,1.7,2.3c0.6,0.9,1.2,1.8,1.8,2.7
					c0.5,0.9,1,1.7,1.6,2.6c0.5,0.8,0.9,1.6,1.3,2.4c0.4,0.7,0.8,1.4,1.1,2.1c0.3,0.6,0.6,1.2,0.9,1.8c0.2,0.4,0.4,0.9,0.6,1.3
					c0.2,0.3,0.3,0.7,0.5,1c0.1,0.3,0.3,0.5,0.4,0.8c0.2,0.4,0.4,0.7,0.5,1.1c0.3,0.5,0.5,1,0.7,1.6c0.3,0.7,0.6,1.3,0.9,2
					c0.4,0.8,0.8,1.7,1.1,2.5c0.4,0.9,0.8,1.8,1.2,2.6c0.4,1,0.9,2.1,1.3,3.1l1.5,3.6c0.6,1.4,1.2,2.7,1.7,4.1
					c0.6,1.6,1.3,3.1,1.9,4.6l2.2,5.2c0.8,1.9,1.6,3.9,2.4,5.8l1.8,4.4"/>
			</g>
			<g id="LINE-4" transform="translate(1587.664 379.175)">
				<line id="Line_800" className="st1" x1="0" y1="0" x2="0.9" y2="1.2"/>
			</g>
			<g id="SPLINE-14" transform="translate(1587.664 370.23)">
				<path id="Path_715" className="st1" d="M9.9,0C9.3,0.2,8.7,0.4,8.2,0.7C7.7,0.9,7.3,1.1,6.8,1.3c-0.3,0.2-0.7,0.4-1,0.5
					C5.6,2,5.4,2.1,5.1,2.3L4.6,2.6C4.4,2.7,4.3,2.8,4.1,2.9S3.8,3.1,3.6,3.2C3.4,3.4,3.2,3.5,3.1,3.6C2.9,3.8,2.6,4,2.4,4.1
					S2,4.5,1.8,4.7C1.5,4.9,1.3,5.2,1,5.4C0.8,5.7,0.6,5.9,0.4,6.1L0.1,6.4C0,6.5,0,6.5,0,6.5"/>
			</g>
			<g id="SPLINE-15" transform="translate(1587.267 376.722)">
				<path id="Path_716" className="st1" d="M0.5,0C0.4,0.2,0.2,0.4,0.1,0.6C0,0.8,0,1.1,0,1.3C0,1.5,0,1.8,0.1,2c0.1,0.2,0.2,0.3,0.3,0.4"
					/>
			</g>
			<g id="SPLINE-16" transform="translate(1589.178 380.978)">
				<path id="Path_717" className="st1" d="M0,0c0.7,0.5,1.4,1,2.2,1.4c0.7,0.4,1.4,0.9,2.1,1.3L6.2,4c0.3,0.2,0.7,0.4,1,0.6"/>
			</g>
			<g id="SPLINE-17" transform="translate(1514.408 220.04)">
				<path id="Path_718" className="st1" d="M30.4,1.6c-0.7-0.2-1.5-0.4-2.2-0.5c-1-0.2-2.1-0.4-3.1-0.5c-0.9-0.1-1.9-0.3-2.8-0.3
					c-0.8-0.1-1.6-0.1-2.5-0.2c-0.7,0-1.4,0-2.1,0c-0.6,0-1.2,0-1.8,0l-1.7,0.1c-0.5,0-0.9,0.1-1.4,0.1c-0.4,0.1-0.9,0.1-1.3,0.2
					c-0.5,0.1-0.9,0.2-1.3,0.3C9.8,0.9,9.3,1,8.9,1.1C8.3,1.3,7.7,1.5,7.2,1.7c-0.5,0.2-1,0.4-1.4,0.6C5.3,2.5,5,2.7,4.6,2.9
					C4.4,3.1,4.1,3.2,3.8,3.4C3.6,3.6,3.4,3.7,3.1,3.9C2.9,4.1,2.7,4.3,2.4,4.5C2.2,4.8,1.9,5.1,1.7,5.4C1.4,5.8,1.1,6.2,0.9,6.6
					C0.5,7.2,0.3,7.8,0,8.4"/>
			</g>
			<g id="SPLINE-18" transform="translate(1574.823 240.78)">
				<path id="Path_719" className="st1" d="M0.5,7.1c0.1-0.4,0.2-0.9,0.3-1.3c0.1-0.3,0.1-0.7,0.1-1c0-0.3,0-0.5,0-0.8V3.5
					c0-0.1,0-0.3,0-0.4c0-0.2-0.1-0.5-0.1-0.7C0.7,2.2,0.6,1.8,0.5,1.5C0.4,1.2,0.3,0.8,0.2,0.4C0.1,0.3,0,0.1,0,0"/>
			</g>
			<g id="LINE-5" transform="translate(1514.413 236.652)">
				<line id="Line_801" className="st1" x1="0" y1="0" x2="0" y2="0.1"/>
			</g>
			<g id="LINE-6" transform="translate(1574.895 248.678)">
				<line id="Line_802" className="st1" x1="0" y1="0.4" x2="0.2" y2="0"/>
			</g>
			<g id="LINE-7" transform="translate(1571.289 252.321)">
				<line id="Line_803" className="st1" x1="0" y1="1.2" x2="1.3" y2="0"/>
			</g>
			<g id="SPLINE-19" transform="translate(1536.085 274.359)">
				<path id="Path_720" className="st1" d="M0,0c0.3,0,0.6,0.1,1,0.1c0.4,0,0.8,0.1,1.2,0.1l1.3,0c0.5,0,0.9,0,1.4-0.1
					C5.1,0.1,5.3,0,5.5,0"/>
			</g>
			<g id="SPLINE-20" transform="translate(1514.071 234.369)">
				<path id="Path_721" className="st1" d="M0,0c0.5,2.1,1,4.1,1.5,6.2c0.4,1.7,0.8,3.5,1.3,5.2c0.3,1.1,0.5,2.2,0.9,3.3"/>
			</g>
			<g id="SPLINE-21" transform="translate(1613.344 345.342)">
				<path id="Path_722" className="st1" d="M0.1,0.5c0-0.1,0-0.1,0-0.1C0,0.3,0,0.1,0,0"/>
			</g>
			<g id="LINE-8" transform="translate(1615.328 356.451)">
				<line id="Line_804" className="st1" x1="0.1" y1="0.6" x2="0" y2="0"/>
			</g>
			<g id="LINE-9" transform="translate(1613.633 360.852)">
				<line id="Line_805" className="st1" x1="0" y1="0" x2="0.1" y2="0"/>
			</g>
			<g id="SPLINE-22" transform="translate(1605.662 382.421)">
				<path id="Path_723" className="st1" d="M0,1.3C0.4,1.2,0.7,1.1,1,1c0.4-0.1,0.6-0.2,1-0.3C2.6,0.5,3.2,0.2,3.8,0"/>
			</g>
			<g id="SPLINE-23" transform="translate(1596.428 384.909)">
				<path id="Path_724" className="st1" d="M0,0.6c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.3,0,0.4,0c0.4,0,0.8,0,1.2-0.1c0.5-0.1,1-0.1,1.5-0.3
					S4.5,0.1,5.1,0"/>
			</g>
			<g id="LINE-10" transform="translate(1610.134 341.772)">
				<line id="Line_806" className="st1" x1="0.1" y1="0" x2="0" y2="0"/>
			</g>
			<g id="SPLINE-24" transform="translate(1547.555 242.294)">
				<path id="Path_725" className="st1" d="M3.6,4.1L3.6,4.1c0.1-0.2,0.1-0.4,0.1-0.6c0-0.2,0-0.4-0.1-0.5c0-0.2-0.1-0.4-0.2-0.5
					C3.2,2.2,3.1,2.1,3,1.9C2.9,1.8,2.8,1.6,2.6,1.5C2.5,1.4,2.3,1.2,2.2,1.1C2,1,1.8,0.9,1.7,0.8C1.5,0.7,1.4,0.6,1.2,0.5L0.8,0.3
					C0.5,0.2,0.3,0.1,0,0"/>
			</g>
			<g id="SPLINE-25" transform="translate(1542.326 241.97)">
				<path id="Path_726" className="st1" d="M5.2,0.4C4.9,0.3,4.7,0.3,4.4,0.2c-0.1,0-0.2,0-0.3-0.1c-0.2,0-0.4,0-0.5-0.1C3.4,0,3.2,0,3,0
					C2.8,0,2.6,0,2.5,0c-0.2,0-0.4,0-0.5,0.1c-0.2,0-0.3,0.1-0.5,0.1C1.2,0.3,1.1,0.4,0.9,0.5C0.8,0.5,0.7,0.6,0.5,0.8
					C0.4,0.9,0.3,1,0.2,1.2L0,1.6"/>
			</g>
			<g id="LINE-11" transform="translate(1550.657 246.37)">
				<line id="Line_807" className="st1" x1="0" y1="1.6" x2="0.5" y2="0"/>
			</g>
			<g id="LINE-12" transform="translate(1541.929 243.593)">
				<line id="Line_808" className="st1" x1="0.4" y1="0" x2="0" y2="1.4"/>
			</g>
			<g id="LINE-13" transform="translate(1597.438 352.664)">
				<line id="Line_809" className="st1" x1="0" y1="0" x2="0.6" y2="2.9"/>
			</g>
			<g id="SPLINE-26" transform="translate(1595.491 351.23)">
				<path id="Path_727" className="st1" d="M0,0c0.2,0,0.3,0,0.5,0c0.2,0,0.4,0.1,0.6,0.2c0.1,0.1,0.2,0.1,0.3,0.2
					c0.1,0.1,0.2,0.2,0.3,0.3l0.2,0.3c0.1,0.1,0.1,0.3,0.1,0.4"/>
			</g>
			<g id="SPLINE-27" transform="translate(1597.258 355.55)">
				<path id="Path_728" className="st1" d="M0.8,0c0,0.1,0,0.3,0,0.4c0,0.1,0,0.2,0,0.4c0,0.2-0.1,0.4-0.2,0.5C0.5,1.4,0.4,1.5,0.3,1.6
					C0.2,1.7,0.1,1.7,0,1.7"/>
			</g>
			<g id="SPLINE-28" transform="translate(1536.554 235.946)">
				<path id="Path_729" className="st1" d="M3.6,4.1L3.6,4.1c0.1-0.2,0.1-0.4,0.1-0.6c0-0.2,0-0.4-0.1-0.5c0-0.2-0.1-0.4-0.2-0.5
					C3.2,2.2,3.1,2.1,3,1.9C2.9,1.8,2.8,1.6,2.6,1.5C2.5,1.4,2.3,1.2,2.2,1.1C2,1,1.8,0.9,1.7,0.8C1.5,0.7,1.4,0.6,1.2,0.5L0.8,0.3
					C0.5,0.2,0.3,0.1,0,0"/>
			</g>
			<g id="SPLINE-29" transform="translate(1531.325 235.622)">
				<path id="Path_730" className="st1" d="M5.2,0.4C4.9,0.3,4.7,0.3,4.4,0.2c-0.1,0-0.2,0-0.3-0.1c-0.2,0-0.4,0-0.5-0.1C3.4,0,3.2,0,3,0
					C2.8,0,2.6,0,2.5,0c-0.2,0-0.4,0-0.5,0.1c-0.2,0-0.3,0.1-0.5,0.1C1.2,0.3,1.1,0.4,0.9,0.5C0.8,0.5,0.7,0.6,0.5,0.8
					C0.4,0.9,0.3,1,0.2,1.2L0,1.6"/>
			</g>
			<g id="LINE-14" transform="translate(1539.656 240.022)">
				<line id="Line_810" className="st1" x1="0" y1="1.4" x2="0.5" y2="0"/>
			</g>
			<g id="LINE-15" transform="translate(1530.783 237.245)">
				<line id="Line_811" className="st1" x1="0.6" y1="0" x2="0" y2="1.8"/>
			</g>
			<g id="SPLINE-30" transform="translate(1556.609 246.607)">
				<path id="Path_731" className="st1" d="M4.2,3.2c0-0.1,0-0.1,0.1-0.2c0-0.1,0-0.2,0-0.4c0-0.2-0.1-0.4-0.2-0.6
					C3.9,1.8,3.7,1.5,3.5,1.2C3.3,1.1,3.2,1,3.1,0.9C2.8,0.8,2.6,0.6,2.4,0.5C2,0.3,1.7,0.2,1.3,0.1C1.1,0,0.9,0,0.7,0
					C0.5,0,0.2,0,0,0"/>
			</g>
			<g id="LINE-16" transform="translate(1560.792 249.869)">
				<line id="Line_812" className="st1" x1="0" y1="0" x2="0" y2="0"/>
			</g>
			<g id="LINE-17" transform="translate(1555.13 247.488)">
				<line id="Line_813" className="st1" x1="0" y1="0" x2="0" y2="0.1"/>
			</g>
			<g id="SPLINE-31" transform="translate(1555.13 246.586)">
				<path id="Path_732" className="st1" d="M1.6,0C1.4,0,1.2,0.1,1,0.1c-0.2,0-0.3,0.1-0.5,0.2C0.4,0.4,0.3,0.5,0.2,0.6
					C0.1,0.7,0.1,0.8,0,0.9"/>
			</g>
			<g id="SPLINE-32" transform="translate(1520.756 254.414)">
				<path id="Path_733" className="st1" d="M0,0c0.2,0.3,0.4,0.5,0.7,0.8C0.9,1,1.1,1.2,1.4,1.5C1.6,1.8,1.8,2,2.1,2.3L2.7,3
					c0.2,0.3,0.4,0.5,0.6,0.7C3.5,4,3.7,4.2,3.9,4.4c0.3,0.4,0.6,0.8,0.9,1.1c0.3,0.3,0.5,0.7,0.7,1C5.7,7,6,7.4,6.2,7.8
					C6.5,8.3,6.8,8.7,7,9.2c0.3,0.5,0.5,1,0.7,1.6"/>
			</g>
			<g id="SPLINE-33" transform="translate(1526.852 270.933)">
				<path id="Path_734" className="st1" d="M0,0c0.3,0.1,0.6,0.2,1,0.3c0.6,0.1,1.1,0.2,1.7,0.3c0.6,0.1,1.2,0.1,1.7,0.1h0.6"/>
			</g>
			<g id="SPLINE-34" transform="translate(1522.524 256.361)">
				<path id="Path_735" className="st1" d="M0,0c0.1,0.5,0.3,1,0.4,1.5C0.7,2.3,0.9,3.2,1.1,4c0.1,0.7,0.3,1.3,0.4,2
					c0.1,0.5,0.2,1,0.3,1.5c0,0.3,0.1,0.5,0.1,0.8C2,8.4,2,8.6,2,8.8c0,0.3,0.1,0.5,0.1,0.7c0,0.3,0.1,0.6,0.1,1
					c0.1,0.4,0.1,0.9,0.1,1.3c0,0.1,0,0.3,0,0.5"/>
			</g>
			<g id="SPLINE-35" transform="translate(1525.049 268.588)">
				<path id="Path_736" className="st1" d="M0,0c0.1,0.4,0.2,0.7,0.3,1c0.1,0.3,0.3,0.6,0.6,0.8C1,2,1.3,2.2,1.5,2.3
					c0.1,0,0.2,0.1,0.3,0.1"/>
			</g>
			<g id="SPLINE-36" transform="translate(1528.475 265.126)">
				<path id="Path_737" className="st1" d="M0,0c0.4,0.9,0.8,1.8,1.2,2.6C1.5,3.3,1.8,4,2.2,4.7c0.3,0.5,0.6,1,0.9,1.4
					c0.3,0.3,0.5,0.6,0.8,0.9c0.1,0.1,0.3,0.3,0.4,0.4l0.3,0.3C4.8,7.9,4.9,8,5.1,8.1l0.6,0.4C6,8.7,6.3,8.9,6.6,9
					C7,9.1,7.3,9.2,7.7,9.3"/>
			</g>
			<g id="SPLINE-37" transform="translate(1517.943 249.616)">
				<path id="Path_738" className="st1" d="M0,0c0,0,0,0.1,0,0.1c0.1,0.4,0.3,0.7,0.4,1.1L1,2.3C1.2,2.7,1.4,3,1.7,3.4
					c0.3,0.4,0.5,0.7,0.8,1.1c0.1,0.1,0.2,0.2,0.3,0.4"/>
			</g>
			<g id="SPLINE-38" transform="translate(1578.827 217.912)">
				<path id="Path_739" className="st1" d="M0,16.6c1.3-0.8,2.6-1.5,3.9-2.3c1.2-0.7,2.5-1.4,3.7-2.1l3.1-1.7c0.9-0.5,1.7-0.9,2.6-1.4
					C14,8.7,14.7,8.3,15.4,8c0.3-0.1,0.6-0.3,0.9-0.5c0.3-0.1,0.5-0.3,0.8-0.4c0.2-0.1,0.4-0.2,0.6-0.3c0.3-0.1,0.5-0.3,0.7-0.4
					C18.7,6.2,19,6,19.4,5.8c0.5-0.3,0.9-0.5,1.4-0.8c0.6-0.3,1.2-0.6,1.8-1c0.8-0.4,1.5-0.8,2.2-1.2c0.9-0.5,1.8-0.9,2.7-1.4
					c1-0.5,1.9-1,3-1.5"/>
			</g>
			<g id="SPLINE-39" transform="translate(1555.599 221.591)">
				<path id="Path_740" className="st1" d="M0,7.8c0,0,0.1,0,0.1,0c0.2,0,0.5,0.1,0.7,0.1C1.1,8,1.3,8,1.5,8C1.8,8,2,8,2.2,8
					c0.2,0,0.5,0,0.7,0c0.2,0,0.5,0,0.7-0.1S4,7.8,4.2,7.8c0.2-0.1,0.4-0.1,0.6-0.2C5,7.5,5.2,7.4,5.4,7.3C5.5,7.2,5.7,7,5.8,6.9
					C6,6.7,6.1,6.6,6.2,6.4c0.1-0.2,0.2-0.4,0.3-0.5c0.1-0.2,0.1-0.4,0.1-0.6c0-0.2,0-0.4,0-0.6c0-0.2-0.1-0.4-0.2-0.6
					C6.2,3.6,6,3.2,5.7,2.8C5.5,2.6,5.3,2.4,5.2,2.3C5,2.1,4.8,1.9,4.6,1.8C4.4,1.6,4.2,1.5,4,1.3S3.5,1,3.3,0.9
					C3.1,0.8,2.9,0.7,2.7,0.6C2.5,0.5,2.3,0.5,2.1,0.4C1.8,0.2,1.5,0.1,1.1,0"/>
			</g>
			<g id="LINE-18" transform="translate(1552.244 228.191)">
				<line id="Line_814" className="st1" x1="0" y1="0" x2="0.6" y2="0.3"/>
			</g>
			<g id="LINE-19" transform="translate(1555.851 229.454)">
				<line id="Line_815" className="st1" x1="0" y1="0" x2="0.6" y2="0.1"/>
			</g>
			<g id="LINE-20" transform="translate(1586.437 193.674)">
				<line id="Line_816" className="st1" x1="0.8" y1="0" x2="0" y2="0.7"/>
			</g>
			<g id="SPLINE-40" transform="translate(1583.768 194.179)">
				<path id="Path_741" className="st1" d="M2.9,0c0,0-0.1,0.1-0.1,0.1C2.4,0.3,2.1,0.6,1.9,0.9C1.6,1.3,1.3,1.7,1,2.1
					c-0.3,0.5-0.5,1-0.7,1.6C0.1,4.3,0,4.9,0,5.6c0,0.3,0,0.7,0,1c0,0.4,0.1,0.7,0.2,1c0.1,0.4,0.3,0.7,0.4,1c0.2,0.3,0.4,0.7,0.6,1
					c0.2,0.3,0.5,0.7,0.8,0.9l0.8,0.8"/>
			</g>
			<g id="SPLINE-41" transform="translate(1589.467 190.428)">
				<path id="Path_742" className="st1" d="M5,0C4.4,0.2,3.7,0.4,3.1,0.6C2.1,1,1,1.4,0,1.9"/>
			</g>
			<g id="LINE-21" transform="translate(1557.438 229.598)">
				<line id="Line_817" className="st1" x1="0" y1="1.8" x2="0.5" y2="0"/>
			</g>
			<g id="LINE-22" transform="translate(1550.477 227.398)">
				<line id="Line_818" className="st1" x1="0.5" y1="0" x2="0" y2="1.6"/>
			</g>
			<g id="SPLINE-42" transform="translate(1574.376 234.504)">
				<path id="Path_743" className="st1" d="M0.4,6.3C0.3,6,0.2,5.7,0.1,5.4C0,5.1,0,4.8,0,4.5c0-0.3,0.1-0.6,0.3-0.8
					C0.4,3.5,0.5,3.2,0.7,3C0.9,2.8,1,2.5,1.2,2.3C1.5,2.1,1.7,1.8,2,1.6C2.4,1.3,2.7,1,3.1,0.8C3.5,0.5,4,0.3,4.4,0"/>
			</g>
			<g id="SPLINE-43" transform="translate(1563.462 210.734)">
				<path id="Path_744" className="st1" d="M28.8,0c-1,0.4-1.9,0.7-2.9,1.1c-1,0.4-2.1,0.8-3.1,1.1c-0.9,0.3-1.7,0.6-2.6,0.9
					c-0.8,0.3-1.6,0.5-2.3,0.8c-0.8,0.3-1.5,0.5-2.3,0.8c-0.5,0.2-1,0.4-1.6,0.5c-0.5,0.2-1,0.4-1.6,0.5c-0.6,0.2-1.2,0.4-1.8,0.6
					C9.9,6.6,9.1,6.9,8.4,7.1L5.8,8c-1,0.3-2,0.6-3,1C1.9,9.3,0.9,9.6,0,9.9"/>
			</g>
			<g id="SPLINE-44" transform="translate(1595.274 190.031)">
				<path id="Path_745" className="st1" d="M10.6,4.5C9.8,3.7,9.1,3.1,8.2,2.4C7.8,2,7.3,1.7,6.9,1.4c-0.5-0.3-1-0.6-1.6-0.8
					C4.7,0.5,4.1,0.3,3.5,0.2C2.9,0.1,2.3,0,1.8,0c-0.5,0-1,0-1.6,0.1c-0.1,0-0.2,0-0.2,0.1"/>
			</g>
			<g id="SPLINE-45" transform="translate(1558.051 220.581)">
				<path id="Path_746" className="st1" d="M5.5,0C4.5,0.3,3.6,0.6,2.6,0.9C1.8,1.1,1,1.3,0.1,1.4H0"/>
			</g>
			<g id="SPLINE-46" transform="translate(1544.742 221.627)">
				<path id="Path_747" className="st1" d="M4.7,0.7C4,0.6,3.4,0.6,2.7,0.5C1.8,0.4,0.9,0.2,0,0"/>
			</g>
			<g id="LINE-23" transform="translate(1609.088 217.984)">
				<line id="Line_819" className="st1" x1="0" y1="0" x2="2.6" y2="0"/>
			</g>
			<g id="LINE-24" transform="translate(1613.994 216.433)">
				<line id="Line_820" className="st1" x1="0" y1="0.1" x2="0" y2="0"/>
			</g>
			<g id="LINE-25" transform="translate(1592.569 209.039)">
				<line id="Line_821" className="st1" x1="0" y1="0" x2="0" y2="0.1"/>
			</g>
			<g id="LINE-26" transform="translate(1592.208 209.219)">
				<line id="Line_822" className="st1" x1="0.4" y1="0" x2="0" y2="1.6"/>
			</g>
			<g id="LINE-27" transform="translate(1601.153 384.874)">
				<line id="Line_823" className="st1" x1="0" y1="0.1" x2="0.4" y2="0"/>
			</g>
			<g id="LINE-28" transform="translate(1605.59 383.647)">
				<line id="Line_824" className="st1" x1="0" y1="0.1" x2="0.4" y2="0"/>
			</g>
			<g id="SPLINE-47" transform="translate(1637.222 347.29)">
				<path id="Path_748" className="st1" d="M0,5.3L0,5.3C0.8,3.6,1.5,1.8,2.2,0"/>
			</g>
			<g id="LINE-29" transform="translate(1608.728 197.425)">
				<line id="Line_825" className="st1" x1="0.6" y1="0.6" x2="0" y2="0"/>
			</g>
			<g id="SPLINE-48" transform="translate(1609.665 373.007)">
				<path id="Path_749" className="st1" d="M4.2,0C4.1,0.3,3.9,0.7,3.8,1S3.5,1.7,3.4,1.9S3.1,2.5,3,2.8C2.9,3.1,2.7,3.4,2.6,3.7
					C2.5,3.9,2.4,4.2,2.3,4.4C2.2,4.7,2,4.9,1.9,5.2C1.8,5.4,1.7,5.6,1.7,5.8C1.5,6,1.5,6.2,1.4,6.4C1.3,6.6,1.2,6.7,1.1,6.9
					C1,7.1,1,7.2,0.9,7.4L0.6,7.8C0.6,7.9,0.5,8.1,0.5,8.2c0,0.1-0.1,0.2-0.1,0.3c0,0.1-0.1,0.2-0.1,0.3L0.1,9C0,9,0,9.1,0,9.1"/>
			</g>
			<g id="LINE-30" transform="translate(1613.849 372.682)">
				<line id="Line_826" className="st1" x1="0" y1="0" x2="0" y2="0"/>
			</g>
			<g id="LINE-31" transform="translate(1612.876 371.384)">
				<line id="Line_827" className="st1" x1="0" y1="0" x2="1" y2="1.3"/>
			</g>
			<g id="SPLINE-49" transform="translate(1609.521 201.032)">
				<path id="Path_750" className="st1" d="M3.4,170.4c2.6-1,5.2-2.3,7.5-3.9c2.5-1.7,4.8-3.7,6.8-5.8c2.2-2.4,4.2-4.9,6-7.6
					c1.9-2.9,3.6-6,5-9.2c1.6-3.4,2.9-7,4-10.6c1.2-3.9,2.1-7.8,2.8-11.8c0.8-4.2,1.3-8.4,1.6-12.7c0.3-4.4,0.4-8.8,0.4-13.3
					s-0.4-9.1-0.9-13.7c-0.5-4.6-1.2-9.2-2.1-13.7c-0.9-4.6-2-9.1-3.3-13.5c-1.3-4.4-2.8-8.8-4.4-13s-3.5-8.3-5.4-12.2
					s-4.1-7.6-6.3-11.1c-2.2-3.4-4.6-6.7-7.1-9.8C5.4,5.4,2.8,2.6,0,0"/>
			</g>
			<g id="ARC" transform="translate(1612.587 370.987)">
				<path id="Path_751" className="st1" d="M0.3,0.4C0.2,0.2,0.1,0.1,0,0"/>
			</g>
			<g id="SPLINE-50" transform="translate(1586.762 205.793)">
				<path id="Path_752" className="st1" d="M0,0l0.1,0.1"/>
			</g>
			<g id="SPLINE-51" transform="translate(1612.479 371.023)">
				<path id="Path_753" className="st1" d="M0,0c0,0,0.1,0,0.1,0"/>
			</g>
			<g id="SPLINE-52" transform="translate(1586.87 205.901)">
				<path id="Path_754" className="st1" d="M0,0c1.3,1.3,2.6,2.5,3.9,3.9C4.3,4.3,4.6,4.7,4.9,5"/>
			</g>
			<g id="LINE-32" transform="translate(1600.648 222.421)">
				<line id="Line_828" className="st1" x1="0" y1="0" x2="1" y2="1.5"/>
			</g>
			<g id="SPLINE-53" transform="translate(1614.535 331.492)">
				<path id="Path_755" className="st1" d="M6.7,0C6.6,0.4,6.5,0.9,6.4,1.3C6,3.2,5.4,5.1,4.9,7C4.3,8.8,3.7,10.7,3,12.4
					c-0.6,1.7-1.3,3.5-2.1,5.1c-0.3,0.6-0.6,1.2-0.9,1.8"/>
			</g>
			<g id="SPLINE-54" transform="translate(1597.727 367.055)">
				<path id="Path_756" className="st1" d="M17.3,0c-0.3,0.1-0.5,0.3-0.9,0.5c-0.4,0.2-0.7,0.3-1.1,0.4c-0.4,0.1-0.8,0.2-1.2,0.3
					c-0.5,0.1-0.9,0.1-1.4,0.2l-1.3,0.1c-0.5,0-0.9,0.1-1.4,0.1c-0.5,0-1,0.1-1.5,0.1L7,1.8c-0.6,0-1.2,0.1-1.7,0.1
					C4.7,2,4.1,2.1,3.6,2.1C3,2.2,2.4,2.3,1.9,2.5c-0.5,0.1-1,0.3-1.5,0.4C0.3,3,0.1,3,0,3.1"/>
			</g>
			<g id="SPLINE-55" transform="translate(1615.004 363.99)">
				<path id="Path_757" className="st1" d="M1.7,0c0,0.1,0,0.2,0,0.3c0,0.3,0,0.5-0.1,0.8C1.5,1.4,1.4,1.6,1.2,1.9
					C0.9,2.2,0.7,2.5,0.4,2.7C0.2,2.8,0.1,2.9,0,3"/>
			</g>
			<g id="SPLINE-56" transform="translate(1595.887 209.436)">
				<path id="Path_758" className="st1" d="M0,0c2.5,0.9,5.1,1.7,7.7,2.4c2.6,0.7,5.2,1.4,7.9,2"/>
			</g>
			<g id="SPLINE-57" transform="translate(1592.641 208.723)">
				<path id="Path_759" className="st1" d="M0,0.3c0-0.1,0-0.1,0-0.1c0-0.1,0.2-0.1,0.3-0.1c0.2,0,0.4,0,0.5,0c0.2,0,0.4,0.1,0.6,0.1
					c0.3,0.1,0.5,0.1,0.8,0.3S3,0.6,3.2,0.7"/>
			</g>
			<g id="SPLINE-58" transform="translate(1611.469 213.836)">
				<path id="Path_760" className="st1" d="M0,0c0.4,0.1,0.8,0.2,1.2,0.3c0.3,0.1,0.5,0.2,0.7,0.4C2.1,0.8,2.3,1,2.4,1.2
					c0.1,0.2,0.2,0.3,0.2,0.5c0.1,0.2,0.1,0.4,0,0.6c0,0.1,0,0.1-0.1,0.2"/>
			</g>
			<g id="ARC-2" transform="translate(1613.885 372.646)">
				<path id="Path_761" className="st1" d="M0,0.4C0,0.2,0,0.1,0,0"/>
			</g>
			<g id="LINE-33" transform="translate(1605.842 194.503)">
				<line id="Line_829" className="st1" x1="0" y1="0" x2="0.1" y2="0.1"/>
			</g>
			<g id="ARC-3" transform="translate(1586.798 205.829)">
				<path id="Path_762" className="st1" d="M0,0C0,0,0,0.1,0,0"/>
			</g>
			<g id="SPLINE-59" transform="translate(1542.888 264.224)">
				<path id="Path_763" className="st1" d="M21.7,6.1c-0.6-0.5-1.2-1.1-1.8-1.6C19.3,4,18.7,3.5,18,3c-0.7-0.5-1.3-0.9-2-1.3
					c-0.7-0.4-1.4-0.7-2.2-1c-0.7-0.3-1.5-0.5-2.3-0.6c-0.4-0.1-0.8-0.1-1.2-0.1S9.7,0,9.3,0C8.6,0,7.9,0.1,7.2,0.2
					C6.5,0.4,5.9,0.6,5.3,0.8C4.2,1.3,3.2,2,2.4,2.8C1.7,3.6,1.1,4.4,0.7,5.4C0.3,6.2,0.1,7,0,7.9c0,0.4,0,0.8,0,1.2
					c0,0.3,0.1,0.7,0.3,1"/>
			</g>
			<g id="SPLINE-60" transform="translate(1543.227 274.323)">
				<path id="Path_764" className="st1" d="M0,0c0,0.1,0.1,0.3,0.1,0.4c0.1,0.1,0.1,0.2,0.2,0.3C0.4,0.8,0.5,0.9,0.6,1
					C0.7,1.1,0.8,1.3,1,1.3c0.1,0.1,0.3,0.1,0.4,0.2l0,0"/>
			</g>
			<g id="SPLINE-61" transform="translate(1538.646 254.414)">
				<path id="Path_765" className="st1" d="M2.1,19.5c-0.2-0.1-0.3-0.1-0.4-0.2C1.4,19.2,1.2,19,1,18.8c-0.2-0.2-0.4-0.5-0.5-0.8
					c-0.1-0.3-0.2-0.6-0.3-0.9c-0.1-0.3-0.1-0.7-0.1-1c0-0.4,0-0.8,0.1-1.1c0.1-0.2,0.1-0.4,0.2-0.7c0.1-0.3,0.2-0.5,0.4-0.8
					c0.2-0.3,0.3-0.6,0.5-0.9c0.3-0.5,0.7-0.9,1.1-1.4c0.4-0.5,0.9-0.9,1.4-1.4c0.3-0.3,0.7-0.5,1-0.8C5.2,8.9,5.6,8.6,6,8.4
					C6.3,8.2,6.6,8,7,7.8C7.5,7.5,8,7.3,8.5,7C9,6.8,9.5,6.6,10,6.4c0.5-0.2,0.9-0.3,1.4-0.5c0.5-0.1,1-0.3,1.6-0.5s1-0.3,1.6-0.4
					c0.6-0.1,1.1-0.3,1.7-0.4c0.6-0.1,1.2-0.3,1.8-0.4c0.6-0.1,1.3-0.3,1.9-0.4c0.7-0.1,1.3-0.3,2-0.4c0.7-0.1,1.4-0.3,2.1-0.5
					c0.7-0.2,1.3-0.4,2-0.6c0.7-0.2,1.4-0.4,2-0.7c0.4-0.1,0.8-0.3,1.1-0.5c0.4-0.2,0.8-0.4,1.1-0.5c0.4-0.2,0.8-0.4,1.1-0.6"/>
			</g>
			<g id="SPLINE-62" transform="translate(1584.49 341.627)">
				<path id="Path_766" className="st1" d="M0.1,2.6C0.1,2.6,0,2.6,0.1,2.6C0,2.5,0,2.5,0,2.5c0,0,0-0.1,0-0.1s0.1-0.1,0.1-0.2
					C0.2,2,0.3,2,0.3,1.9l0.3-0.3C0.8,1.5,1,1.3,1.2,1.1C1.4,1,1.5,0.9,1.6,0.8c0.2-0.1,0.3-0.2,0.5-0.3C2.3,0.4,2.6,0.2,2.9,0"/>
			</g>
			<g id="SPLINE-63" transform="translate(1587.375 326.334)">
				<path id="Path_767" className="st1" d="M0,15.3c0.5-0.3,1-0.6,1.5-0.9c0.6-0.3,1.1-0.7,1.7-1.2c0.6-0.5,1.2-0.9,1.7-1.5
					c0.6-0.6,1.1-1.2,1.5-1.9c0.5-0.7,0.8-1.5,1.1-2.3C7.8,6.7,7.9,5.9,8,5c0-0.4,0-0.9,0-1.3c0-0.4-0.1-0.9-0.1-1.3
					C7.8,2.1,7.6,1.7,7.5,1.2C7.4,0.8,7.3,0.4,7.2,0"/>
			</g>
			<g id="SPLINE-64" transform="translate(1564.616 270.355)">
				<path id="Path_768" className="st1" d="M29.9,56c-0.4-1.3-0.8-2.6-1.2-3.8c-0.4-1.3-0.8-2.6-1.2-3.8s-0.8-2.6-1.3-3.8
					c-0.4-1.3-0.9-2.5-1.4-3.8c-0.9-2.5-1.9-5-3.1-7.4c-1.1-2.5-2.2-4.9-3.5-7.3c-1.2-2.4-2.5-4.7-3.9-7c-1.4-2.3-2.8-4.6-4.3-6.8
					C8.6,10,7.1,7.9,5.4,5.8C3.7,3.8,1.9,1.8,0,0"/>
			</g>
			<g id="SPLINE-65" transform="translate(1598.123 352.592)">
				<path id="Path_769" className="st1" d="M0.6,2.9C0.4,1.9,0.2,1,0,0"/>
			</g>
			<g id="SPLINE-66" transform="translate(1593.182 350.284)">
				<path id="Path_770" className="st1" d="M4.9,2.3c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0-0.1-0.1-0.1s0-0.1-0.1-0.1
					c0,0,0-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1C4.4,1.2,4.3,1,4.2,0.9C4.1,0.8,3.9,0.7,3.8,0.5C3.6,0.4,3.4,0.3,3.1,0.2
					C3,0.1,2.9,0.1,2.7,0.1C2.5,0,2.3,0,2.1,0C2,0,1.8,0,1.6,0.1c-0.2,0-0.3,0.1-0.5,0.1C1,0.3,0.9,0.4,0.8,0.5
					C0.7,0.6,0.6,0.6,0.5,0.8C0.4,0.9,0.3,1,0.2,1.2c0,0.1-0.1,0.2-0.1,0.3L0,2l0,0.5c0,0.1,0,0.1,0,0.2s0,0.1,0,0.2"/>
			</g>
			<g id="SPLINE-67" transform="translate(1593.326 353.349)">
				<path id="Path_771" className="st1" d="M0,0c0.2,1,0.5,1.9,0.7,2.9"/>
			</g>
			<g id="SPLINE-68" transform="translate(1594.012 355.586)">
				<path id="Path_772" className="st1" d="M0,0.6c0,0,0,0.1,0,0.1s0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0.1,0.1s0,0.1,0.1,0.1
					s0,0.1,0.1,0.1c0,0,0,0.1,0.1,0.1c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.2,0.2,0.3,0.4,0.4c0.2,0.1,0.4,0.3,0.6,0.4L2,2.9
					C2.2,3,2.3,3,2.5,3C2.6,3,2.8,3,3,2.9c0.2,0,0.3-0.1,0.5-0.2c0.2-0.1,0.3-0.2,0.4-0.3C4,2.3,4.1,2.2,4.3,2.1l0.2-0.3
					c0.1-0.1,0.1-0.3,0.2-0.4c0-0.1,0.1-0.3,0.1-0.4c0-0.1,0-0.2,0-0.3V0.3c0-0.1,0-0.2,0-0.3"/>
			</g>
			<g id="LINE-34" transform="translate(1609.99 341.808)">
				<line id="Line_830" className="st1" x1="0.1" y1="0" x2="0" y2="0"/>
			</g>
			<g id="SPLINE-69" transform="translate(1569.99 254.414)">
				<path id="Path_773" className="st1" d="M0.1,0C0.1,0,0,0,0,0.1"/>
			</g>
			<g id="SPLINE-70" transform="translate(1570.098 253.512)">
				<path id="Path_774" className="st1" d="M0,0.9c0.2-0.1,0.4-0.3,0.6-0.5C0.8,0.3,1,0.2,1.2,0l0,0"/>
			</g>
			<g id="SPLINE-71" transform="translate(1584.332 341.158)">
				<path id="Path_775" className="st1" d="M0.3,2.7H0.2C0,2.7,0,2.6,0,2.5c0-0.1,0.1-0.3,0.2-0.4c0.2-0.2,0.3-0.4,0.5-0.5
					c0.3-0.2,0.5-0.5,0.9-0.7C1.9,0.6,2.4,0.3,2.8,0"/>
			</g>
			<g id="SPLINE-72" transform="translate(1543.624 274.576)">
				<path id="Path_776" className="st1" d="M0,0c0,0.1,0.1,0.3,0.1,0.4c0.1,0.1,0.1,0.2,0.2,0.3S0.5,0.9,0.6,1C0.7,1.1,0.8,1.3,1,1.3
					c0,0,0.1,0,0.1,0.1"/>
			</g>
			<g id="SPLINE-73" transform="translate(1543.299 264.75)">
				<path id="Path_777" className="st1" d="M0.3,9.8c0,0,0-0.1-0.1-0.1c0-0.1,0-0.1-0.1-0.2c0-0.1,0-0.1,0-0.2c0-0.1-0.1-0.2-0.1-0.4
					c0-0.1,0-0.2,0-0.3c0-0.3,0-0.5,0-0.8c0-0.2,0-0.5,0.1-0.7c0.1-0.5,0.2-1.1,0.4-1.6c0.2-0.5,0.5-1.1,0.8-1.6
					c0.3-0.5,0.7-0.9,1-1.3C2.7,2.3,3.1,2,3.6,1.6C4,1.3,4.5,1.1,4.9,0.9c0.5-0.2,0.9-0.4,1.4-0.5C6.9,0.2,7.4,0.1,8,0.1
					C8.5,0,9.1,0,9.7,0c0.6,0,1.1,0.1,1.7,0.2c0.6,0.1,1.2,0.3,1.7,0.5c0.4,0.1,0.7,0.3,1,0.4s0.7,0.3,1,0.5c0.4,0.2,0.7,0.4,1,0.6
					c0.4,0.2,0.7,0.5,1.1,0.7c0.3,0.2,0.6,0.4,0.9,0.6c0.3,0.3,0.6,0.5,0.9,0.8C19.5,4.6,19.7,4.8,20,5c0.3,0.3,0.6,0.6,1,0.9"/>
			</g>
			<g id="SPLINE-74" transform="translate(1564.219 270.716)">
				<path id="Path_778" className="st1" d="M0,0c0.2,0.1,0.3,0.3,0.5,0.5C0.7,0.6,0.8,0.8,1,1l0.5,0.5c0.2,0.2,0.4,0.4,0.5,0.6
					c0.2,0.2,0.4,0.4,0.5,0.6C2.8,2.9,3,3.1,3.2,3.3c0.2,0.2,0.4,0.4,0.6,0.6s0.4,0.4,0.6,0.6C4.7,5,5,5.4,5.4,5.8
					c0.4,0.5,0.8,1,1.2,1.5s0.8,1,1.2,1.5c0.7,1,1.4,1.9,2.1,3c1.2,1.7,2.3,3.4,3.4,5.2c0.7,1.2,1.4,2.3,2.1,3.5
					c0.8,1.4,1.6,2.7,2.3,4.1c0.9,1.6,1.7,3.2,2.5,4.9c1.6,3.2,3,6.6,4.3,10c0.6,1.7,1.3,3.4,1.8,5c0.4,1,0.7,2.1,1.1,3.2l0.5,1.6
					l0.4,1.4c0.3,0.9,0.6,1.8,0.9,2.8c0.3,0.8,0.5,1.6,0.8,2.3"/>
			</g>
			<g id="SPLINE-75" transform="translate(1587.195 326.514)">
				<path id="Path_779" className="st1" d="M6.9,0l0.2,0.6C7.1,0.9,7.2,1,7.2,1.3c0.1,0.4,0.2,0.7,0.3,1c0.1,0.5,0.2,1,0.2,1.6
					c0,0.4,0,0.8,0,1.2c0,0.4-0.1,0.8-0.2,1.2C7.3,6.9,7.1,7.6,6.8,8.2C6.6,8.6,6.3,9.1,6.1,9.5c-0.3,0.4-0.6,0.8-0.9,1.2
					c-0.4,0.4-0.8,0.9-1.2,1.2c-0.4,0.4-0.9,0.7-1.3,1c-0.2,0.1-0.4,0.3-0.6,0.5c-0.3,0.2-0.5,0.3-0.8,0.5C1.2,14,1.1,14.1,1,14.1
					c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2,0.1-0.3,0.1"/>
			</g>
			<g id="SPLINE-76" transform="translate(1612.767 371.384)">
				<path id="Path_780" className="st1" d="M0.1,0C0.1,0,0,0,0,0"/>
			</g>
			<g id="ARC-4" transform="translate(1564.219 270.356)">
				<path id="Path_781" className="st1" d="M0,0.4C0.2,0.3,0.3,0.2,0.4,0"/>
			</g>
			<g id="ARC-5" transform="translate(1594.048 326.334)">
				<path id="Path_782" className="st1" d="M0.5,0C0.3,0,0.2,0.1,0,0.1"/>
			</g>
			<g id="SPLINE-77" transform="translate(1612.479 371.059)">
				<path id="Path_783" className="st1" d="M0.3,0.4c0-0.1-0.1-0.2-0.1-0.3C0.1,0.1,0.1,0,0,0"/>
			</g>
			<g id="SPLINE-78" transform="translate(1613.849 372.682)">
				<path id="Path_784" className="st1" d="M0,0c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2"/>
			</g>
			<g id="SPLINE-79" transform="translate(1613.813 373.007)">
				<path id="Path_785" className="st1" d="M0.1,0C0,0,0,0,0.1,0"/>
			</g>
			<g id="SPLINE-80" transform="translate(1541.898 244.999)">
				<path id="Path_786" className="st1" d="M8.1,3.7C8,3.8,7.8,4,7.6,4C7.4,4.1,7.1,4.2,6.9,4.3c-0.3,0-0.5,0.1-0.8,0.1
					c-0.3,0-0.6,0-0.8,0C5,4.3,4.7,4.2,4.4,4.2C4.1,4.1,3.9,4,3.5,3.9C3.2,3.8,2.9,3.7,2.7,3.6C2.4,3.4,2.1,3.3,1.9,3.1
					c-0.4-0.3-0.8-0.6-1.2-1C0.5,2,0.4,1.8,0.3,1.5C0.2,1.4,0.1,1.1,0,0.9c0-0.3,0-0.6,0-0.9"/>
			</g>
			<g id="SPLINE-81" transform="translate(1550.044 247.921)">
				<path id="Path_787" className="st1" d="M0.6,0L0.6,0c0,0.1,0,0.2-0.1,0.2c0,0.1-0.1,0.1-0.1,0.2C0.3,0.5,0.1,0.7,0,0.8"/>
			</g>
			<g id="SPLINE-82" transform="translate(1555.274 248.787)">
				<path id="Path_788" className="st1" d="M5.5,1.1L5.5,1.1c0,0.1-0.1,0.2-0.2,0.3C5.3,1.5,5.2,1.6,5,1.7C4.9,1.8,4.8,1.8,4.6,1.9
					C4.5,1.9,4.3,1.9,4.2,2C4,2,3.8,2,3.6,2C3.4,2,3.3,2,3.1,1.9c-0.2,0-0.4-0.1-0.6-0.2C2.2,1.7,2,1.6,1.8,1.5
					C1.6,1.4,1.4,1.3,1.3,1.2C1.1,1.1,0.9,0.9,0.7,0.8c0,0,0,0,0,0c0,0,0,0,0,0l0,0c-0.1,0-0.1-0.1-0.2-0.1C0.3,0.4,0.1,0.2,0,0"/>
			</g>
			<g id="SPLINE-83" transform="translate(1555.058 247.416)">
				<path id="Path_789" className="st1" d="M0.3,1.3C0.1,1.1,0,0.8,0,0.6C0,0.4,0.1,0.2,0.1,0"/>
			</g>
			<g id="SPLINE-84" transform="translate(1530.652 239.084)">
				<path id="Path_790" className="st1" d="M8.5,3.2C8.1,3.4,7.7,3.6,7.3,3.7C6.8,3.8,6.2,3.9,5.7,3.9c-0.2,0-0.3,0-0.5,0
					c-0.2,0-0.3,0-0.5-0.1c-0.3,0-0.6-0.1-0.9-0.2C3.6,3.5,3.3,3.4,3,3.4L2.3,3C2,2.9,1.8,2.8,1.6,2.6S1.1,2.3,1,2.2
					C0.8,2,0.6,1.8,0.5,1.7C0.4,1.5,0.2,1.3,0.2,1.1C0.1,1,0.1,0.8,0,0.6c0-0.2,0-0.4,0-0.5c0,0,0,0,0-0.1"/>
			</g>
			<g id="SPLINE-85" transform="translate(1539.115 241.465)">
				<path id="Path_791" className="st1" d="M0.5,0L0.5,0c0,0.1-0.1,0.2-0.1,0.3C0.3,0.5,0.2,0.6,0,0.8"/>
			</g>
			<g id="SPLINE-86" transform="translate(1537.42 230.284)">
				<path id="Path_792" className="st1" d="M0,0.3c0.1,0,0.1,0,0.2-0.1c0.1,0,0.1,0,0.2,0s0.1,0,0.2,0s0.1,0,0.2,0s0.1,0,0.2,0
					c0.1,0,0.1,0,0.2,0C1.4,0,1.6,0,1.7,0L3,0c0.4,0,0.7,0,1.1,0.1c0.4,0,0.9,0.1,1.3,0.2c0.5,0.1,0.9,0.2,1.3,0.3
					C7,0.7,7.3,0.8,7.6,0.9C7.8,0.9,8.1,1,8.4,1.2c0.1,0,0.3,0.1,0.4,0.1c0.1,0,0.3,0.1,0.4,0.1c0.1,0.1,0.2,0.1,0.4,0.1
					c0.1,0,0.2,0.1,0.3,0.1"/>
			</g>
			<g id="SPLINE-87" transform="translate(1539.187 237.461)">
				<path id="Path_793" className="st1" d="M10.6,6c-0.4-0.2-0.8-0.5-1.2-0.7C9.1,5.1,8.7,4.8,8.3,4.6C7.9,4.4,7.5,4.1,7.1,3.9
					S6.3,3.5,6,3.2L4.8,2.6L3.6,1.9L2.4,1.3L1.2,0.6C0.8,0.4,0.4,0.2,0,0"/>
			</g>
			<g id="SPLINE-88" transform="translate(1549.792 243.377)">
				<path id="Path_794" className="st1" d="M11.5,0.6c0,0,0,0.1-0.1,0.1l-0.1,0.1l-0.1,0.1L11.1,1L11,1.2c0,0-0.1,0.1-0.1,0.1
					c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.3,0.1-0.5,0.2S9.6,1.9,9.4,1.9C9.2,2,8.9,2,8.7,2.1c-0.5,0.1-1,0.1-1.4,0.1
					C6.9,2.1,6.4,2.1,6,2C5.6,2,5.2,1.9,4.7,1.8c-0.5-0.1-1-0.3-1.6-0.4L2.5,1.2C2.3,1.1,2.1,1,1.8,0.9C1.7,0.8,1.6,0.8,1.4,0.7
					C1.3,0.6,1.1,0.6,1,0.5C0.9,0.5,0.7,0.4,0.6,0.4S0.4,0.3,0.3,0.2C0.2,0.1,0.1,0.1,0,0"/>
			</g>
			<g id="SPLINE-89" transform="translate(1557.835 238.038)">
				<path id="Path_795" className="st1" d="M0,0c0.1,0,0.1,0.1,0.2,0.1s0.1,0.1,0.2,0.1s0.1,0.1,0.2,0.1s0.1,0.1,0.2,0.1
					c0.1,0,0.1,0.1,0.2,0.1C1,0.6,1,0.7,1.1,0.7C1.3,0.9,1.5,1,1.7,1.2C1.8,1.3,2,1.5,2.2,1.7c0.1,0.1,0.3,0.3,0.4,0.4l0.3,0.4
					C3,2.6,3.1,2.8,3.2,3c0.1,0.1,0.2,0.3,0.3,0.5C3.6,3.6,3.6,3.8,3.7,4c0.1,0.2,0.1,0.4,0.1,0.6v0.3c0,0.1,0,0.2,0,0.3
					c0,0.1,0,0.2-0.1,0.3c0,0.1,0,0.2-0.1,0.3S3.5,5.8,3.5,5.9"/>
			</g>
			<g id="SPLINE-90" transform="translate(1547.195 232.087)">
				<path id="Path_796" className="st1" d="M0,0c0.4,0.2,0.8,0.4,1.2,0.6S2,1,2.4,1.2l1.2,0.6l1.2,0.6L6,3.2c0.4,0.2,0.8,0.4,1.2,0.7
					c0.4,0.2,0.8,0.5,1.2,0.7S9.1,5,9.5,5.2s0.8,0.5,1.2,0.7"/>
			</g>
			<g id="SPLINE-91" transform="translate(1550.426 228.949)">
				<path id="Path_797" className="st1" d="M6.6,2.8C6.5,2.9,6.3,3,6.1,3c-0.2,0-0.3,0-0.5,0c-0.4,0-0.9,0-1.3-0.1C3.9,2.8,3.5,2.7,3,2.6
					C2.6,2.4,2.3,2.2,1.9,2.1c-0.3-0.2-0.7-0.4-1-0.6C0.6,1.3,0.4,1,0.2,0.8C0.2,0.7,0.1,0.5,0.1,0.4C0,0.3,0,0.2,0,0.1
					c0,0,0-0.1,0-0.1"/>
			</g>
			<g id="SPLINE-92" transform="translate(1557.041 231.365)">
				<path id="Path_798" className="st1" d="M0.4,0c0,0,0,0.1,0,0.1c0,0.1-0.1,0.1-0.1,0.1C0.2,0.3,0.1,0.4,0,0.4"/>
			</g>
			<g id="LINE-35" transform="translate(1545.139 221.916)">
				<line id="Line_831" className="st1" x1="0" y1="0" x2="0" y2="0"/>
			</g>
			<g id="SPLINE-93" transform="translate(1545.175 221.916)">
				<path id="Path_799" className="st1" d="M0,0c1,0.3,2.1,0.5,3.1,0.8C3.4,0.9,3.6,1,3.8,1"/>
			</g>
			<g id="SPLINE-94" transform="translate(1561.514 228.336)">
				<path id="Path_800" className="st1" d="M0,0c0.6,0.4,1.3,0.8,2,1.2c0.9,0.6,1.7,1.2,2.6,1.8c0.8,0.6,1.6,1.2,2.3,1.8
					C7.5,5.4,8.2,6,8.8,6.6c0.6,0.6,1.1,1.2,1.6,1.8c0.5,0.6,0.9,1.2,1.2,1.8c0.4,0.6,0.6,1.2,0.9,1.7"/>
			</g>
			<g id="SPLINE-95" transform="translate(1573.958 240.31)">
				<path id="Path_801" className="st1" d="M0,0c0,0.1,0.1,0.2,0.1,0.3"/>
			</g>
			<g id="SPLINE-96" transform="translate(1571.541 247.777)">
				<path id="Path_802" className="st1" d="M0,5c0.5-0.3,0.9-0.7,1.4-1c0.4-0.3,0.8-0.7,1.1-1.2C2.8,2.4,3,2,3.3,1.5
					c0.2-0.4,0.4-0.9,0.5-1.4c0-0.1,0-0.1,0-0.1"/>
			</g>
			<g id="SPLINE-97" transform="translate(1513.976 228.552)">
				<path id="Path_803" className="st1" d="M0.5,0C0.4,0.3,0.3,0.5,0.3,0.7C0.1,1.4,0,2,0,2.7c0,0.7,0.1,1.4,0.3,2.1
					C0.5,5.6,0.8,6.3,1.1,7c0.4,0.8,0.8,1.6,1.3,2.3c0.5,0.8,1.1,1.6,1.8,2.3c0.7,0.8,1.5,1.5,2.3,2.2c0.8,0.8,1.7,1.5,2.7,2.2
					c0.9,0.7,2,1.4,3,2.1c1.1,0.7,2.2,1.3,3.4,1.9c1.2,0.6,2.4,1.2,3.6,1.8c1.3,0.5,2.5,1.1,3.8,1.6s2.6,0.9,4,1.3s2.7,0.8,4,1.1
					c1.3,0.3,2.7,0.6,4,0.8c1.3,0.2,2.6,0.4,3.9,0.5s2.6,0.2,3.8,0.3c1.2,0,2.5,0,3.6-0.1c1.1-0.1,2.2-0.2,3.4-0.4
					c1-0.2,2.1-0.4,3-0.6c0.9-0.2,1.8-0.6,2.6-0.9c0.8-0.4,1.5-0.8,2.2-1.2"/>
			</g>
			<g id="LINE-36" transform="translate(1571.505 252.79)">
				<line id="Line_832" className="st1" x1="0" y1="0.1" x2="0" y2="0"/>
			</g>
			<g id="SPLINE-98" transform="translate(1513.895 228.66)">
				<path id="Path_804" className="st1" d="M57.6,24.2c-0.7,0.4-1.4,0.8-2.2,1.2c-0.9,0.4-1.7,0.7-2.6,0.9c-0.9,0.3-1.9,0.5-3,0.6
					c-1.1,0.2-2.2,0.3-3.4,0.4c-1.2,0.1-2.4,0.1-3.6,0.1c-1.2,0-2.5-0.1-3.8-0.3s-2.6-0.3-3.9-0.5c-1.3-0.2-2.7-0.5-4-0.8
					c-1.3-0.3-2.7-0.7-4-1.1s-2.7-0.9-4-1.3s-2.6-1-3.8-1.6s-2.5-1.2-3.6-1.8s-2.3-1.3-3.4-1.9c-1.1-0.7-2.1-1.4-3-2.1
					c-0.9-0.7-1.8-1.4-2.7-2.2c-0.8-0.8-1.6-1.5-2.3-2.2C3.6,10.9,3,10.1,2.4,9.3C1.9,8.6,1.5,7.8,1.1,7C0.8,6.3,0.5,5.6,0.3,4.8
					C0.1,4.1,0,3.4,0,2.7c0-0.7,0-1.3,0.3-2C0.3,0.5,0.4,0.2,0.6,0"/>
			</g>
			<g id="SPLINE-99" transform="translate(1571.541 247.885)">
				<path id="Path_805" className="st1" d="M3.8,0L3.8,0C3.7,0.7,3.4,1.4,3,1.9C2.7,2.5,2.2,3.1,1.8,3.6C1.2,4.1,0.6,4.6,0,5"/>
			</g>
			<g id="SPLINE-100" transform="translate(1520.468 253.98)">
				<path id="Path_806" className="st1" d="M8.8,11.8c-0.1-0.2-0.2-0.4-0.3-0.5c-0.1-0.2-0.2-0.5-0.3-0.7c-0.1-0.1-0.1-0.3-0.2-0.4
					C7.9,9.9,7.8,9.7,7.6,9.4C7.4,9,7.2,8.7,7,8.3C6.7,8,6.5,7.7,6.3,7.4C6.1,7,5.8,6.7,5.6,6.3l-0.8-1c-0.5-0.6-1-1.3-1.6-1.8l-1-1.1
					C2,2.1,1.7,1.8,1.5,1.6C1.3,1.4,1.1,1.2,1,1.1C0.9,1,0.8,0.8,0.6,0.7C0.5,0.6,0.4,0.5,0.3,0.3C0.2,0.2,0.1,0.1,0,0"/>
			</g>
			<g id="LINE-38" transform="translate(1536.085 274.359)">
				<line id="Line_834" className="st1" x1="0.1" y1="0" x2="0" y2="0"/>
			</g>
			<g id="SPLINE-101" transform="translate(1604.206 341.808)">
				<path id="Path_807" className="st1" d="M5.9,0c0,0-0.1,0-0.1,0s-0.1,0-0.1,0c0,0-0.1,0-0.1,0.1s-0.1,0-0.1,0.1s-0.1,0-0.1,0.1
					c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1S4.7,0.5,4.7,0.6c0,0-0.1,0.1-0.1,0.1S4.5,0.8,4.4,0.8C4.3,0.9,4.3,0.9,4.2,1
					C4.2,1,4.1,1.1,4.1,1.1C3.9,1.3,3.7,1.4,3.6,1.6C3.4,1.8,3.2,2,3,2.2C2.9,2.4,2.7,2.7,2.5,3S2.1,3.5,2,3.8C1.6,4.4,1.2,5.1,1,5.7
					C0.7,6.4,0.4,7.1,0.3,7.8C0.1,8.4,0,9,0,9.6c0,0.6,0,1.1,0.1,1.7c0.1,0.5,0.3,1.1,0.5,1.6c0.3,0.6,0.6,1.1,0.9,1.6
					C2,15,2.5,15.5,3,16c0.5,0.5,1.1,1,1.7,1.4c0.3,0.2,0.5,0.4,0.8,0.5c0.3,0.1,0.5,0.3,0.8,0.4c0.2,0.1,0.5,0.2,0.7,0.3
					c0.2,0.1,0.5,0.2,0.7,0.2c0.1,0,0.3,0.1,0.4,0.1s0.3,0,0.4,0.1c0.1,0,0.2,0,0.4,0h0.3c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3-0.1"/>
			</g>
			<g id="SPLINE-102" transform="translate(1613.885 357.029)">
				<path id="Path_808" className="st1" d="M0,3.8c0.2-0.1,0.5-0.2,0.7-0.3C0.8,3.4,0.9,3.3,1,3.2C1.1,3.1,1.1,3,1.2,2.8
					c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.4c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0-0.3V0.7
					c0-0.2,0-0.4,0-0.6V0"/>
			</g>
			<g id="SPLINE-103" transform="translate(1610.387 341.808)">
				<path id="Path_809" className="st1" d="M3,3.6c0-0.1-0.1-0.2-0.1-0.3C2.8,3.1,2.7,2.8,2.6,2.6C2.6,2.3,2.5,2.1,2.4,1.9
					C2.3,1.7,2.2,1.5,2.1,1.3C2,1.2,1.9,1,1.8,0.9C1.7,0.8,1.6,0.7,1.5,0.5C1.4,0.4,1.3,0.4,1.2,0.3C0.9,0.1,0.7,0,0.4,0
					C0.3,0,0.1,0,0,0"/>
			</g>
			<g id="LINE-39" transform="translate(1610.062 341.808)">
				<line id="Line_835" className="st1" x1="0.1" y1="0" x2="0" y2="0"/>
			</g>
			<g id="SPLINE-104" transform="translate(1613.417 345.883)">
				<path id="Path_810" className="st1" d="M0,0c0,0.1,0.1,0.3,0.1,0.4c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6
					c0.1,0.3,0.1,0.5,0.2,0.8c0,0.3,0.1,0.5,0.1,0.8c0,0.1,0,0.1,0,0.2"/>
			</g>
			<g id="SPLINE-105" transform="translate(1614.679 351.943)">
				<path id="Path_811" className="st1" d="M0,0c0,0.3,0.1,0.6,0.1,0.9s0.1,0.6,0.1,0.9c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0.1,0.4,0.1,0.6
					c0,0.2,0,0.4,0.1,0.6s0,0.4,0.1,0.5v0"/>
			</g>
			<g id="LINE-40" transform="translate(1609.99 341.808)">
				<line id="Line_836" className="st1" x1="0" y1="0" x2="0.1" y2="0"/>
			</g>
			<g id="SPLINE-106" transform="translate(1606.419 346.532)">
				<path id="Path_812" className="st1" d="M0.2,6c0-0.2-0.1-0.3-0.1-0.5c0-0.2,0-0.3-0.1-0.5c0-0.2,0-0.4,0-0.5l0-0.5c0-0.2,0-0.3,0-0.5
					c0-0.2,0-0.3,0-0.5c0-0.2,0-0.3,0.1-0.5c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0.1-0.2c0-0.1,0-0.1,0.1-0.2s0-0.1,0.1-0.2
					c0-0.1,0.1-0.2,0.1-0.4c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.1-0.2,0.2-0.3C1,0.6,1.1,0.5,1.2,0.4c0.1-0.1,0.2-0.1,0.3-0.2
					c0.1,0,0.2-0.1,0.3-0.1C1.8,0.1,1.8,0,1.9,0"/>
			</g>
			<g id="SPLINE-107" transform="translate(1606.636 352.484)">
				<path id="Path_813" className="st1" d="M3.7,4.5c-0.1,0-0.3,0-0.4,0C3,4.6,2.8,4.5,2.7,4.4C2.5,4.3,2.3,4.2,2.1,4
					C1.9,3.9,1.7,3.7,1.5,3.5C1.4,3.3,1.2,3,1,2.8C0.9,2.5,0.7,2.2,0.6,1.9C0.5,1.7,0.4,1.3,0.3,1S0.1,0.3,0,0"/>
			</g>
			<g id="LWPOLYLINE" transform="translate(1587.123 341.158)">
				<path id="Path_814" className="st1" d="M0.3,0.5L0.3,0.5l0.1-0.1V0.2L0.3,0.1L0.2,0L0.1,0L0,0"/>
			</g>
			<g id="SPLINE-108" transform="translate(1610.423 356.668)">
				<path id="Path_815" className="st1" d="M0.7,0L0.5,0.1C0.4,0.3,0.2,0.3,0,0.4"/>
			</g>
			<g id="LINE-41" transform="translate(1608.331 346.497)">
				<line id="Line_837" className="st1" x1="0" y1="0" x2="0.1" y2="0"/>
			</g>
			<g id="SPLINE-109" transform="translate(1608.62 346.46)">
				<path id="Path_816" className="st1" d="M0,0c0.1,0,0.2,0,0.3,0c0.1,0,0.3,0.1,0.4,0.1"/>
			</g>
			<g id="SPLINE-110" transform="translate(1594.733 352.989)">
				<path id="Path_817" className="st1" d="M0.7,2.9C0.5,1.9,0.3,1,0,0"/>
			</g>
			<g id="SPLINE-111" transform="translate(1555.31 248.751)">
				<path id="Path_818" className="st1" d="M0,0c0.3,0.4,0.7,0.8,1.1,1.1"/>
			</g>
			<g id="LINE-42" transform="translate(1526.852 270.933)">
				<line id="Line_838" className="st1" x1="0" y1="0" x2="0" y2="0"/>
			</g>
			<g id="SPLINE-112" transform="translate(1545.211 221.879)">
				<path id="Path_819" className="st1" d="M4,0.6C3.4,0.6,2.8,0.5,2.2,0.4C1.5,0.3,0.7,0.2,0,0"/>
			</g>
			<g id="LWPOLYLINE-2" transform="translate(1555.599 229.382)">
				<path id="Path_820" className="st1" d="M0.9,0.1L0.9,0.1L0,0"/>
			</g>
			<g id="ARC-6" transform="translate(1552.821 228.48)">
				<path id="Path_821" className="st1" d="M0,0c0.9,0.5,2,0.8,3,0.9"/>
			</g>
			<g id="SPLINE-113" transform="translate(1609.413 200.888)">
				<path id="Path_822" className="st1" d="M0,0l0.1,0.1"/>
			</g>
			<g id="LINE-43" transform="translate(1586.437 194.179)">
				<line id="Line_839" className="st1" x1="0.2" y1="0" x2="0" y2="0.2"/>
			</g>
			<g id="ARC-7" transform="translate(1586.69 205.721)">
				<path id="Path_823" className="st1" d="M0,0C0,0,0,0.1,0,0"/>
			</g>
			<g id="SPLINE-114" transform="translate(1589.034 192.411)">
				<path id="Path_824" className="st1" d="M0.1,0C0.1,0,0.1,0,0.1,0C0,0,0,0.1,0,0.1"/>
			</g>
			<g id="SPLINE-115" transform="translate(1594.48 190.067)">
				<path id="Path_825" className="st1" d="M11.5,4.5c-0.1-0.1-0.3-0.3-0.4-0.4c-0.1-0.1-0.3-0.3-0.4-0.4s-0.3-0.3-0.5-0.4
					C10,3.2,9.9,3.1,9.8,3C9.6,2.9,9.5,2.8,9.4,2.7L8.9,2.3C8.6,2.1,8.2,1.8,7.9,1.6C7.7,1.5,7.6,1.4,7.4,1.3C7.3,1.3,7.1,1.2,7,1.1
					C6.8,1,6.6,0.9,6.4,0.8c-0.1,0-0.2-0.1-0.3-0.1L5.8,0.6c-0.1,0-0.3-0.1-0.4-0.1L5,0.4c-0.1,0-0.3-0.1-0.4-0.1s-0.2,0-0.3-0.1
					c-0.1,0-0.2,0-0.3,0c-0.2,0-0.4-0.1-0.6-0.1C3.3,0,3.1,0,2.9,0C2.8,0,2.6,0,2.5,0C2,0,1.4,0,0.9,0.1c-0.2,0-0.5,0.1-0.7,0.1
					C0.2,0.3,0.1,0.3,0,0.3"/>
			</g>
			<g id="SPLINE-116" transform="translate(1595.851 209.58)">
				<path id="Path_826" className="st1" d="M15.6,4.4c-2.6-0.6-5.3-1.3-7.9-2S2.5,0.9,0,0"/>
			</g>
			<g id="LINE-44" transform="translate(1595.851 209.436)">
				<line id="Line_840" className="st1" x1="0" y1="0.1" x2="0" y2="0"/>
			</g>
			<g id="LINE-45" transform="translate(1611.433 213.836)">
				<line id="Line_841" className="st1" x1="0" y1="0.1" x2="0" y2="0"/>
			</g>
			<g id="SPLINE-117" transform="translate(1611.325 213.945)">
				<path id="Path_827" className="st1" d="M0.3,4.1h0.3C0.8,4.1,0.9,4,1,4c0.1,0,0.3-0.1,0.4-0.1c0.1,0,0.3-0.1,0.4-0.2
					C1.9,3.6,2,3.5,2.1,3.5c0.1-0.1,0.2-0.2,0.3-0.3C2.4,3.1,2.5,3,2.5,2.9c0.1-0.1,0.1-0.2,0.1-0.4c0-0.1,0-0.3,0-0.4
					c0-0.1,0-0.3,0-0.4c0-0.1-0.1-0.2-0.1-0.3S2.4,1.2,2.4,1.1C2.3,1,2.2,0.9,2.2,0.9C2.1,0.8,2,0.7,1.9,0.6C1.8,0.6,1.6,0.5,1.5,0.4
					C1.4,0.4,1.2,0.3,1.1,0.2C0.9,0.2,0.7,0.1,0.5,0.1L0,0"/>
			</g>
			<g id="SPLINE-118" transform="translate(1592.569 208.895)">
				<path id="Path_828" className="st1" d="M3.3,0.7C2.8,0.5,2.4,0.4,1.9,0.2C1.7,0.2,1.5,0.1,1.3,0.1C1.2,0,1,0,0.8,0L0.4,0
					C0.3,0,0.2,0,0.1,0.1C0.1,0.1,0,0.1,0,0.2l0,0.1"/>
			</g>
			<g id="SPLINE-119" transform="translate(1608.367 352.159)">
				<path id="Path_829" className="st1" d="M4.3,4.2c-0.2,0-0.3,0-0.5,0c-0.1,0-0.2,0-0.3,0L3.2,4.1C3,4.1,2.9,4,2.7,3.9
					C2.6,3.8,2.5,3.7,2.3,3.6C2.1,3.5,2,3.4,1.8,3.2C1.6,3.1,1.5,2.9,1.3,2.7C1.2,2.6,1.1,2.4,1,2.3C0.9,2.1,0.8,1.9,0.7,1.8
					C0.5,1.5,0.4,1.2,0.3,0.9C0.1,0.6,0.1,0.3,0,0"/>
			</g>
			<g id="SPLINE-120" transform="translate(1608.28 346.352)">
				<path id="Path_830" className="st1" d="M0.1,5.8C0.1,5.5,0,5.2,0,4.9c0-0.3,0-0.7,0-1c0-0.2,0.1-0.4,0.1-0.6c0-0.2,0.1-0.4,0.1-0.6
					c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.2,0.2-0.4,0.3-0.6C0.9,1.4,1,1.2,1.1,1.1c0.1-0.1,0.2-0.3,0.3-0.4C1.6,0.5,1.8,0.4,2,0.3
					C2.2,0.1,2.3,0.1,2.5,0l0.1,0"/>
			</g>
			<g id="LWPOLYLINE-3" transform="translate(1614.463 350.68)">
				<path id="Path_831" className="st1" d="M0,0L0,0"/>
			</g>
			<g id="SPLINE-121" transform="translate(1601.514 383.755)">
				<path id="Path_832" className="st1" d="M0,1.1C0.3,1,0.5,1,0.8,0.9c0.5-0.1,1-0.3,1.5-0.4s1-0.3,1.4-0.4C3.8,0.1,4,0.1,4.1,0"/>
			</g>
			<g id="SPLINE-122" transform="translate(1609.665 352.628)">
				<path id="Path_833" className="st1" d="M0,29.5c1.4-0.6,2.8-1.3,4.1-2c1.4-0.7,2.7-1.6,4-2.5c1.3-0.9,2.6-2,3.8-3
					c1.3-1.1,2.5-2.3,3.6-3.5c1.2-1.3,2.3-2.6,3.4-4c1.1-1.4,2.1-2.9,3.1-4.4s2-3.2,2.9-4.9s1.7-3.5,2.6-5.3"/>
			</g>
			<g id="LINE-46" transform="translate(1605.95 194.576)">
				<line id="Line_842" className="st1" x1="2.8" y1="2.8" x2="0" y2="0"/>
			</g>
			<g id="SPLINE-123" transform="translate(1597.546 369.066)">
				<path id="Path_834" className="st1" d="M0,1.2c0.9-0.3,1.8-0.6,2.7-0.8c1-0.2,2-0.3,3-0.4c1,0,2,0,3.1,0.1c1,0.1,2.1,0.3,3.1,0.6
					c1,0.3,2,0.7,3,1.2"/>
			</g>
			<g id="SPLINE-124" transform="translate(1601.658 223.935)">
				<path id="Path_835" className="st1" d="M0,0c1.1,1.8,2.2,3.5,3.3,5.4c1,1.8,2.1,3.8,3.1,5.7s1.9,3.9,2.8,6c0.9,2,1.8,4.1,2.6,6.2
					c0.8,2.1,1.6,4.2,2.3,6.4c0.7,2.2,1.4,4.3,2.1,6.6c0.6,2.2,1.2,4.4,1.8,6.7s1,4.5,1.5,6.8s0.9,4.5,1.2,6.9
					c0.4,2.3,0.6,4.6,0.9,6.9c0.3,2.3,0.5,4.6,0.6,6.9s0.3,4.5,0.3,6.8s0,4.5,0,6.7c-0.1,2.2-0.2,4.4-0.3,6.6
					c-0.2,2.2-0.4,4.3-0.6,6.4s-0.6,4.2-0.9,6.2c-0.3,1.6-0.6,3.2-1,4.7"/>
			</g>
			<g id="SPLINE-125" transform="translate(1609.377 382.168)">
				<path id="Path_836" className="st1" d="M0.3,0c0,0.1-0.1,0.2-0.2,0.2c0,0-0.1,0-0.1,0.1"/>
			</g>
			<g id="SPLINE-126" transform="translate(1587.664 371.492)">
				<path id="Path_837" className="st1" d="M0,7.7C0,7.7,0,7.7,0,7.7C0,7.7,0,7.7,0,7.7C0.1,7.8,0.2,7.9,0.3,8c0.2,0.1,0.3,0.3,0.5,0.4
					C1,8.6,1.3,8.7,1.5,8.7C1.7,8.8,1.8,8.9,2,8.9C2.2,8.9,2.4,9,2.6,9c0.2,0,0.5,0.1,0.7,0.1c0.1,0,0.3,0,0.4,0h0.5
					c0.2,0,0.4,0,0.6,0c0.3,0,0.5,0,0.7-0.1c0.3,0,0.6-0.1,0.9-0.1c0.3-0.1,0.6-0.1,0.9-0.2c0.3-0.1,0.5-0.1,0.8-0.2
					C8.4,8.4,8.7,8.3,9,8.2C9.2,8.1,9.4,8,9.7,7.9c0.2-0.1,0.4-0.2,0.6-0.3c0.2-0.1,0.4-0.2,0.6-0.3c0.3-0.1,0.5-0.2,0.8-0.4
					c0.2-0.1,0.5-0.2,0.7-0.4c0.2-0.1,0.5-0.2,0.7-0.4L13.7,6c0.3-0.2,0.6-0.4,0.9-0.5s0.6-0.4,0.9-0.5c0.3-0.2,0.6-0.3,0.8-0.5
					c0.5-0.3,1-0.6,1.5-0.9c0.5-0.3,0.9-0.5,1.3-0.8C19.6,2.5,20,2.2,20.4,2c0.1-0.1,0.3-0.1,0.4-0.2c0.1-0.1,0.2-0.1,0.4-0.2
					c0.1-0.1,0.2-0.1,0.4-0.2c0.1-0.1,0.3-0.1,0.4-0.2s0.3-0.1,0.4-0.2c0.2-0.1,0.4-0.1,0.5-0.2c0.2-0.1,0.3-0.1,0.5-0.2
					c0.1,0,0.2-0.1,0.4-0.1c0.1,0,0.3-0.1,0.4-0.1l0.3-0.1c0.1,0,0.2-0.1,0.3-0.1C24.8,0.1,24.9,0,25,0"/>
			</g>
			<g id="SPLINE-127" transform="translate(1596.464 382.168)">
				<path id="Path_838" className="st1" d="M0,3.4C0,3.4,0,3.4,0,3.4C0,3.4,0,3.4,0,3.4l0.4,0c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0
					s0.2,0,0.3,0c0.2,0,0.4-0.1,0.7-0.1S2.6,3.1,2.9,3l0.5-0.1c0.2,0,0.4-0.1,0.6-0.1c0.2,0,0.4-0.1,0.6-0.1c0.1,0,0.3-0.1,0.4-0.1
					l0.4-0.1c0.1,0,0.3-0.1,0.5-0.1c0.2,0,0.3-0.1,0.5-0.1c0.1,0,0.3-0.1,0.4-0.1C7,2,7.1,2,7.3,1.9c0.2,0,0.3-0.1,0.5-0.1
					c0.1,0,0.2-0.1,0.3-0.1c0.3-0.1,0.5-0.1,0.8-0.2C9,1.4,9.2,1.4,9.4,1.3C9.7,1.2,10,1.1,10.3,1c0.1,0,0.3-0.1,0.5-0.1
					s0.3-0.1,0.4-0.1c0.2-0.1,0.4-0.1,0.5-0.2L12,0.4c0.2-0.1,0.4-0.1,0.6-0.2s0.4-0.1,0.6-0.2"/>
			</g>
			<g id="LINE-47" transform="translate(1539.115 237.425)">
				<line id="Line_843" className="st1" x1="0.1" y1="0" x2="0" y2="0"/>
			</g>
			<g id="SPLINE-128" transform="translate(1535.148 230.608)">
				<path id="Path_839" className="st1" d="M2.4,5.8L2.4,5.8C2.3,5.7,2.2,5.6,2.1,5.6C2,5.5,1.9,5.4,1.8,5.3C1.7,5.3,1.6,5.2,1.6,5.1
					C1.5,5,1.4,5,1.3,4.9C1.2,4.8,1.2,4.7,1.1,4.6S0.9,4.4,0.9,4.4C0.8,4.3,0.7,4.2,0.7,4.1C0.6,4,0.6,3.9,0.5,3.9
					C0.4,3.7,0.3,3.6,0.3,3.4C0.2,3.2,0.1,3.1,0.1,2.9C0,2.7,0,2.5,0,2.3c0-0.3,0-0.5,0.1-0.8c0.1-0.2,0.2-0.5,0.4-0.6
					C0.8,0.7,1,0.5,1.3,0.4c0.3-0.2,0.6-0.3,1-0.4"/>
			</g>
			<g id="SPLINE-129" transform="translate(1544.742 221.663)">
				<path id="Path_840" className="st1" d="M0.4,0.3C0.3,0.1,0.2,0,0.1,0L0,0"/>
			</g>
			<g id="SPLINE-130" transform="translate(1574.066 240.563)">
				<path id="Path_841" className="st1" d="M0,0c0.2,0,0.4,0,0.5,0.1c0.1,0,0.1,0,0.2,0.1c0,0,0,0,0,0.1"/>
			</g>
			<g id="LINE-48" transform="translate(1514.481 236.652)">
				<line id="Line_844" className="st1" x1="0" y1="0" x2="0" y2="0"/>
			</g>
			<g id="ARC-8" transform="translate(1517.871 249.328)">
				<path id="Path_842" className="st1" d="M0,0c0.5,1.7,1.4,3.3,2.7,4.6"/>
			</g>
			<g id="SPLINE-131" transform="translate(1529.233 265.775)">
				<path id="Path_843" className="st1" d="M6.9,8.6c-0.1,0-0.1,0-0.2,0C6.4,8.5,6.2,8.4,6,8.4C5.8,8.3,5.6,8.2,5.4,8.1
					C5.3,8,5.1,7.9,4.9,7.7C4.8,7.6,4.7,7.5,4.5,7.4C4.4,7.3,4.2,7.1,4.1,7C4,6.9,3.9,6.7,3.7,6.6C3.6,6.4,3.4,6.2,3.3,6.1
					C3.2,5.9,3.1,5.7,2.9,5.5S2.7,5.1,2.5,4.9S2.3,4.5,2.1,4.3S1.9,3.8,1.7,3.5C1.6,3.4,1.6,3.3,1.5,3.2S1.4,3,1.3,2.9
					S1.2,2.7,1.2,2.6C1.1,2.4,1,2.3,1,2.2C0.9,2.1,0.9,1.9,0.8,1.8c0-0.1-0.1-0.2-0.1-0.3c0-0.1-0.1-0.2-0.1-0.3
					c0-0.1-0.1-0.2-0.1-0.3C0.3,0.6,0.1,0.3,0,0"/>
			</g>
			<g id="LWPOLYLINE-4" transform="translate(1542.325 243.593)">
				<path id="Path_844" className="st1" d="M8.8,2.8l0,0.1L8.5,3.3L8,3.6L7.4,3.8L6.7,3.9H5.9L5.1,3.8L4.2,3.6L3.3,3.3L2.4,2.9L1.7,2.5
					L1,2L0.5,1.5L0.2,1L0,0.6l0-0.5L0,0"/>
			</g>
			<g id="SPLINE-132" transform="translate(1594.661 351.258)">
				<path id="Path_845" className="st1" d="M0.1,1.7L0.1,1.7L0.1,1.7C0,1.5,0,1.3,0,1.2C0,1,0,0.8,0.1,0.7c0-0.1,0.1-0.2,0.1-0.3
					c0-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.1-0.1,0.2-0.1C0.7,0,0.8,0,0.9,0"/>
			</g>
			<g id="ARC-9" transform="translate(1543.191 274.202)">
				<path id="Path_846" className="st1" d="M0.3,0C0.2,0,0.1,0,0,0.1"/>
			</g>
			<g id="SPLINE-133" transform="translate(1595.491 355.875)">
				<path id="Path_847" className="st1" d="M1.8,1.4c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2-0.1C0.9,1.2,0.8,1.2,0.7,1.1
					C0.6,1,0.5,0.9,0.4,0.8C0.4,0.8,0.3,0.7,0.3,0.6C0.2,0.4,0.1,0.2,0,0"/>
			</g>
			<g id="LWPOLYLINE-5" transform="translate(1531.324 237.245)">
				<path id="Path_848" className="st1" d="M8.8,2.8l0,0.1L8.5,3.3L8,3.6L7.4,3.8L6.7,3.9H5.9L5,3.8L4.1,3.6L3.2,3.3L2.4,2.9L1.7,2.5L1,2
					L0.5,1.5L0.2,1L0,0.5l0-0.5L0,0"/>
			</g>
			<g id="SPLINE-134" transform="translate(1556.681 246.586)">
				<path id="Path_849" className="st1" d="M0,0L0,0c0.1,0,0.1,0,0.1,0l0.1,0.1"/>
			</g>
			<g id="SPLINE-135" transform="translate(1556.464 249.869)">
				<path id="Path_850" className="st1" d="M0,0c0.3,0.2,0.7,0.4,1,0.5c0.3,0.1,0.6,0.2,0.9,0.3c0.3,0.1,0.6,0.1,0.9,0.1
					c0.3,0,0.5-0.1,0.8-0.1c0.2-0.1,0.4-0.2,0.5-0.4C4.2,0.3,4.3,0.1,4.3,0"/>
			</g>
			<g id="ARC-10" transform="translate(1520.504 253.944)">
				<path id="Path_851" className="st1" d="M0,0c0,0.2,0.1,0.3,0.2,0.5"/>
			</g>
			<g id="ARC-11" transform="translate(1528.475 265.126)">
				<path id="Path_852" className="st1" d="M0,0c0.1,0.3,0.4,0.6,0.8,0.6"/>
			</g>
			<g id="SPLINE-136" transform="translate(1526.383 261.844)">
				<path id="Path_853" className="st1" d="M0.5,9.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1-0.1L0.2,8.9C0.2,8.8,0.1,8.7,0.1,8.6
					c0-0.1,0-0.2-0.1-0.3C0,8.1,0,8,0,7.8l0-1.2c0-0.5,0-1,0.1-1.7c0-0.5,0.1-1,0.1-1.6c0-0.5,0.1-1,0.1-1.6c0-0.4,0.1-0.9,0.1-1.3
					c0-0.2,0-0.3,0-0.5"/>
			</g>
			<g id="SPLINE-137" transform="translate(1586.654 192.123)">
				<path id="Path_854" className="st1" d="M22.8,8.8c-0.1-0.1-0.3-0.2-0.4-0.3S22.1,8.2,22,8.1c-0.1-0.1-0.3-0.3-0.5-0.4
					c-0.2-0.1-0.4-0.3-0.6-0.5c-0.3-0.2-0.5-0.4-0.8-0.6c-0.1-0.1-0.2-0.1-0.3-0.2s-0.2-0.1-0.3-0.2l-0.4-0.3
					c-0.2-0.1-0.3-0.3-0.5-0.4c-0.2-0.1-0.4-0.3-0.5-0.4s-0.4-0.3-0.5-0.4c-0.3-0.2-0.5-0.4-0.8-0.6s-0.6-0.4-0.9-0.6S15.3,3.2,15,3
					c-0.3-0.1-0.5-0.3-0.8-0.5c-0.2-0.1-0.4-0.2-0.6-0.3C13.4,2.1,13.2,2,13,1.9c-0.3-0.1-0.5-0.3-0.8-0.4c-0.2-0.1-0.4-0.1-0.5-0.2
					l-0.5-0.2c-0.4-0.1-0.7-0.3-1-0.4C9.9,0.6,9.6,0.6,9.4,0.5S8.9,0.4,8.7,0.3L8.3,0.2C8.1,0.2,8,0.1,7.8,0.1L7.1,0
					C6.8,0,6.5,0,6.3,0L5.6,0C5.3,0,5.1,0,4.9,0c-0.2,0-0.4,0-0.6,0.1L3.8,0.2c-0.1,0-0.3,0.1-0.5,0.1L2.9,0.4c-0.1,0-0.3,0.1-0.4,0.1
					C2.3,0.6,2.1,0.7,1.8,0.8C1.7,0.9,1.5,1,1.3,1.1C1.2,1.1,1.1,1.2,1,1.3c-0.1,0-0.2,0.1-0.3,0.1C0.6,1.5,0.4,1.6,0.3,1.7
					C0.2,1.8,0.1,1.9,0,1.9l0,0"/>
			</g>
			<g id="LINE-49" transform="translate(1607.682 346.316)">
				<line id="Line_845" className="st2" x1="3.2" y1="0" x2="0" y2="0.6"/>
			</g>
			<g id="LINE-50" transform="translate(1609.413 356.379)">
				<line id="Line_846" className="st2" x1="0" y1="0.6" x2="3.2" y2="0"/>
			</g>
			<g id="SPLINE-138" transform="translate(1610.892 346.3)">
				<path id="Path_855" className="st3" d="M3.6,4.4c-0.1-0.5-0.2-1-0.4-1.4C3.1,2.6,3,2.2,2.8,1.9C2.7,1.6,2.5,1.4,2.4,1.1
					C2.3,1,2.1,0.8,2,0.7C1.9,0.6,1.8,0.5,1.7,0.4C1.6,0.3,1.5,0.3,1.3,0.2C1.1,0.1,1,0,0.8,0C0.5,0,0.2,0,0,0"/>
			</g>
			<g id="SPLINE-139" transform="translate(1612.623 350.644)">
				<path id="Path_856" className="st2" d="M0,5.7c0.3-0.1,0.5-0.1,0.8-0.3c0.2-0.1,0.3-0.2,0.5-0.4C1.4,5,1.5,4.8,1.5,4.7
					c0.1-0.1,0.1-0.2,0.2-0.4c0.1-0.2,0.1-0.4,0.2-0.6C2,3.4,2,3.1,2,2.8c0-0.4,0-0.8,0-1.3C2,1.3,2,1.1,2,0.8c0-0.3-0.1-0.6-0.1-0.8"
					/>
			</g>
			<g id="SPLINE-140" transform="translate(1601.514 383.755)">
				<path id="Path_857" className="st2" d="M0,1.1C0.3,1,0.5,1,0.8,0.9c0.5-0.1,1-0.3,1.5-0.4C2.9,0.4,3.5,0.2,4.1,0"/>
			</g>
			<g id="SPLINE-141" transform="translate(1609.377 198.038)">
				<path id="Path_858" className="st3" d="M0,0c0.4,0.4,0.8,0.8,1.1,1.2c1.1,1.2,2.2,2.5,3.3,3.7s2.1,2.5,3.2,3.8s2.1,2.6,3,3.9
					c1,1.3,2,2.7,2.9,4c0.1,0.1,0.2,0.3,0.3,0.4c0.6,0.9,1.4,2.3,1.9,3.1"/>
			</g>
			<g id="LINE-51" transform="translate(1597.546 370.158)">
				<line id="Line_847" className="st2" x1="0.2" y1="0" x2="0" y2="0.1"/>
			</g>
			<g id="SPLINE-142" transform="translate(1609.413 352.881)">
				<path id="Path_859" className="st3" d="M0,29.6c0.6-0.3,1.3-0.5,1.9-0.8c0.6-0.3,1.1-0.5,1.7-0.8c0.5-0.3,1-0.5,1.4-0.8
					c0.4-0.3,0.8-0.5,1.2-0.7l1-0.6c0.3-0.2,0.5-0.4,0.8-0.6c0.4-0.3,0.9-0.6,1.3-0.9s0.9-0.7,1.3-1l1.3-1.1c0.4-0.4,0.8-0.7,1.2-1.1
					c0.4-0.4,0.7-0.7,1.1-1l1.2-1.2c0.5-0.5,0.9-1,1.3-1.5s0.9-1,1.3-1.6c0.6-0.7,1.2-1.5,1.7-2.2l1.6-2.3c0.5-0.8,1-1.6,1.6-2.4
					c0.5-0.8,1-1.7,1.5-2.5c0.5-0.9,1-1.8,1.4-2.7c0.5-0.9,1-1.9,1.4-2.9L27.7,0"/>
			</g>
			<g id="SPLINE-143" transform="translate(1605.914 194.54)">
				<path id="Path_860" className="st3" d="M3.4,3.4C2.8,2.8,2.3,2.2,1.7,1.7S0.6,0.5,0,0"/>
			</g>
			<g id="SPLINE-144" transform="translate(1584.526 344.044)">
				<path id="Path_861" className="st3" d="M0,0c0.5,1.2,0.9,2.3,1.4,3.4l2.9,7.1c1,2.5,2,4.9,3,7.4c1,2.6,2.1,5.1,3.1,7.6
					c0.2,0.5,0.4,0.9,0.6,1.4"/>
			</g>
			<g id="SPLINE-145" transform="translate(1541.532 274.395)">
				<path id="Path_862" className="st3" d="M0,0c0.7,0.3,1.2,0.6,1.9,0.9C2.2,1,2.8,1.3,3.1,1.5"/>
			</g>
			<path id="Path_863" className="st2" d="M1614.7,352.5c0.2,1.2,0.4,2.1,0.4,2.5"/>
			<path id="Path_864" className="st3" d="M1574.6,249.8l1.3,1.3c0.4,0.4,0.9,0.9,1.3,1.3c0.2,0.2,0.4,0.5,0.6,0.7
				c0.1,0.2,0.3,0.3,0.5,0.5c0.1,0.1,0.2,0.3,0.3,0.4c0.4,0.4,0.7,0.8,1.1,1.2c0.4,0.5,0.9,1,1.3,1.6c0.5,0.6,1,1.2,1.6,1.9
				c0.6,0.7,1.2,1.4,1.7,2.2c1.2,1.5,2.2,3,3.3,4.6c1,1.6,2.1,3.2,3.1,4.9s1.9,3.5,2.8,5.2c0.9,1.8,1.8,3.7,2.6,5.6
				c0.5,1.2,1,2.3,1.4,3.5c0.5,1.2,1,2.5,1.4,3.8c0.5,1.3,1,2.7,1.4,4c0.5,1.4,1,2.9,1.4,4.4c0.5,1.6,1,3.2,1.4,4.8
				c0.5,1.7,1,3.5,1.5,5.2c0.4,1.6,0.9,3.2,1.3,4.8c0.5,1.7,0.9,3.5,1.3,5.2c0.5,1.9,0.9,3.8,1.4,5.7c0.5,2.1,0.9,4.1,1.4,6.2
				c0.5,2.3,1,4.6,1.4,6.9c0.5,2.5,1,4.9,1.4,7.4c0.3,1.5,0.5,3,0.8,4.4c0.1,0.4,0.2,1.2,0.4,1.9"/>
			<g id="SPLINE-146" transform="translate(1615.184 354.973)">
				<path id="Path_865" className="st2" d="M1.6,9C1.3,7.4,1,5.8,0.7,4.1C0.5,2.7,0.3,1.4,0,0"/>
			</g>
			<g id="SPLINE-147" transform="translate(1544.778 275.982)">
				<path id="Path_866" className="st3" d="M0,0c0.3,0.1,0.6,0.3,0.9,0.5c0.6,0.3,1.2,0.6,1.8,1c0.5,0.3,1,0.6,1.5,0.9
					C4.6,2.7,5,3,5.4,3.3C5.9,3.6,6.3,4,6.8,4.4C7.1,4.7,7.5,5,7.9,5.3c0.3,0.3,0.5,0.5,0.8,0.8c0.3,0.3,0.5,0.5,0.8,0.8
					c0.3,0.3,0.6,0.6,0.8,0.9c0.3,0.4,0.6,0.7,1,1.1c0.4,0.4,0.8,0.9,1.1,1.4c0.6,0.7,1.1,1.5,1.7,2.3c0.6,0.9,1.2,1.8,1.8,2.7
					c0.5,0.9,1,1.7,1.6,2.6c0.5,0.8,0.9,1.6,1.3,2.4c0.4,0.7,0.8,1.4,1.1,2.1c0.3,0.6,0.6,1.2,0.9,1.8c0.2,0.4,0.4,0.9,0.6,1.3
					c0.2,0.3,0.3,0.7,0.5,1c0.1,0.3,0.3,0.5,0.4,0.8c0.2,0.4,0.4,0.7,0.5,1.1c0.3,0.5,0.5,1,0.7,1.6c0.3,0.7,0.6,1.3,0.9,2
					c0.4,0.8,0.8,1.7,1.1,2.5c0.4,0.9,0.8,1.8,1.2,2.6c0.4,1,0.9,2.1,1.3,3.1l1.5,3.6c0.6,1.4,1.2,2.7,1.7,4.1
					c0.6,1.6,1.3,3.1,1.9,4.6l2.2,5.2c0.8,1.9,1.6,3.9,2.4,5.8c0.6,1.5,1.2,3,1.8,4.4"/>
			</g>
			<g id="SPLINE-148" transform="translate(1587.664 370.23)">
				<path id="Path_867" className="st3" d="M9.9,0C9.3,0.2,8.7,0.4,8.2,0.7C7.7,0.9,7.3,1.1,6.8,1.3c-0.3,0.2-0.7,0.4-1,0.5
					C5.6,2,5.4,2.1,5.1,2.3L4.6,2.6C4.4,2.7,4.3,2.8,4.1,2.9S3.8,3.1,3.6,3.2C3.4,3.4,3.2,3.5,3.1,3.6C2.9,3.8,2.6,4,2.4,4.1
					S2,4.5,1.8,4.7C1.5,4.9,1.3,5.2,1,5.4C0.8,5.7,0.6,5.9,0.4,6.1L0.1,6.4C0,6.5,0,6.5,0,6.5"/>
			</g>
			<g id="SPLINE-149" transform="translate(1587.267 376.722)">
				<path id="Path_868" className="st3" d="M0.5,0C0.4,0.2,0.2,0.4,0.1,0.6C0,0.8,0,1.1,0,1.3C0,1.5,0,1.8,0.1,2c0.1,0.2,0.1,0.3,0.3,0.4
					c0.4,0.7,0.9,1.3,1.6,1.8"/>
			</g>
			<g id="SPLINE-150" transform="translate(1589.178 380.978)">
				<path id="Path_869" className="st3" d="M0,0c0.7,0.5,1.4,1,2.2,1.4c0.7,0.4,1.4,0.9,2.1,1.3L6.2,4c0.3,0.2,0.7,0.4,1,0.6"/>
			</g>
			<g id="SPLINE-151" transform="translate(1514.408 220.04)">
				<path id="Path_870" className="st3" d="M30.4,1.6c-0.7-0.2-1.5-0.4-2.2-0.5c-1-0.2-2.1-0.4-3.1-0.5c-0.9-0.1-1.9-0.3-2.8-0.3
					c-0.8-0.1-1.6-0.1-2.5-0.2c-0.7,0-1.4,0-2.1,0c-0.6,0-1.2,0-1.8,0l-1.7,0.1c-0.5,0-0.9,0.1-1.4,0.1c-0.4,0.1-0.9,0.1-1.3,0.2
					c-0.5,0.1-0.9,0.2-1.3,0.3C9.8,0.9,9.3,1,8.9,1.1C8.3,1.3,7.7,1.5,7.2,1.7c-0.5,0.2-1,0.4-1.4,0.6C5.3,2.5,5,2.7,4.6,2.9
					C4.4,3.1,4.1,3.2,3.8,3.4C3.6,3.6,3.4,3.7,3.1,3.9C2.9,4.1,2.7,4.3,2.4,4.5C2.2,4.8,1.9,5.1,1.7,5.4C1.4,5.8,1.1,6.2,0.9,6.6
					C0.5,7.2,0.3,7.8,0,8.4"/>
			</g>
			<g id="SPLINE-152" transform="translate(1574.571 240.78)">
				<path id="Path_871" className="st3" d="M0.2,0c0.1,0.1,0.1,0.3,0.2,0.4c0.1,0.4,0.3,0.7,0.4,1.1C0.8,1.8,0.9,2.2,1,2.5
					C1,2.7,1,2.9,1.1,3.1c0,0.1,0,0.3,0,0.4V4c0,0.3,0,0.5,0,0.8C1,5.1,1,5.4,1,5.8C0.9,6.2,0.8,6.6,0.7,7.1C0.6,7.8,0.3,8.4,0,9"/>
			</g>
			<g id="LINE-52" transform="translate(1513.867 228.993)">
				<path id="Path_872" className="st3" d="M0.5,0L0.5,0C0,1.6-0.1,3.3,0.2,5"/>
			</g>
			<g id="SPLINE-153" transform="translate(1536.085 274.359)">
				<path id="Path_873" className="st3" d="M0,0c0.3,0,0.6,0.1,1,0.1c0.4,0,0.8,0.1,1.2,0.1l1.3,0c0.5,0,0.9,0,1.4-0.1
					C5.1,0.1,5.3,0,5.5,0"/>
			</g>
			<g id="SPLINE-154" transform="translate(1514.071 234.369)">
				<path id="Path_874" className="st3" d="M0,0c0.5,2.1,1,4.1,1.5,6.2c0.4,1.7,0.8,3.5,1.3,5.2c0.3,1.1,0.5,2.2,0.9,3.3"/>
			</g>
			<g id="SPLINE-155" transform="translate(1605.662 382.421)">
				<path id="Path_875" className="st3" d="M0,1.3C0.4,1.2,0.7,1.1,1,1c0.4-0.1,0.6-0.2,1-0.3C2.6,0.5,3.2,0.2,3.8,0"/>
			</g>
			<g id="SPLINE-156" transform="translate(1596.428 384.909)">
				<path id="Path_876" className="st3" d="M0,0.6c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.3,0,0.4,0c0.4,0,0.8,0,1.2-0.1c0.5-0.1,1-0.1,1.5-0.3
					S4.5,0.1,5.1,0"/>
			</g>
			<g id="SPLINE-157" transform="translate(1547.555 242.294)">
				<path id="Path_877" className="st2" d="M3.6,4.1L3.6,4.1c0.1-0.2,0.1-0.4,0.1-0.6c0-0.2,0-0.4-0.1-0.5c0-0.2-0.1-0.4-0.2-0.5
					C3.2,2.2,3.1,2.1,3,1.9C2.9,1.8,2.8,1.6,2.6,1.5C2.5,1.4,2.3,1.2,2.2,1.1C2,1,1.8,0.9,1.7,0.8C1.5,0.7,1.4,0.6,1.2,0.5L0.8,0.3
					C0.5,0.2,0.3,0.1,0,0"/>
			</g>
			<g id="SPLINE-158" transform="translate(1542.326 241.97)">
				<path id="Path_878" className="st2" d="M5.2,0.4C4.9,0.3,4.7,0.3,4.4,0.2c-0.1,0-0.2,0-0.3-0.1c-0.2,0-0.4,0-0.5-0.1C3.4,0,3.2,0,3,0
					C2.8,0,2.6,0,2.5,0c-0.2,0-0.4,0-0.5,0.1c-0.2,0-0.3,0.1-0.5,0.1C1.2,0.3,1.1,0.4,0.9,0.5C0.8,0.5,0.7,0.6,0.5,0.8
					C0.4,0.9,0.3,1,0.2,1.2L0,1.6"/>
			</g>
			<g id="LINE-53" transform="translate(1550.657 246.37)">
				<line id="Line_848" className="st2" x1="0" y1="1.6" x2="0.5" y2="0"/>
			</g>
			<g id="LINE-54" transform="translate(1541.929 243.593)">
				<line id="Line_849" className="st2" x1="0.4" y1="0" x2="0" y2="1.4"/>
			</g>
			<g id="SPLINE-159" transform="translate(1536.554 235.946)">
				<path id="Path_879" className="st2" d="M3.6,4.1L3.6,4.1c0.1-0.2,0.1-0.4,0.1-0.6c0-0.2,0-0.4-0.1-0.5c0-0.2-0.1-0.4-0.2-0.5
					C3.2,2.2,3.1,2.1,3,1.9C2.9,1.8,2.8,1.6,2.6,1.5C2.5,1.4,2.3,1.2,2.2,1.1C2,1,1.8,0.9,1.7,0.8C1.5,0.7,1.4,0.6,1.2,0.5L0.8,0.3
					C0.5,0.2,0.3,0.1,0,0"/>
			</g>
			<g id="SPLINE-160" transform="translate(1531.325 235.622)">
				<path id="Path_880" className="st2" d="M5.2,0.4C4.9,0.3,4.7,0.3,4.4,0.2c-0.1,0-0.2,0-0.3-0.1c-0.2,0-0.4,0-0.5-0.1C3.4,0,3.2,0,3,0
					C2.8,0,2.6,0,2.5,0c-0.2,0-0.4,0-0.5,0.1c-0.2,0-0.3,0.1-0.5,0.1C1.2,0.3,1.1,0.4,0.9,0.5C0.8,0.5,0.7,0.6,0.5,0.8
					C0.4,0.9,0.3,1,0.2,1.2L0,1.6"/>
			</g>
			<g id="LINE-55" transform="translate(1539.656 240.022)">
				<line id="Line_850" className="st2" x1="0" y1="1.4" x2="0.5" y2="0"/>
			</g>
			<g id="LINE-56" transform="translate(1530.783 237.245)">
				<line id="Line_851" className="st2" x1="0.6" y1="0" x2="0" y2="1.8"/>
			</g>
			<g id="SPLINE-161" transform="translate(1556.609 246.607)">
				<path id="Path_881" className="st2" d="M4.2,3.2c0-0.1,0-0.1,0.1-0.2c0-0.1,0-0.2,0-0.4c0-0.2-0.1-0.4-0.2-0.6
					C3.9,1.8,3.7,1.5,3.5,1.2C3.3,1.1,3.2,1,3.1,0.9C2.8,0.8,2.6,0.6,2.4,0.5C2,0.3,1.7,0.2,1.3,0.1C1.1,0,0.9,0,0.7,0
					C0.5,0,0.2,0,0,0"/>
			</g>
			<g id="LINE-57" transform="translate(1560.792 249.869)">
				<line id="Line_852" className="st2" x1="0" y1="0" x2="0" y2="0"/>
			</g>
			<g id="LINE-58" transform="translate(1555.13 247.488)">
				<line id="Line_853" className="st2" x1="0" y1="0" x2="0" y2="0.1"/>
			</g>
			<g id="SPLINE-162" transform="translate(1555.13 246.586)">
				<path id="Path_882" className="st2" d="M1.6,0C1.4,0,1.2,0.1,1,0.1c-0.2,0-0.3,0.1-0.5,0.2C0.4,0.4,0.3,0.5,0.2,0.6
					C0.1,0.7,0.1,0.8,0,0.9"/>
			</g>
			<g id="SPLINE-163" transform="translate(1520.756 254.414)">
				<path id="Path_883" className="st3" d="M0,0c0.2,0.3,0.4,0.5,0.7,0.8C0.9,1,1.1,1.2,1.4,1.5C1.6,1.8,1.8,2,2.1,2.3L2.7,3
					c0.2,0.3,0.4,0.5,0.6,0.7C3.5,4,3.7,4.2,3.9,4.4c0.3,0.4,0.6,0.8,0.9,1.1c0.3,0.3,0.5,0.7,0.7,1C5.7,7,6,7.4,6.2,7.8
					C6.5,8.3,6.8,8.7,7,9.2c0.3,0.5,0.5,1,0.7,1.6"/>
			</g>
			<g id="SPLINE-164" transform="translate(1526.852 270.933)">
				<path id="Path_884" className="st3" d="M0,0c0.3,0.1,0.6,0.2,1,0.3c0.6,0.1,1.1,0.2,1.7,0.3c0.6,0.1,1.2,0.1,1.7,0.1h0.6"/>
			</g>
			<g id="SPLINE-165" transform="translate(1522.524 256.361)">
				<path id="Path_885" className="st3" d="M0,0c0.1,0.5,0.3,1,0.4,1.5C0.7,2.3,0.9,3.2,1.1,4c0.1,0.7,0.3,1.3,0.4,2
					c0.1,0.5,0.2,1,0.3,1.5c0,0.3,0.1,0.5,0.1,0.8C2,8.4,2,8.6,2,8.8c0,0.3,0.1,0.5,0.1,0.7c0,0.3,0.1,0.6,0.1,1
					c0.1,0.4,0.1,0.9,0.1,1.3c0,0.1,0,0.3,0,0.5"/>
			</g>
			<g id="SPLINE-166" transform="translate(1525.049 268.588)">
				<path id="Path_886" className="st3" d="M0,0c0.1,0.4,0.2,0.7,0.3,1c0.1,0.3,0.3,0.6,0.6,0.8C1,2,1.3,2.2,1.5,2.3
					c0.1,0,0.2,0.1,0.3,0.1"/>
			</g>
			<g id="SPLINE-167" transform="translate(1528.475 265.126)">
				<path id="Path_887" className="st3" d="M0,0c0.4,0.9,0.8,1.8,1.2,2.6C1.5,3.3,1.8,4,2.2,4.7c0.3,0.5,0.6,1,0.9,1.4
					c0.3,0.3,0.5,0.6,0.8,0.9c0.1,0.1,0.3,0.3,0.4,0.4l0.3,0.3C4.8,7.9,4.9,8,5.1,8.1l0.6,0.4C6,8.7,6.3,8.9,6.6,9
					C7,9.1,7.3,9.2,7.7,9.3"/>
			</g>
			<g id="SPLINE-168" transform="translate(1517.871 249.292)">
				<path id="Path_888" className="st3" d="M0,0c0,0,0.1,0.4,0.1,0.4c0.1,0.4,0.3,0.7,0.4,1.1L1,2.6C1.3,3,1.5,3.3,1.7,3.7
					C2,4.1,2.3,4.4,2.6,4.8C2.7,4.9,2.8,5,2.9,5.1"/>
			</g>
			<g id="SPLINE-169" transform="translate(1578.827 222.384)">
				<path id="Path_889" className="st3" d="M0,12.1c1.3-0.8,2.6-1.5,3.9-2.3c1.2-0.7,2.5-1.4,3.7-2.1L10.7,6c0.9-0.5,1.7-0.9,2.6-1.4
					c0.7-0.4,1.4-0.8,2.1-1.1c0.3-0.1,0.6-0.3,0.9-0.5c0.3-0.1,0.5-0.3,0.8-0.4c0.2-0.1,0.4-0.2,0.6-0.3c0.3-0.1,0.5-0.3,0.7-0.4
					c0.4-0.2,0.7-0.4,1.1-0.6c0.5-0.3,0.9-0.5,1.4-0.8c0.4-0.2,0.7-0.4,1-0.6"/>
			</g>
			<g id="SPLINE-170" transform="translate(1556.717 221.555)">
				<path id="Path_890" className="st3" d="M1.3,8c0.2,0,0.3,0,0.5,0C2,8,2.2,8,2.5,7.9s0.4-0.1,0.6-0.1c0.2-0.1,0.4-0.1,0.6-0.2
					c0.2-0.1,0.4-0.2,0.5-0.3C4.4,7.2,4.6,7,4.7,6.9C4.9,6.7,5,6.6,5.1,6.4c0.1-0.2,0.2-0.4,0.3-0.5c0.1-0.2,0.1-0.4,0.1-0.6
					c0-0.2,0-0.4,0-0.6c0-0.2-0.1-0.4-0.2-0.6C5.1,3.6,4.9,3.2,4.5,2.8C4.4,2.6,4.2,2.4,4,2.3C3.9,2.1,3.7,1.9,3.5,1.8
					C3.3,1.6,3.1,1.5,2.9,1.3S2.4,1,2.1,0.9C2,0.8,1.7,0.7,1.6,0.6C1.4,0.5,1.2,0.5,1,0.4C0.7,0.2,0.3,0.1,0,0"/>
			</g>
			<g id="SPLINE-171" transform="translate(1548.818 220.942)">
				<path id="Path_891" className="st3" d="M7.9,0.6c-0.3-0.1-0.7-0.2-1-0.3c-0.1,0-0.3-0.1-0.4-0.1C6.2,0.2,6,0.1,5.8,0.1
					C5.5,0.1,5.3,0,5.1,0C4.8,0,4.6,0,4.4,0C4.2,0,3.9,0,3.7,0c-0.2,0-0.5,0-0.7,0.1S2.6,0.2,2.4,0.3C2.2,0.3,2,0.4,1.8,0.5
					C1.6,0.5,1.4,0.6,1.2,0.8C1,0.9,0.9,1,0.8,1.2C0.6,1.3,0.5,1.5,0.4,1.6C0.3,1.8,0.2,2,0.1,2.2C0.1,2.4,0,2.6,0,2.8
					C0,3,0,3.2,0,3.4c0,0.2,0.1,0.4,0.2,0.6c0.2,0.4,0.4,0.9,0.7,1.2c0.2,0.2,0.3,0.4,0.5,0.5C1.6,6,2,6.2,2.2,6.4"/>
			</g>
			<g id="SPLINE-172" transform="translate(1583.768 194.179)">
				<path id="Path_892" className="st3" d="M2.9,0c0,0-0.1,0.1-0.1,0.1C2.4,0.3,2.1,0.6,1.9,0.9C1.6,1.3,1.3,1.7,1,2.1
					c-0.3,0.5-0.5,1-0.7,1.6C0.1,4.3,0,4.9,0,5.6c0,0.3,0,0.7,0,1c0,0.4,0.1,0.7,0.2,1c0.1,0.4,0.3,0.7,0.4,1c0.2,0.3,0.4,0.7,0.6,1
					c0.2,0.3,0.5,0.7,0.8,0.9l0.8,0.8"/>
			</g>
			<g id="SPLINE-173" transform="translate(1589.467 190.428)">
				<path id="Path_893" className="st3" d="M5,0C4.4,0.2,3.7,0.4,3.1,0.6C2.1,1,1,1.5,0,1.9"/>
			</g>
			<g id="LINE-59" transform="translate(1557.438 229.598)">
				<line id="Line_854" className="st2" x1="0" y1="1.8" x2="0.5" y2="0"/>
			</g>
			<g id="LINE-60" transform="translate(1550.477 227.398)">
				<line id="Line_855" className="st2" x1="0.5" y1="0" x2="0" y2="1.6"/>
			</g>
			<g id="SPLINE-174" transform="translate(1574.376 234.504)">
				<path id="Path_894" className="st3" d="M0.4,6.3C0.3,6,0.2,5.7,0.1,5.4C0,5.1,0,4.8,0,4.5c0-0.3,0.1-0.6,0.3-0.8
					C0.4,3.5,0.5,3.2,0.7,3C0.9,2.8,1,2.5,1.2,2.3C1.5,2.1,1.7,1.8,2,1.6C2.4,1.3,2.7,1,3.1,0.8C3.5,0.5,4,0.3,4.4,0"/>
			</g>
			<g id="SPLINE-175" transform="translate(1563.462 210.915)">
				<path id="Path_895" className="st3" d="M28.3,0c-1,0.4-1.4,0.5-2.4,0.9c-1,0.4-2.1,0.8-3.1,1.1c-0.9,0.3-1.7,0.6-2.6,0.9
					c-0.8,0.3-1.6,0.5-2.3,0.8c-0.8,0.3-1.5,0.5-2.3,0.8c-0.5,0.2-1,0.4-1.6,0.5c-0.5,0.2-1,0.4-1.6,0.5c-0.6,0.2-1.2,0.4-1.8,0.6
					C9.9,6.5,9.1,6.7,8.4,6.9L5.8,7.8c-1,0.3-2,0.6-3,1C1.9,9.1,0.9,9.4,0,9.7"/>
			</g>
			<g id="SPLINE-176" transform="translate(1558.051 220.581)">
				<path id="Path_896" className="st3" d="M5.5,0C4.5,0.3,3.6,0.6,2.6,0.9C1.8,1.1,1,1.3,0.1,1.4H0"/>
			</g>
			<g id="SPLINE-177" transform="translate(1544.742 221.627)">
				<path id="Path_897" className="st3" d="M4.7,0.7C4,0.6,3.4,0.6,2.7,0.5C1.8,0.4,0.9,0.2,0,0"/>
			</g>
			<g id="LINE-61" transform="translate(1601.153 384.874)">
				<line id="Line_856" className="st2" x1="0" y1="0.1" x2="0.4" y2="0"/>
			</g>
			<g id="LINE-62" transform="translate(1605.59 383.647)">
				<line id="Line_857" className="st2" x1="0" y1="0.1" x2="0.4" y2="0"/>
			</g>
			<g id="SPLINE-178" transform="translate(1625.067 218.272)">
				<path id="Path_898" className="st3" d="M0,0c1.2,1.8,2.3,3.6,3.4,5.6s2.1,3.9,3.1,5.8c1,2,2,4.1,2.9,6.2c0.9,2.1,1.8,4.3,2.7,6.5
					c0.9,2.2,1.7,4.4,2.4,6.6s1.5,4.5,2.1,6.8c0.6,2.3,1.3,4.6,1.8,6.9s1,4.7,1.5,7c0.4,2.3,0.8,4.6,1.2,6.9s0.6,4.6,0.9,6.9
					c0.3,2.2,0.4,4.4,0.6,6.7c0.1,2.2,0.2,4.4,0.3,6.6c0,2.2,0,4.4,0,6.5s-0.1,4.3-0.3,6.4c-0.1,2.2-0.4,4.3-0.6,6.5
					c-1.4,12.7-4.8,25.1-9.9,36.7"/>
			</g>
			<g id="SPLINE-179" transform="translate(1586.762 205.793)">
				<path id="Path_899" className="st2" d="M0,0l0.1,0.1"/>
			</g>
			<g id="SPLINE-180" transform="translate(1586.87 205.901)">
				<path id="Path_900" className="st3" d="M0,0c1.3,1.3,2.6,2.5,3.9,3.9C4.3,4.3,4.6,4.7,4.9,5"/>
			</g>
			<g id="LINE-63" transform="translate(1600.648 222.421)">
				<line id="Line_858" className="st3" x1="0" y1="0" x2="1" y2="1.5"/>
			</g>
			<g id="SPLINE-181" transform="translate(1614.535 331.492)">
				<path id="Path_901" className="st3" d="M6.7,0C6.6,0.4,6.5,0.9,6.4,1.3C6,3.2,5.4,5.1,4.9,7C4.3,8.8,3.7,10.7,3,12.4
					c-0.6,1.7-1.3,3.5-2.1,5.1c-0.3,0.6-0.6,1.2-0.9,1.8"/>
			</g>
			<g id="SPLINE-182" transform="translate(1597.727 367.055)">
				<path id="Path_902" className="st2" d="M17.3,0c-0.3,0.1-0.5,0.3-0.9,0.5c-0.4,0.2-0.7,0.3-1.1,0.4c-0.4,0.1-0.8,0.2-1.2,0.3
					c-0.5,0.1-0.9,0.1-1.4,0.2l-1.3,0.1c-0.5,0-0.9,0.1-1.4,0.1c-0.5,0-1,0.1-1.5,0.1L7,1.8c-0.6,0-1.2,0.1-1.7,0.1
					C4.7,2,4.1,2.1,3.6,2.1C3,2.2,2.4,2.3,1.9,2.5c-0.5,0.1-1,0.3-1.5,0.4C0.3,3,0.1,3,0,3.1"/>
			</g>
			<g id="SPLINE-183" transform="translate(1615.004 363.99)">
				<path id="Path_903" className="st2" d="M1.7,0c0,0.1,0,0.2,0,0.3c0,0.3,0,0.5-0.1,0.8C1.5,1.4,1.4,1.6,1.2,1.9
					C0.9,2.2,0.7,2.5,0.4,2.7C0.2,2.8,0.1,2.9,0,3"/>
			</g>
			<g id="ARC-12" transform="translate(1586.798 205.829)">
				<path id="Path_904" className="st2" d="M0,0C0,0,0,0.1,0,0"/>
			</g>
			<g id="SPLINE-184" transform="translate(1584.332 341.158)">
				<path id="Path_905" className="st2" d="M0.2,2.7C0,2.7,0,2.6,0,2.5c0-0.1,0.1-0.3,0.2-0.4c0.2-0.2,0.3-0.4,0.5-0.5
					c0.3-0.2,0.5-0.5,0.9-0.7C1.9,0.6,2.4,0.3,2.8,0"/>
			</g>
			<g id="SPLINE-185" transform="translate(1543.624 274.576)">
				<path id="Path_906" className="st2" d="M0,0c0,0.1,0.1,0.3,0.1,0.4c0.1,0.1,0.1,0.2,0.2,0.3S0.5,0.9,0.6,1c0.1,0.1,0.2,0.2,0.3,0.3
					c0,0,0.1,0.1,0.2,0.1"/>
			</g>
			<g id="SPLINE-186" transform="translate(1543.299 264.75)">
				<path id="Path_907" className="st2" d="M0.3,9.8c0,0,0-0.1-0.1-0.1c0-0.1,0-0.1-0.1-0.2c0-0.1,0-0.1,0-0.2c0-0.1-0.1-0.2-0.1-0.4
					c0-0.1,0-0.2,0-0.3c0-0.3,0-0.5,0-0.8c0-0.2,0-0.5,0.1-0.7c0.1-0.5,0.2-1.1,0.4-1.6c0.2-0.5,0.5-1.1,0.8-1.6
					c0.3-0.5,0.7-0.9,1-1.3C2.7,2.3,3.1,2,3.6,1.6C4,1.3,4.5,1.1,4.9,0.9c0.5-0.2,0.9-0.4,1.4-0.5C6.9,0.2,7.4,0.1,8,0.1
					C8.5,0,9.1,0,9.7,0c0.6,0,1.1,0.1,1.7,0.2c0.6,0.1,1.2,0.3,1.7,0.5c0.4,0.1,0.7,0.3,1,0.4s0.7,0.3,1,0.5c0.4,0.2,0.7,0.4,1,0.6
					c0.4,0.2,0.7,0.5,1.1,0.7c0.3,0.2,0.6,0.4,0.9,0.6c0.3,0.3,0.6,0.5,0.9,0.8C19.5,4.6,19.7,4.8,20,5c0.3,0.3,0.6,0.6,1,0.9"/>
			</g>
			<g id="SPLINE-187" transform="translate(1564.219 270.716)">
				<path id="Path_908" className="st2" d="M0,0c0.2,0.1,0.3,0.3,0.5,0.5C0.7,0.6,0.8,0.8,1,1l0.5,0.5c0.2,0.2,0.4,0.4,0.5,0.6
					c0.2,0.2,0.4,0.4,0.5,0.6C2.8,2.9,3,3.1,3.2,3.3c0.2,0.2,0.4,0.4,0.6,0.6s0.4,0.4,0.6,0.6C4.7,5,5,5.4,5.4,5.8
					c0.4,0.5,0.8,1,1.2,1.5s0.8,1,1.2,1.5c0.7,1,1.4,1.9,2.1,3c1.2,1.7,2.3,3.4,3.4,5.2c0.7,1.2,1.4,2.3,2.1,3.5
					c0.8,1.4,1.6,2.7,2.3,4.1c0.9,1.6,1.7,3.2,2.5,4.9c1.6,3.2,3,6.6,4.3,10c0.6,1.7,1.3,3.4,1.8,5c0.4,1,0.7,2.1,1.1,3.2l0.5,1.6
					l0.4,1.4c0.3,0.9,0.6,1.8,0.9,2.8c0.3,0.8,0.5,1.6,0.8,2.3"/>
			</g>
			<g id="SPLINE-188" transform="translate(1587.195 326.514)">
				<path id="Path_909" className="st2" d="M6.9,0l0.2,0.6C7.1,0.9,7.2,1,7.2,1.3c0.1,0.4,0.2,0.7,0.3,1c0.1,0.5,0.2,1,0.2,1.6
					c0,0.4,0,0.8,0,1.2c0,0.4-0.1,0.8-0.2,1.2C7.3,6.9,7.1,7.6,6.8,8.2C6.6,8.6,6.3,9.1,6.1,9.5c-0.3,0.4-0.6,0.8-0.9,1.2
					c-0.4,0.4-0.8,0.9-1.2,1.2c-0.4,0.4-0.9,0.7-1.3,1c-0.2,0.1-0.4,0.3-0.6,0.5c-0.3,0.2-0.5,0.3-0.8,0.5C1.2,14,1.1,14.1,1,14.1
					c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.2,0.2-0.4,0.2c-0.1,0-0.2,0.1-0.3,0.1"/>
			</g>
			<g id="SPLINE-189" transform="translate(1541.898 244.999)">
				<path id="Path_910" className="st2" d="M8.1,3.7C8,3.8,7.8,4,7.6,4C7.4,4.1,7.1,4.2,6.9,4.3c-0.3,0-0.5,0.1-0.8,0.1
					c-0.3,0-0.6,0-0.8,0C5,4.3,4.7,4.2,4.4,4.2C4.1,4.1,3.9,4,3.5,3.9C3.2,3.8,2.9,3.7,2.7,3.6C2.4,3.4,2.1,3.3,1.9,3.1
					c-0.4-0.3-0.8-0.6-1.2-1C0.5,2,0.4,1.8,0.3,1.5C0.2,1.4,0.1,1.1,0,0.9c0-0.3,0-0.6,0-0.9"/>
			</g>
			<g id="SPLINE-190" transform="translate(1550.044 247.921)">
				<path id="Path_911" className="st2" d="M0.6,0L0.6,0c0,0.1,0,0.2-0.1,0.2c0,0.1-0.1,0.1-0.1,0.2C0.3,0.5,0.1,0.7,0,0.8"/>
			</g>
			<g id="SPLINE-191" transform="translate(1555.274 248.787)">
				<path id="Path_912" className="st2" d="M5.5,1.1L5.5,1.1c0,0.1-0.1,0.2-0.2,0.3C5.3,1.5,5.2,1.6,5,1.7C4.9,1.8,4.8,1.8,4.6,1.9
					C4.5,1.9,4.3,1.9,4.2,2C4,2,3.8,2,3.6,2C3.4,2,3.3,2,3.1,1.9c-0.2,0-0.4-0.1-0.6-0.2C2.2,1.7,2,1.6,1.8,1.5
					C1.6,1.4,1.4,1.3,1.3,1.2C1.1,1.1,0.9,0.9,0.7,0.8c0,0,0,0,0,0c0,0,0,0,0,0l0,0c-0.1,0-0.1-0.1-0.2-0.1C0.3,0.4,0.1,0.2,0,0"/>
			</g>
			<g id="SPLINE-192" transform="translate(1555.058 247.416)">
				<path id="Path_913" className="st2" d="M0.3,1.3C0.1,1.1,0,0.8,0,0.6C0,0.4,0.1,0.2,0.1,0"/>
			</g>
			<g id="SPLINE-193" transform="translate(1530.652 239.084)">
				<path id="Path_914" className="st2" d="M8.5,3.2C8.1,3.4,7.7,3.6,7.3,3.7C6.8,3.8,6.2,3.9,5.7,3.9c-0.2,0-0.3,0-0.5,0
					c-0.2,0-0.3,0-0.5-0.1c-0.3,0-0.6-0.1-0.9-0.2C3.6,3.5,3.3,3.4,3,3.4L2.3,3C2,2.9,1.8,2.8,1.6,2.6S1.1,2.3,1,2.2
					C0.8,2,0.6,1.8,0.5,1.7C0.4,1.5,0.2,1.3,0.2,1.1C0.1,1,0.1,0.8,0,0.6c0-0.2,0-0.4,0-0.5c0,0,0,0,0-0.1"/>
			</g>
			<g id="SPLINE-194" transform="translate(1539.115 241.465)">
				<path id="Path_915" className="st2" d="M0.5,0L0.5,0c0,0.1-0.1,0.2-0.1,0.3C0.3,0.5,0.2,0.6,0,0.8"/>
			</g>
			<g id="SPLINE-195" transform="translate(1537.42 230.284)">
				<path id="Path_916" className="st2" d="M0,0.3c0.1,0,0.1,0,0.2-0.1c0.1,0,0.1,0,0.2,0s0.1,0,0.2,0s0.1,0,0.2,0s0.1,0,0.2,0
					c0.1,0,0.1,0,0.2,0C1.4,0,1.6,0,1.7,0L3,0c0.4,0,0.7,0,1.1,0.1c0.4,0,0.9,0.1,1.3,0.2c0.5,0.1,0.9,0.2,1.3,0.3
					C7,0.7,7.3,0.8,7.6,0.9C7.8,0.9,8.1,1,8.4,1.2c0.1,0,0.3,0.1,0.4,0.1c0.1,0,0.3,0.1,0.4,0.1c0.1,0.1,0.2,0.1,0.4,0.1
					c0.1,0,0.2,0.1,0.3,0.1"/>
			</g>
			<g id="SPLINE-196" transform="translate(1539.187 237.461)">
				<path id="Path_917" className="st2" d="M10.6,6c-0.4-0.2-0.8-0.5-1.2-0.7C9.1,5.1,8.7,4.8,8.3,4.6C7.9,4.4,7.5,4.1,7.1,3.9
					S6.3,3.5,6,3.2L4.8,2.6L3.6,1.9L2.4,1.3L1.2,0.6C0.8,0.4,0.4,0.2,0,0"/>
			</g>
			<g id="SPLINE-197" transform="translate(1549.792 243.377)">
				<path id="Path_918" className="st2" d="M11.5,0.6c0,0,0,0.1-0.1,0.1l-0.1,0.1l-0.1,0.1L11.1,1L11,1.2c0,0-0.1,0.1-0.1,0.1
					c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.3,0.1-0.5,0.2S9.6,1.9,9.4,1.9C9.2,2,8.9,2,8.7,2.1c-0.5,0.1-1,0.1-1.4,0.1
					C6.9,2.1,6.4,2.1,6,2C5.6,2,5.2,1.9,4.7,1.8c-0.5-0.1-1-0.3-1.6-0.4L2.5,1.2C2.3,1.1,2.1,1,1.8,0.9C1.7,0.8,1.6,0.8,1.4,0.7
					C1.3,0.6,1.1,0.6,1,0.5C0.9,0.5,0.7,0.4,0.6,0.4S0.4,0.3,0.3,0.2C0.2,0.1,0.1,0.1,0,0"/>
			</g>
			<g id="SPLINE-198" transform="translate(1557.835 238.038)">
				<path id="Path_919" className="st2" d="M0,0c0.1,0,0.1,0.1,0.2,0.1s0.1,0.1,0.2,0.1s0.1,0.1,0.2,0.1s0.1,0.1,0.2,0.1
					c0.1,0,0.1,0.1,0.2,0.1C1,0.6,1,0.7,1.1,0.7C1.3,0.9,1.5,1,1.7,1.2C1.8,1.3,2,1.5,2.2,1.7c0.1,0.1,0.3,0.3,0.4,0.4l0.3,0.4
					C3,2.6,3.1,2.8,3.2,3c0.1,0.1,0.2,0.3,0.3,0.5C3.6,3.6,3.6,3.8,3.7,4c0.1,0.2,0.1,0.4,0.1,0.6v0.3c0,0.1,0,0.2,0,0.3
					c0,0.1,0,0.2-0.1,0.3c0,0.1,0,0.2-0.1,0.3S3.5,5.8,3.5,5.9"/>
			</g>
			<g id="SPLINE-199" transform="translate(1547.195 232.087)">
				<path id="Path_920" className="st2" d="M0,0c0.4,0.2,0.8,0.4,1.2,0.6S2,1,2.4,1.2l1.2,0.6l1.2,0.6L6,3.2c0.4,0.2,0.8,0.4,1.2,0.7
					c0.4,0.2,0.8,0.5,1.2,0.7S9.1,5,9.5,5.2s0.8,0.5,1.2,0.7"/>
			</g>
			<g id="SPLINE-200" transform="translate(1550.426 228.949)">
				<path id="Path_921" className="st2" d="M6.6,2.8C6.5,2.9,6.3,3,6.1,3c-0.2,0-0.3,0-0.5,0c-0.4,0-0.9,0-1.3-0.1C3.9,2.8,3.5,2.7,3,2.6
					C2.6,2.4,2.3,2.2,1.9,2.1c-0.3-0.2-0.7-0.4-1-0.6C0.6,1.3,0.4,1,0.2,0.8C0.2,0.7,0.1,0.5,0.1,0.4C0,0.3,0,0.2,0,0.1
					c0,0,0-0.1,0-0.1"/>
			</g>
			<g id="SPLINE-201" transform="translate(1557.041 231.365)">
				<path id="Path_922" className="st2" d="M0.4,0c0,0,0,0.1,0,0.1c0,0.1-0.1,0.1-0.1,0.1C0.2,0.3,0.1,0.4,0,0.4"/>
			</g>
			<g id="LINE-64" transform="translate(1536.085 274.359)">
				<line id="Line_859" className="st2" x1="0.1" y1="0" x2="0" y2="0"/>
			</g>
			<g id="SPLINE-202" transform="translate(1606.419 346.893)">
				<path id="Path_923" className="st2" d="M0.2,5.6c0-0.2-0.1-0.3-0.1-0.5c0-0.2,0-0.3-0.1-0.5c0-0.2,0-0.4,0-0.5l0-0.5
					c0-0.2,0-0.3,0-0.5c0-0.2,0-0.3,0-0.5c0-0.2,0-0.3,0.1-0.5c0-0.1,0-0.1,0-0.2c0-0.1,0-0.2,0.1-0.2c0-0.1,0-0.1,0.1-0.2
					s0-0.1,0.1-0.2c0-0.1,0.1-0.2,0.1-0.4c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.1-0.2,0.2-0.3C1,0.3,1.1,0.1,1.2,0.1c0,0,0.1,0,0.1-0.1"/>
			</g>
			<g id="SPLINE-203" transform="translate(1606.636 352.52)">
				<path id="Path_924" className="st2" d="M2.8,4.4c0,0-0.1,0-0.1,0C2.5,4.3,2.3,4.2,2.1,4C1.9,3.9,1.7,3.7,1.6,3.5
					C1.4,3.3,1.2,3,1.1,2.8C0.9,2.5,0.7,2.2,0.6,1.9C0.5,1.7,0.4,1.3,0.3,1S0.1,0.3,0,0"/>
			</g>
			<g id="SPLINE-204" transform="translate(1555.31 248.751)">
				<path id="Path_925" className="st2" d="M0,0c0.3,0.4,0.7,0.8,1.1,1.1"/>
			</g>
			<g id="LINE-65" transform="translate(1526.852 270.933)">
				<line id="Line_860" className="st2" x1="0" y1="0" x2="0" y2="0"/>
			</g>
			<g id="LINE-66" transform="translate(1586.437 192.339)">
				<path id="Path_926" className="st3" d="M0,2l0.2-0.2C1.1,1.1,2,0.5,3.1,0"/>
			</g>
			<g id="ARC-13" transform="translate(1586.69 205.721)">
				<path id="Path_927" className="st2" d="M0,0C0,0,0,0.1,0,0"/>
			</g>
			<g id="SPLINE-205" transform="translate(1594.48 190.067)">
				<path id="Path_928" className="st3" d="M11.5,4.5c-0.1-0.1-0.3-0.3-0.4-0.4c-0.1-0.1-0.3-0.3-0.4-0.4s-0.3-0.3-0.5-0.4
					C10,3.2,9.9,3.1,9.8,3C9.6,2.9,9.5,2.8,9.4,2.7L8.9,2.3C8.6,2.1,8.2,1.8,7.9,1.6C7.7,1.5,7.6,1.4,7.4,1.3C7.3,1.3,7.1,1.2,7,1.1
					C6.8,1,6.6,0.9,6.4,0.8c-0.1,0-0.2-0.1-0.3-0.1L5.8,0.6c-0.1,0-0.3-0.1-0.4-0.1L5,0.4c-0.1,0-0.3-0.1-0.4-0.1s-0.2,0-0.3-0.1
					c-0.1,0-0.2,0-0.3,0c-0.2,0-0.4-0.1-0.6-0.1C3.3,0,3.1,0,2.9,0C2.8,0,2.6,0,2.5,0C2,0,1.4,0,0.9,0.1c-0.2,0-0.5,0.1-0.7,0.1
					C0.2,0.3,0.1,0.3,0,0.3"/>
			</g>
			<g id="SPLINE-206" transform="translate(1601.514 383.755)">
				<path id="Path_929" className="st3" d="M0,1.1C0.3,1,0.5,1,0.8,0.9c0.5-0.1,1-0.3,1.5-0.4s1-0.3,1.4-0.4C3.8,0.1,4,0.1,4.1,0"/>
			</g>
			<g id="SPLINE-207" transform="translate(1601.658 223.935)">
				<path id="Path_930" className="st3" d="M0,0c1.1,1.8,2.2,3.5,3.3,5.4c1,1.8,2.1,3.8,3.1,5.7s1.9,3.9,2.8,6c0.9,2,1.8,4.1,2.6,6.2
					c0.8,2.1,1.6,4.2,2.3,6.4c0.7,2.2,1.4,4.3,2.1,6.6c0.6,2.2,1.2,4.4,1.8,6.7s1,4.5,1.5,6.8s0.9,4.5,1.2,6.9
					c0.4,2.3,0.6,4.6,0.9,6.9c0.3,2.3,0.5,4.6,0.6,6.9s0.3,4.5,0.3,6.8s0,4.5,0,6.7c-0.1,2.2-0.2,4.4-0.3,6.6
					c-0.2,2.2-0.4,4.3-0.6,6.4s-0.6,4.2-0.9,6.2c-0.3,1.6-0.6,3.2-1,4.7"/>
			</g>
			<g id="LINE-67" transform="translate(1539.115 237.425)">
				<line id="Line_861" className="st2" x1="0.1" y1="0" x2="0" y2="0"/>
			</g>
			<g id="SPLINE-208" transform="translate(1535.148 230.608)">
				<path id="Path_931" className="st2" d="M2.4,5.8L2.4,5.8C2.3,5.7,2.2,5.6,2.1,5.6C2,5.5,1.9,5.4,1.8,5.3C1.7,5.3,1.6,5.2,1.6,5.1
					C1.5,5,1.4,5,1.3,4.9C1.2,4.8,1.2,4.7,1.1,4.6S0.9,4.4,0.9,4.4C0.8,4.3,0.7,4.2,0.7,4.1C0.6,4,0.6,3.9,0.5,3.9
					C0.4,3.7,0.3,3.6,0.3,3.4C0.2,3.2,0.1,3.1,0.1,2.9C0,2.7,0,2.5,0,2.3c0-0.3,0-0.5,0.1-0.8c0.1-0.2,0.2-0.5,0.4-0.6
					C0.8,0.7,1,0.5,1.3,0.4c0.3-0.2,0.6-0.3,1-0.4"/>
			</g>
			<g id="SPLINE-209" transform="translate(1556.464 249.869)">
				<path id="Path_933" className="st2" d="M0,0c0.3,0.2,0.7,0.4,1,0.5c0.3,0.1,0.6,0.2,0.9,0.3c0.3,0.1,0.6,0.1,0.9,0.1
					c0.3,0,0.5-0.1,0.8-0.1c0.2-0.1,0.4-0.2,0.5-0.4C4.2,0.3,4.3,0.1,4.3,0"/>
			</g>
			<g id="ARC-15" transform="translate(1528.475 265.126)">
				<path id="Path_934" className="st2" d="M0,0"/>
			</g>
		</g>
	  </svg>
	);
}

export function PairingUIIcon_Tracker( bHighlightPairingControls: boolean )
{
	return (
	<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 124.4 96.4" className="ViveTrackerPairingSVG">
		<path id="Path_690" className="st0" d="M17.7,76.5c5.5,11.5,27.7,20.6,54.5,18c42-4,51-23.6,50.8-37.2c0-1.7-0.5-3.4-1.2-4.9
			c0-0.3-0.1-0.7-0.1-1c1.3-5.2-0.7-9.5-5-11.8c-2.8-1.4-6-2-9.1-1.6c0,0,0,0-0.1-0.1c0,0-3.9-5.1-4.6-8.5c-0.7-3.5-2.7-15-2.7-15
			C99.2,9,96.1,3.4,88.8,2.7L72.9,1.5c-4.7,0-9,2.9-10.7,7.3c0,0-5.4,14.7-6.4,17.7c-1,2.9-2.6,7.2-12.7,11c-4.7,1.7-9.4,3.7-13.9,6
			l-6-7c-4-4.7-9.5-8.2-16.7-4.4l-2,1.6C-5.2,39.7,16.7,75.2,17.7,76.5L17.7,76.5z"/>
		<path id="Path_691" className="st1" d="M5.6,33.1c1.3,0,2.6,0.6,3.5,1.5c4.3,4.2,0.4,6.3,2.1,14.6c0.9,2.6,2.1,5.1,3.6,7.5
			c2.4,3.4,10.4,15.2,10.4,15.2c3.2,4.4,7.9,7.5,13.3,8.8c9.1,2.3,36,6.3,45.4-2.6c5.7-5.5,10.2-12.1,13.3-19.4c0.9-2,1.7-4,2.3-6.2
			c0.7-2.5,1.8-8.5,10-10.6c8.2-2.1,11.7,0.9,12.5,5.3"/>
		<path id="Path_692" className="st2" d="M121.5,51.4c0,0-1.7,13.6,1.1,7.8"/>
		<path id="Path_693_2_" className="st1" d="M29,43.8c0,0,3,3.8,4.4,4.9c1.4,1.1,4.1,0.9,4.1,0.9"/>
		<path id="Path_695" className={ bHighlightPairingControls ? "st3" : "st0" } d="M78.9,55.1c-0.3,0.2-1.2,0.5-1.9,0.9c-0.8,0.4-1.7,0.6-2.6,0.6C74,56.5,54.9,55,54.9,55
			c-0.5-0.1-0.9-0.1-1.1-0.4c-0.5-0.7-0.8-1.1-0.9-1.4l0-0.7c0.1-0.3,0.3-0.5,0.5-0.7L67,45.4c0.7-0.4,1.4-0.6,2.2-0.6l4.2,0.2
			c0.2,0,0.3,0.1,0.4,0.3l5.5,8.8l-0.1,0.6C79.2,54.7,79.1,55,78.9,55.1z"/>
		<path id="Path_696" className={ bHighlightPairingControls ? "st3" : "st0" } d="M79.1,54c-0.1,0.1-0.1,0.3-0.3,0.3c-0.3,0.2-1.2,0.5-1.9,0.9c-0.8,0.4-1.7,0.6-2.6,0.6
			c-0.4,0-18.9-1.4-18.9-1.4c-1.4-0.2-1.3,0-2.2-1.6"/>
		<path id="Path_697" className="st4" d="M74.4,52.3c-0.7,1.1-3.3,2-7.8,1.7c-5.2-0.4-7.9-1.3-7.6-2.2c0.8-2,7.5-4.6,10.1-4.4
			C74.1,47.7,74.8,51.5,74.4,52.3z"/>
		<path id="Path_698" className="st4" d="M59.3,52.4c0.8-2,7-4.7,9.6-4.5c4.9,0.4,5.7,4.1,4.8,5.1"/>
		<path id="Path_699" className="st2" d="M80,4.9c-0.3,0.4-0.8,0.6-1.3,0.4c-0.6-0.1-0.8-0.5-0.7-0.8c0.3-0.4,0.8-0.6,1.3-0.5
			C79.8,4.2,80.1,4.6,80,4.9z"/>
		<path id="Path_700" className="st5" d="M73.5,59.9"/>
		<g>
			<path id="Path_701" className="st6" d="M73.3,64.1c0,0,5.8,2,10.1-5.9l3.3-5.1c1.6-3.1,3.8-5.8,6.5-8.1c6.2-4.8,14.5-6.6,14.5-6.6"/>
		</g>
	</svg>
	);
}

export function PairingUIIcon_Wand( bHighlightPairingControls: boolean )
{
	return (
		<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="512 241 200 310" className="ViveWandPairingSVG">
			<path className="st0" d="M690.1,291.8c0,0-19.2-24.5-30.6-33.4c-5.7-5.4-13.1-10-23.6-12.8l0,0c-1.1-0.3-2.2-0.5-3.3-0.8h-0.1
				c-1.1-0.2-2.2-0.5-3.4-0.7c-0.1,0-0.1,0-0.2,0c-1.1-0.2-2.3-0.4-3.4-0.5c-0.1,0-0.2,0-0.2,0c-1.1-0.2-2.3-0.3-3.5-0.4
				c-0.1,0-0.2,0-0.3,0c-1.2-0.1-2.3-0.2-3.5-0.3c-0.1,0-0.2,0-0.4,0c-1.2-0.1-2.3-0.1-3.5-0.1c-0.1,0-0.3,0-0.4,0c-0.6,0-1.2,0-1.8,0
				l0,0l0,0c-0.6,0-1.2,0-1.8,0c-0.1,0-0.3,0-0.4,0c-1.2,0-2.4,0.1-3.5,0.1c-0.1,0-0.2,0-0.4,0c-1.2,0.1-2.3,0.2-3.5,0.3
				c-0.1,0-0.2,0-0.3,0c-1.2,0.1-2.3,0.2-3.5,0.4c-0.1,0-0.2,0-0.2,0c-1.2,0.2-2.3,0.3-3.4,0.5c-0.1,0-0.1,0-0.2,0
				c-1.1,0.2-2.3,0.4-3.4,0.7h-0.1c-1.1,0.2-2.2,0.5-3.3,0.8l0,0c-10.5,2.8-17.7,7.6-23.6,12.8c-11.4,8.9-30.6,33.4-30.6,33.4
				c-3.9,5.2-5.5,9.1-5.3,14.4c0.1,3.3,0.7,7.6,4.1,10.1l6.6,4.2c4.7,2.9,7.3,3.4,11.1-1c4.1-4.6,9.7-9,9.7-9l0.2-0.2
				c2.5,1.9,5.6,4.3,7.3,5.7c6,5,8.2,17.7,9.1,25.6c3.5,58.4,6.9,127.4,10.4,183c0.2,2.5,0.6,4.9,1.3,7.2c2.8,9.2,9.9,16.4,22.2,17
				c0.5,0,1,0,1.4,0l0,0l0,0c0.5,0,1,0,1.4,0c12.3-0.5,19.4-7.7,22.2-17c0.7-2.3,1.2-4.7,1.3-7.2c3.5-55.6,6.9-124.5,10.4-183
				c0.8-7.9,3.1-20.6,9.1-25.6c1.7-1.4,4.8-3.9,7.3-5.7l0.2,0.2c0,0,5.6,4.3,9.7,9c3.8,4.4,6.4,3.9,11.1,1l6.6-4.2
				c3.4-2.5,4-6.9,4.1-10.1C695.6,300.9,694,297,690.1,291.8z"/>
			<path className="st0" d="M659.8,258.8c2.2,2.8,3.4,5.7,3.4,8.9c0,13.7-22.8,24.7-51.3,24.7s-51.2-11.1-51.2-24.7c0-2.8,1-5.5,2.8-8.1"/>
			<path className="st0" d="M655.8,266.6c0,7.9-6.7,21.6-43.8,21.6c-35,0-43.8-13.7-43.8-21.6c0-7.6,14.3-20,43.8-20
				C642.9,246.6,655.8,259.1,655.8,266.6z"/>
			<path className={ bHighlightPairingControls ? "st1" : "st0" } d="M619.5,330.7c0,4.1-3.3,7.5-7.5,7.5l0,0c-4.1,0-7.5-3.3-7.5-7.5l0,0c0-4.1,3.3-7.5,7.5-7.5l0,0 C616.1,323.2,619.5,326.5,619.5,330.7L619.5,330.7z"/>
			<path className={ bHighlightPairingControls ? "st1" : "st0" } d="M619.5,427.1c0,4.1-3.3,7.5-7.5,7.5l0,0c-4.1,0-7.5-3.3-7.5-7.5l0,0c0-4.1,3.3-7.5,7.5-7.5l0,0 C616.1,419.6,619.5,423,619.5,427.1L619.5,427.1z"/>
			<path className="st0" d="M641.7,372c0,16.4-13.3,29.8-29.8,29.8l0,0c-16.4,0-29.8-13.3-29.8-29.8l0,0c0-16.4,13.3-29.8,29.8-29.8l0,0
				C628.4,342.2,641.7,355.5,641.7,372L641.7,372z"/>
			<path className="st2" d="M643.2,384.8c0,17.3-14,31.2-31.2,31.2l0,0c-17.3,0-31.2-14-31.2-31.2v-13.4c0-17.3,14-31.2,31.2-31.2l0,0
				c17.3,0,31.2,14,31.2,31.2V384.8z"/>
			<path className="st3" d="M613.2,439.1c0,0.7-0.5,1.2-1.2,1.2s-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2S613.2,438.4,613.2,439.1z"/>
			<path className="st0" d="M534.2,316.1c1,0.1,2.5-0.1,4.5-1.8l8.8-8.2c2.4-2,3.9-2,6.9-0.1l6.7,4.8"/>
			<path className="st0" d="M690,315.9c-1,0.1-2.5-0.1-4.5-1.8l-8.8-8.2c-2.4-2-3.9-2-6.9-0.1l-6.7,4.8"/>
			<path className="st4" d="M584.3,283.5c0-7.2,12.5-13,27.9-13s28,5.8,28,13"/>
			<path className="st3" d="M586.4,284.4c1.6-5.7,12.6-10.1,25.9-10.1c13.4,0,24.5,4.5,25.9,10.2"/>
			<g>
				<polyline className="st5" points="588.9,285.3 588.9,285.2 589.3,284.7 589.7,284.2 590.2,283.6 590.7,283.1 591.2,282.7 591.4,282.6
					"/>
				<polyline className="st5" points="632.9,282.6 633.1,282.8 633.7,283.3 634.3,283.9 634.8,284.4 635.2,285 635.4,285.3 	"/>
				<polyline className="st5" points="670.5,311.7 670.7,311.4 670.9,311.2 671.1,311 671.4,310.7 671.6,310.5 671.9,310.4 672.2,310.2
					672.4,310 672.7,309.9 	"/>
				<polyline className="st5" points="551.5,309.9 551.8,310 552.1,310.2 552.4,310.4 552.6,310.5 552.9,310.8 553.1,311 553.3,311.2
					553.5,311.4 553.7,311.7 	"/>
				<polyline className="st5" points="549.8,309.3 550.1,309.4 550.4,309.4 550.7,309.5 551,309.6 551.3,309.7 551.5,309.9 	"/>
				<polyline className="st5" points="546.8,318.9 546.4,318.8 546,318.6 545.5,318.5 545.1,318.3 544.7,318.1 544.4,317.9 	"/>
				<polyline className="st5" points="631.2,281.5 631.9,281.9 632.5,282.3 632.9,282.6 	"/>
				<polyline className="st5" points="672.7,309.9 673,309.7 673.3,309.6 673.5,309.5 673.8,309.4 674.1,309.4 674.4,309.3 	"/>
				<polyline className="st5" points="544.4,317.9 543.9,317.5 543.4,317.1 543,316.7 542.7,316.3 542.4,315.8 542.2,315.3 542,314.8
					541.9,314.3 541.8,313.8 541.9,313.3 542,312.9 542.1,312.4 542.4,311.9 542.6,311.5 543,311.1 543.4,310.7 543.9,310.3 544.3,310
					544.9,309.8 545.4,309.6 546,309.4 546.6,309.2 547.3,309.2 547.9,309.1 548.5,309.1 549.2,309.2 549.8,309.3 	"/>
				<polyline className="st5" points="553.7,311.7 553.8,311.8 553.9,311.9 553.9,312 554,312.1 554.1,312.2 554.1,312.3 	"/>
				<polyline className="st5" points="670.1,312.3 670.2,312.2 670.3,312.1 670.3,312 670.4,311.9 670.5,311.8 670.5,311.7 	"/>
				<polyline className="st5" points="627,287.2 626.7,287 626.4,286.7 	"/>
				<polyline className="st5" points="626.4,286.7 626.1,286.3 625.8,285.9 	"/>
				<polyline className="st5" points="625.8,285.9 625.5,285.5 625.3,285.1 625.1,284.7 625,284.3 624.9,283.8 624.9,283.4 625,283
					625.1,282.6 625.3,282.3 625.6,282 625.9,281.7 626.2,281.5 626.6,281.2 627.1,281.1 627.6,280.9 628.1,280.9 628.7,280.8
					629.3,280.9 629.9,281 630.5,281.2 631.2,281.5 	"/>
				<polyline className="st5" points="593.1,281.5 593.5,281.3 593.9,281.1 594.4,281 594.8,280.9 595.3,280.9 595.7,280.8 596.1,280.9
					596.5,280.9 596.9,281 597.3,281.1 597.6,281.2 597.9,281.4 598.2,281.6 598.5,281.8 598.7,282 598.9,282.3 599.1,282.5
					599.2,282.8 599.3,283.2 599.4,283.5 599.4,283.8 599.3,284.2 599.2,284.6 599,285 598.8,285.4 598.6,285.7 	"/>
				<polyline className="st5" points="598.6,285.7 598.3,286.1 598,286.4 597.7,286.8 597.4,287.1 597.3,287.2 	"/>
				<polyline className="st5" points="554.1,312.3 554.2,312.5 554.3,312.8 554.3,313 554.3,313.2 554.3,313.4 554.3,313.6 554.3,313.8
					554.2,314 554.2,314.2 554.1,314.4 554,314.6 553.9,314.8 553.7,314.9 553.6,315.1 553.5,315.3 553.3,315.6 553.1,315.8 552.9,316
					552.7,316.2 552.4,316.5 552.2,316.7 551.9,316.9 551.6,317.2 551.3,317.4 551,317.7 550.7,317.9 550.3,318.1 550,318.3
					549.6,318.5 549.2,318.6 548.9,318.8 548.5,318.9 548,319 547.6,319 547.2,318.9 546.8,318.9 	"/>
				<polyline className="st5" points="679.9,317.9 679.5,318.1 679.1,318.3 678.7,318.5 678.3,318.6 677.9,318.8 677.5,318.9 	"/>
				<polyline className="st5" points="674.4,309.3 675.1,309.2 675.7,309.1 676.4,309.1 677,309.2 677.6,309.2 678.3,309.4 678.8,309.6
					679.4,309.8 679.9,310 680.4,310.3 680.9,310.7 681.3,311.1 681.6,311.5 681.9,311.9 682.1,312.4 682.3,312.9 682.4,313.3
					682.4,313.8 682.4,314.3 682.3,314.8 682.1,315.3 681.9,315.8 681.6,316.3 681.2,316.7 680.8,317.1 680.4,317.5 679.9,317.9 	"/>
				<polyline className="st5" points="677.5,318.9 677.1,318.9 676.6,319 676.2,319 675.8,318.9 675.4,318.8 675,318.7 674.7,318.5
					674.3,318.3 673.9,318.1 673.6,317.9 673.3,317.7 673,317.5 672.7,317.2 672.4,317 672.1,316.7 671.8,316.5 671.6,316.2 671.4,316
					671.2,315.8 671,315.6 670.8,315.3 670.6,315.1 670.5,314.9 670.4,314.7 670.3,314.6 670.2,314.4 670.1,314.2 670,314 670,313.8
					669.9,313.6 669.9,313.4 669.9,313.2 669.9,313 670,312.8 670.1,312.5 670.1,312.3 	"/>
				<polyline className="st5" points="591.4,282.6 591.8,282.2 592.4,281.9 593.1,281.5 	"/>
				<polyline className="st5" points="687.3,298.4 686.9,297.8 686.4,297.1 686,296.5 685.7,296 	"/>
				<polyline className="st5" points="538.6,296 538.2,296.5 537.8,297.1 537.4,297.8 536.9,298.4 	"/>
				<polyline className="st5" points="665.3,299.9 665.3,299.9 665.3,299.9 665.3,299.9 665.3,299.9 665.4,299.9 665.4,299.9 	"/>
				<polyline className="st5" points="656.7,302.8 656.6,302.2 656.5,301.5 656.4,300.8 656.5,300.2 656.5,299.6 656.7,299.1 656.9,298.6
					657.1,298.1 657.3,297.7 657.7,297.3 658,297 658.4,296.7 658.8,296.5 659.2,296.3 659.6,296.2 660.1,296.2 660.6,296.2
					661.1,296.3 661.6,296.5 662.1,296.7 662.6,297 663.1,297.4 663.6,297.8 664,298.3 664.5,298.8 664.9,299.3 665.3,299.9 	"/>
				<polyline className="st5" points="655.5,269 655.3,269.4 655,269.8 654.8,270.2 654.6,270.6 654.3,271 654,271.4 653.8,271.7
					653.5,272.1 653.2,272.4 652.9,272.8 652.7,273.1 652.4,273.3 	"/>
				<polyline className="st5" points="651.5,265.6 651.8,265.3 652.1,265.1 652.4,264.8 652.7,264.6 653,264.4 653.3,264.3 653.6,264.1
					653.9,264 654.1,263.9 654.4,263.9 654.6,263.8 654.9,263.8 	"/>
				<polyline className="st5" points="652.4,273.3 652,273.7 651.7,274 651.4,274.3 651,274.6 650.7,274.8 650.4,275 650.1,275.1
					649.9,275.2 649.6,275.2 649.4,275.2 649.2,275.2 649,275.1 648.8,274.9 648.6,274.7 648.5,274.5 648.4,274.1 648.3,273.7
					648.3,273.3 648.3,272.8 648.4,272.3 648.4,271.8 648.5,271.3 648.7,270.7 648.9,270.1 649,269.6 649.3,269 649.5,268.5
					649.8,267.9 650.1,267.4 650.4,266.9 650.7,266.5 651.1,266 651.5,265.6 	"/>
				<polyline className="st5" points="661.1,275.2 661,274.9 660.9,274.7 660.9,274.4 660.8,274.2 660.8,273.9 660.7,273.7 660.7,273.5
					660.7,273.2 660.7,273 660.7,272.8 660.8,272.5 660.8,272.3 660.9,272.1 660.9,271.9 661,271.7 661.1,271.5 661.2,271.3
					661.3,271.2 661.4,271 661.6,270.9 661.7,270.7 661.9,270.6 662,270.5 662.2,270.5 662.3,270.4 662.5,270.4 662.6,270.4
					662.8,270.4 663,270.4 663.1,270.5 	"/>
				<polyline className="st5" points="654.9,263.8 655,263.8 655.1,263.9 655.2,263.9 655.3,263.9 655.4,264 655.5,264 655.6,264.1
					655.7,264.2 655.8,264.3 655.8,264.4 655.9,264.5 656,264.6 656.1,264.7 656.1,264.8 656.2,264.9 656.2,265 656.3,265.2
					656.3,265.3 656.3,265.4 656.4,265.6 656.4,265.7 656.4,265.9 656.4,266 656.4,266.1 656.4,266.3 656.4,266.4 656.4,266.6
					656.3,266.7 656.3,266.9 656.3,267 656.2,267.1 656.2,267.3 656.2,267.4 656.1,267.6 656.1,267.7 656,267.8 656,268 655.9,268.1
					655.9,268.3 655.8,268.4 655.8,268.5 655.7,268.6 655.6,268.8 655.6,268.9 655.5,269 	"/>
				<polyline className="st5" points="688.3,299.5 687.8,299 687.3,298.4 	"/>
				<polyline className="st5" points="657.7,305.1 657.5,304.8 657.3,304.4 657.1,304 657,303.6 656.8,303.2 656.7,302.8 	"/>
				<polyline className="st5" points="665.7,305.4 665.5,305.8 665.3,306.1 665,306.4 664.8,306.7 664.5,307 664.2,307.2 663.8,307.4
					663.5,307.6 663.2,307.8 	"/>
				<polyline className="st5" points="663.2,307.8 662.8,307.9 662.5,308 662.1,308 661.8,308 661.4,308 661.1,307.9 660.7,307.8
					660.3,307.6 659.9,307.4 659.5,307.2 659.1,306.9 658.8,306.5 658.4,306.1 658,305.6 657.7,305.1 	"/>
				<polyline className="st5" points="688.4,292.8 688.8,293.4 689.3,294 689.7,294.5 690.1,295.2 690.5,295.8 690.9,296.4 691.2,297
					691.5,297.6 691.8,298.2 692,298.7 692.2,299.2 692.3,299.7 692.4,300.1 692.5,300.4 692.5,300.7 692.5,301 692.4,301.2
					692.3,301.4 692.2,301.5 692.1,301.6 692,301.7 691.8,301.7 691.6,301.7 691.4,301.7 	"/>
				<polyline className="st5" points="691.4,301.7 691.2,301.7 691,301.6 690.8,301.5 690.5,301.4 690.3,301.2 690,301 689.7,300.8
					689.5,300.6 689.2,300.4 688.9,300.1 688.6,299.8 688.3,299.5 	"/>
				<polyline className="st5" points="665.4,300.2 665.7,300.8 665.9,301.3 666.1,301.9 666.2,302.5 666.3,303.1 666.3,303.7 666.2,304.3
					666,304.9 665.7,305.4 	"/>
				<polyline className="st5" points="665.3,299.9 665.3,300 665.3,300 665.3,300.1 665.4,300.1 665.4,300.2 665.4,300.2 	"/>
				<polyline className="st5" points="663.7,279.8 663.3,279.3 663,278.8 662.6,278.3 662.3,277.8 662,277.2 661.7,276.7 661.5,276.2
					661.3,275.7 661.1,275.2 	"/>
				<polyline className="st5" points="666.5,273.3 666.8,273.7 667,274 667.3,274.4 667.6,274.7 667.9,275.1 668.1,275.5 668.4,275.9
					668.6,276.2 668.8,276.6 669,277 669.2,277.4 669.4,277.8 669.6,278.2 669.8,278.6 669.9,279 670,279.4 670.1,279.8 670.2,280.2
					670.3,280.6 670.3,281 670.3,281.3 670.3,281.7 670.2,282 670.1,282.3 669.9,282.5 669.7,282.7 669.4,282.9 669,283 668.7,283
					668.2,283 667.8,282.9 667.3,282.7 666.8,282.5 666.3,282.1 665.8,281.8 665.2,281.3 664.7,280.9 664.2,280.4 663.7,279.8 	"/>
				<polyline className="st5" points="535.9,292.8 536.1,292.5 536.4,292.2 536.7,291.9 537,291.6 537.2,291.3 537.5,291 537.8,290.8
					538,290.5 538.3,290.3 538.5,290.1 538.7,290 539,289.8 539.2,289.7 539.4,289.6 539.6,289.5 539.7,289.5 539.9,289.4 540.1,289.4
					540.2,289.5 540.3,289.6 540.4,289.7 540.5,289.8 540.6,290 540.6,290.2 540.6,290.4 540.6,290.7 540.6,291.1 540.5,291.4
					540.4,291.8 540.3,292.3 540.1,292.8 539.9,293.3 539.6,293.9 539.3,294.5 539,295.2 538.6,295.8 538.6,296 	"/>
				<polyline className="st5" points="535.9,299.5 535.6,299.8 535.4,300.1 535.1,300.4 534.8,300.6 534.5,300.8 534.3,301 534,301.2
					533.7,301.4 533.5,301.5 533.3,301.6 533,301.7 532.8,301.7 532.6,301.7 532.5,301.7 532.3,301.7 532.2,301.6 532,301.5
					531.9,301.4 531.8,301.2 531.8,301 531.8,300.7 	"/>
				<polyline className="st5" points="531.8,300.7 531.8,300.4 531.8,300.1 531.9,299.7 532,299.2 532.2,298.7 532.5,298.2 532.7,297.6
					533,297 533.4,296.4 533.7,295.8 534.1,295.2 534.5,294.5 535,294 535.4,293.4 535.9,292.8 	"/>
				<polyline className="st5" points="663.1,270.5 663.3,270.6 663.5,270.7 663.8,270.9 664,271 664.2,271.2 664.4,271.3 664.7,271.5
					664.9,271.7 665.1,271.9 665.3,272.1 665.6,272.3 665.8,272.6 666,272.8 666.3,273.1 666.5,273.3 	"/>
				<polyline className="st5" points="536.9,298.4 536.4,299 535.9,299.5 	"/>
				<polyline className="st5" points="557.8,273.3 558,273.1 558.2,272.8 558.5,272.6 558.7,272.3 558.9,272.1 559.1,271.9 559.4,271.7
					559.6,271.5 559.8,271.3 560.1,271.2 560.3,271 560.5,270.9 560.7,270.7 560.9,270.6 561.1,270.5 	"/>
				<polyline className="st5" points="560.5,279.8 560,280.4 559.5,280.9 559,281.3 558.5,281.8 558,282.1 557.5,282.5 557,282.7
					556.5,282.9 556,283 555.6,283 555.2,283 554.9,282.9 554.6,282.7 554.4,282.5 554.2,282.3 554.1,282 554,281.7 553.9,281.3
					553.9,281 554,280.6 554,280.2 554.1,279.8 554.2,279.4 554.3,279 554.5,278.6 554.6,278.2 554.8,277.8 555,277.4 555.2,277
					555.4,276.6 555.7,276.2 555.9,275.9 556.1,275.5 556.4,275.1 556.7,274.7 556.9,274.4 557.2,274 557.5,273.7 557.8,273.3 	"/>
				<polyline className="st5" points="563.2,275.2 563,275.7 562.8,276.2 562.5,276.7 562.2,277.2 561.9,277.8 561.6,278.3 561.3,278.8
					560.9,279.3 560.5,279.8 	"/>
				<polyline className="st5" points="559,299.9 559.4,299.3 559.8,298.8 560.2,298.3 560.7,297.8 561.2,297.4 561.7,297 562.2,296.7
					562.7,296.5 563.2,296.3 563.7,296.2 564.2,296.2 564.6,296.2 565.1,296.3 565.5,296.5 565.9,296.7 566.3,297 566.6,297.3
					566.9,297.7 567.2,298.1 567.4,298.6 567.6,299.1 567.7,299.6 567.8,300.2 567.8,300.8 567.8,301.5 567.7,302.2 567.6,302.8 	"/>
				<polyline className="st5" points="559,299.9 559,299.9 559,299.9 558.9,299.9 558.9,299.9 558.9,299.9 558.9,299.9 	"/>
				<polyline className="st5" points="569.4,263.8 569.6,263.8 569.9,263.9 570.1,263.9 570.4,264 570.7,264.1 571,264.3 571.3,264.4
					571.6,264.6 571.9,264.8 572.2,265.1 572.5,265.3 572.8,265.6 	"/>
				<polyline className="st5" points="685.7,296 685.6,295.8 685.2,295.2 684.9,294.5 684.6,293.9 684.4,293.3 684.2,292.8 684,292.3
					683.9,291.8 683.8,291.4 683.7,291.1 683.6,290.7 683.6,290.5 683.6,290.2 683.7,290 683.7,289.8 683.8,289.7 683.9,289.6
					684,289.5 684.2,289.4 684.3,289.4 684.5,289.5 684.7,289.5 684.9,289.6 685.1,289.7 685.3,289.8 685.5,290 685.8,290.1 686,290.3
					686.3,290.5 686.5,290.8 686.8,291 687,291.3 687.3,291.6 687.6,291.9 687.8,292.2 688.1,292.5 688.4,292.8 	"/>
				<polyline className="st5" points="571.9,273.3 571.6,273.1 571.3,272.8 571.1,272.4 570.8,272.1 570.5,271.8 570.2,271.4 570,271
					569.7,270.6 569.5,270.2 569.2,269.8 569,269.4 568.7,269 	"/>
				<polyline className="st5" points="572.8,265.6 573.2,266 573.5,266.5 573.9,266.9 574.2,267.4 574.5,267.9 574.7,268.5 575,269
					575.2,269.6 575.4,270.1 575.6,270.7 575.7,271.3 575.8,271.8 575.9,272.3 575.9,272.8 575.9,273.3 575.9,273.7 575.8,274.1
					575.8,274.5 575.6,274.7 575.5,274.9 575.3,275.1 575.1,275.2 574.9,275.2 574.6,275.2 574.4,275.2 574.1,275.1 573.8,275
					573.5,274.8 573.2,274.6 572.9,274.3 572.6,274 572.2,273.7 571.9,273.3 	"/>
				<polyline className="st5" points="568.7,269 568.7,268.9 568.6,268.7 568.5,268.6 568.5,268.5 568.4,268.3 568.4,268.2 568.3,268
					568.2,267.9 568.2,267.8 568.1,267.6 568.1,267.5 568.1,267.3 568,267.2 568,267 568,266.9 567.9,266.7 567.9,266.5 567.9,266.4
					567.9,266.2 567.9,266.1 567.9,265.9 567.9,265.8 567.9,265.6 567.9,265.5 567.9,265.3 568,265.2 568,265.1 568.1,264.9
					568.1,264.8 568.2,264.7 568.3,264.5 568.4,264.4 568.4,264.3 568.5,264.2 568.6,264.1 568.7,264.1 568.8,264 568.9,263.9
					569.1,263.9 569.2,263.9 569.3,263.8 569.4,263.8 	"/>
				<polyline className="st5" points="561.1,270.5 561.3,270.4 561.5,270.4 561.6,270.4 561.8,270.4 561.9,270.4 562.1,270.5 562.3,270.6
					562.4,270.6 562.6,270.8 562.7,270.9 562.8,271 562.9,271.2 563.1,271.3 563.2,271.5 563.2,271.7 563.3,271.9 563.4,272.1
					563.5,272.3 563.5,272.5 563.5,272.8 563.5,273 563.5,273.2 563.5,273.5 563.5,273.7 563.5,274 563.4,274.2 563.4,274.4
					563.3,274.7 563.2,274.9 563.2,275.2 	"/>
				<polyline className="st5" points="566.6,305.1 566.3,305.6 565.9,306.1 565.5,306.5 565.1,306.9 564.7,307.2 564.3,307.4 564,307.6
					563.6,307.8 563.2,307.9 562.8,308 562.5,308 562.1,308 561.8,308 561.4,307.9 561.1,307.8 	"/>
				<polyline className="st5" points="561.1,307.8 560.7,307.6 560.4,307.4 560.1,307.2 559.8,307 559.5,306.7 559.2,306.4 559,306.1
					558.8,305.8 558.5,305.4 	"/>
				<polyline className="st5" points="567.6,302.8 567.4,303.2 567.3,303.6 567.1,304 567,304.4 566.8,304.8 566.6,305.1 	"/>
				<polyline className="st5" points="558.8,300.2 558.9,300.2 558.9,300.1 558.9,300.1 558.9,300 559,300 559,299.9 	"/>
				<polyline className="st5" points="558.5,305.4 558.3,304.9 558.1,304.3 558,303.7 558,303.1 558,302.5 558.1,301.9 558.3,301.3
					558.6,300.8 558.8,300.2 	"/>
				<polyline className="st5" points="678.7,315.6 678.5,315.7 678.2,315.8 678,315.8 677.8,315.9 677.6,316 677.3,316 677.1,316
					676.8,316 676.6,316.1 676.3,316.1 676.1,316 675.8,316 675.6,316 675.4,315.9 675.1,315.9 674.9,315.8 674.7,315.7 674.5,315.6
					674.3,315.5 674.1,315.4 673.9,315.3 673.7,315.2 673.5,315 673.3,314.9 673.2,314.7 673.1,314.6 672.9,314.4 672.8,314.3
					672.7,314.1 672.7,313.9 672.6,313.7 672.5,313.6 672.5,313.4 672.5,313.2 672.5,313 672.5,312.8 672.5,312.6 672.5,312.5
					672.6,312.3 672.7,312.1 672.7,311.9 672.8,311.8 672.9,311.6 673.1,311.4 673.2,311.3 673.4,311.1 673.5,311 673.7,310.9
					673.9,310.8 674.1,310.6 674.3,310.5 	"/>
				<polyline className="st5" points="674.3,310.5 674.5,310.4 674.7,310.4 674.9,310.3 675.1,310.2 675.4,310.2 675.6,310.1 675.9,310.1
					676.1,310.1 676.4,310.1 676.6,310.1 676.8,310.1 677.1,310.1 677.3,310.2 677.6,310.2 677.8,310.3 678,310.3 678.3,310.4
					678.5,310.5 678.7,310.6 678.9,310.7 679.1,310.8 679.3,311 679.4,311.1 679.6,311.2 679.7,311.4 679.9,311.5 680,311.7
					680.1,311.9 680.2,312 680.3,312.2 680.4,312.4 680.4,312.6 680.4,312.8 680.5,312.9 680.5,313.1 680.5,313.3 680.4,313.5
					680.4,313.7 680.3,313.8 680.3,314 680.2,314.2 680.1,314.4 680,314.5 679.9,314.7 679.7,314.8 679.6,315 679.4,315.1 679.2,315.3
					679.1,315.4 678.9,315.5 678.7,315.6 	"/>
				<polyline className="st5" points="631.4,286.3 631.3,286.2 631.2,286 631,285.8 630.9,285.6 630.8,285.4 630.6,285.2 630.5,285
					630.4,284.8 630.3,284.6 630.3,284.4 630.2,284.2 630.1,284.1 630.1,283.9 630,283.7 630,283.5 630,283.4 630,283.2 630,283.1
					630,282.9 630,282.8 630.1,282.7 630.1,282.5 630.2,282.4 630.3,282.3 630.4,282.3 630.5,282.2 630.6,282.1 630.7,282.1 630.8,282
					630.9,282 631.1,282 631.2,282 631.4,282 631.5,282.1 631.7,282.1 631.9,282.1 632,282.2 632.2,282.3 632.4,282.4 	"/>
				<polyline className="st5" points="591.9,282.4 591.7,282.5 591.5,282.6 591.3,282.7 591.1,282.8 591.1,282.8 	"/>
				<polyline className="st5" points="592.8,286.3 592.9,286.2 593.1,286 593.2,285.8 593.4,285.6 593.5,285.4 593.6,285.2 593.7,285
					593.8,284.8 593.9,284.6 594,284.4 594.1,284.2 594.1,284.1 594.2,283.9 594.2,283.7 594.2,283.5 594.3,283.4 594.3,283.2
					594.3,283.1 594.2,282.9 594.2,282.8 594.2,282.7 594.1,282.5 594.1,282.4 594,282.3 593.9,282.3 593.8,282.2 593.7,282.1
					593.6,282.1 593.5,282 593.3,282 593.2,282 593,282 592.9,282 592.7,282 592.6,282.1 592.4,282.1 592.2,282.2 592,282.3
					591.9,282.4 	"/>
				<polyline className="st5" points="545.6,315.6 545.8,315.7 546,315.8 546.2,315.8 546.5,315.9 546.7,316 546.9,316 547.2,316
					547.4,316 547.7,316.1 547.9,316.1 548.2,316 548.4,316 548.6,316 548.9,315.9 549.1,315.9 549.4,315.8 549.6,315.7 549.8,315.6
					550,315.5 550.2,315.4 550.4,315.3 550.6,315.2 550.7,315 550.9,314.9 551.1,314.7 551.2,314.6 551.3,314.4 551.4,314.3
					551.5,314.1 551.6,313.9 551.7,313.7 551.7,313.6 551.8,313.4 551.8,313.2 551.8,313 551.8,312.8 551.8,312.6 551.7,312.5
					551.7,312.3 551.6,312.1 551.5,311.9 551.4,311.8 551.3,311.6 551.2,311.4 551,311.3 550.9,311.1 550.7,311 550.6,310.9
					550.4,310.8 550.2,310.6 550,310.5 	"/>
				<polyline className="st5" points="550,310.5 549.8,310.4 549.6,310.4 549.3,310.3 549.1,310.2 548.9,310.2 548.6,310.1 548.4,310.1
					548.1,310.1 547.9,310.1 547.7,310.1 547.4,310.1 547.2,310.1 546.9,310.2 546.7,310.2 546.4,310.3 546.2,310.3 546,310.4
					545.8,310.5 545.6,310.6 545.4,310.7 545.2,310.8 545,311 544.8,311.1 544.7,311.2 544.5,311.4 544.4,311.5 544.3,311.7
					544.1,311.9 544.1,312 544,312.2 543.9,312.4 543.9,312.6 543.8,312.8 543.8,312.9 543.8,313.1 543.8,313.3 543.8,313.5
					543.9,313.7 543.9,313.8 544,314 544.1,314.2 544.2,314.4 544.3,314.5 544.4,314.7 544.5,314.8 544.7,315 544.8,315.1 545,315.3
					545.2,315.4 545.4,315.5 545.6,315.6 	"/>
				<polyline className="st5" points="685.5,295.4 685.4,295.2 685.3,294.9 685.2,294.7 685.1,294.5 685,294.3 685,294 685,293.8
					684.9,293.7 684.9,293.5 684.9,293.3 685,293.2 685,293.1 685,293 685.1,292.9 685.2,292.8 685.3,292.7 685.4,292.7 685.5,292.7
					685.6,292.7 685.7,292.7 685.9,292.7 686,292.8 686.2,292.8 686.3,292.9 686.5,293 686.7,293.1 686.9,293.3 687.1,293.4
					687.2,293.6 687.4,293.8 687.6,293.9 687.8,294.2 	"/>
				<polyline className="st5" points="538.8,295.4 538.9,295.2 539,294.9 539.1,294.7 539.2,294.5 539.2,294.3 539.3,294 539.3,293.8
					539.3,293.7 539.3,293.5 539.3,293.3 539.3,293.2 539.3,293.1 539.2,293 539.2,292.9 539.1,292.8 539,292.7 538.9,292.7
					538.8,292.7 538.7,292.7 538.5,292.7 538.4,292.7 538.2,292.8 538.1,292.8 537.9,292.9 537.7,293 537.6,293.1 537.4,293.3
					537.2,293.4 537,293.6 536.8,293.8 536.6,293.9 536.4,294.2 	"/>
				<polyline className="st5" points="663.3,301.5 663.2,301.3 663,301.1 662.9,301 662.8,300.8 662.6,300.6 662.5,300.5 662.3,300.3
					662.2,300.2 662,300 661.8,299.9 661.7,299.8 661.5,299.7 661.3,299.6 661.2,299.5 661,299.5 660.8,299.4 660.6,299.4 660.4,299.3
					660.3,299.3 660.1,299.3 659.9,299.3 659.7,299.3 659.6,299.3 659.4,299.4 659.3,299.4 659.1,299.5 659,299.5 658.8,299.6
					658.7,299.7 658.5,299.8 658.4,299.9 658.3,300 658.2,300.1 658.1,300.3 658,300.4 657.9,300.6 657.8,300.7 657.8,300.9
					657.7,301.1 657.7,301.2 657.6,301.4 657.6,301.6 657.6,301.8 657.5,302 657.5,302.2 657.6,302.4 657.6,302.6 657.6,302.8
					657.6,303 657.7,303.2 657.7,303.5 657.8,303.7 657.9,303.9 658,304.1 658.1,304.3 658.2,304.5 658.3,304.7 	"/>
				<polyline className="st5" points="658.3,304.7 658.4,304.9 658.5,305 658.6,305.2 658.8,305.4 658.9,305.5 659.1,305.7 659.2,305.8
					659.4,306 659.5,306.1 659.7,306.2 659.9,306.3 660,306.4 660.2,306.5 660.4,306.6 660.6,306.7 660.7,306.8 660.9,306.8
					661.1,306.8 661.3,306.9 661.5,306.9 661.6,306.9 661.8,306.9 662,306.8 662.1,306.8 	"/>
				<polyline className="st5" points="662.1,306.8 662.3,306.8 662.4,306.7 662.6,306.6 662.7,306.6 662.9,306.5 663,306.4 663.1,306.3
					663.2,306.2 663.4,306 663.5,305.9 663.6,305.8 663.6,305.6 663.7,305.4 663.8,305.3 663.8,305.1 663.9,304.9 663.9,304.7
					664,304.5 664,304.3 664,304.2 664,303.9 664,303.7 664,303.5 663.9,303.3 663.9,303.1 663.9,302.9 663.8,302.7 663.7,302.5
					663.7,302.3 663.6,302.1 663.5,301.9 663.4,301.7 663.3,301.5 	"/>
				<polyline className="st5" points="665.4,274.7 665.6,275 665.8,275.2 666,275.5 666.1,275.7 666.3,276 666.5,276.3 666.6,276.5
					666.7,276.8 666.9,277.1 667,277.3 667.1,277.6 667.2,277.9 667.2,278.1 667.3,278.4 667.3,278.6 667.4,278.9 667.4,279.1
					667.4,279.3 667.4,279.5 667.4,279.7 667.3,279.9 667.3,280.1 667.2,280.2 667.1,280.4 667,280.5 666.9,280.6 666.8,280.6
					666.7,280.7 666.6,280.8 666.4,280.8 666.2,280.8 666.1,280.8 665.9,280.7 665.7,280.7 665.5,280.6 665.4,280.5 665.2,280.4
					665,280.3 664.8,280.2 664.6,280 664.4,279.8 664.2,279.6 664,279.5 663.8,279.2 663.6,279 	"/>
				<polyline className="st5" points="663.6,279 663.4,278.8 663.2,278.5 663,278.3 662.9,278 662.7,277.8 662.5,277.5 662.4,277.2
					662.3,277 662.1,276.7 662,276.4 661.9,276.1 661.8,275.9 661.8,275.6 661.7,275.4 661.7,275.1 661.6,274.9 661.6,274.6
					661.6,274.4 661.6,274.2 661.6,274 661.7,273.8 661.7,273.7 661.8,273.5 661.9,273.4 662,273.3 662.1,273.2 662.2,273.1 662.3,273
					662.4,273 662.6,273 662.8,273 662.9,273 663.1,273 663.3,273.1 663.5,273.1 663.6,273.2 663.8,273.3 664,273.5 664.2,273.6
					664.4,273.7 664.6,273.9 664.8,274.1 665,274.3 665.2,274.5 665.4,274.7 	"/>
				<polyline className="st5" points="687.8,294.2 688,294.4 688.2,294.6 688.4,294.8 688.6,295.1 688.8,295.3 688.9,295.6 689.1,295.8
					689.3,296.1 689.4,296.3 689.6,296.6 689.7,296.9 689.9,297.1 690,297.4 690.1,297.6 690.2,297.9 690.3,298.1 690.3,298.3
					690.4,298.6 690.4,298.8 690.5,299 690.5,299.1 690.5,299.3 690.5,299.5 690.5,299.6 690.4,299.7 690.4,299.9 690.3,300 690.3,300
					690.2,300.1 690.1,300.1 690,300.1 689.8,300.2 689.7,300.1 689.6,300.1 689.4,300.1 689.3,300 689.1,299.9 688.9,299.8
					688.8,299.7 688.6,299.5 688.4,299.4 688.2,299.2 688,299.1 687.8,298.9 687.6,298.7 	"/>
				<polyline className="st5" points="653.2,271.9 653,272.1 652.8,272.3 652.6,272.5 652.4,272.6 652.2,272.8 652,272.9 651.8,273
					651.6,273.1 651.4,273.2 651.3,273.3 651.1,273.4 650.9,273.4 650.8,273.4 650.6,273.4 650.5,273.4 650.4,273.3 650.3,273.3
					650.2,273.2 650.1,273.1 650,273 650,272.9 649.9,272.7 649.9,272.6 649.9,272.4 649.9,272.2 649.9,272 649.9,271.8 650,271.6
					650,271.4 650.1,271.1 650.2,270.9 650.3,270.6 650.4,270.4 650.5,270.1 650.6,269.9 650.8,269.6 650.9,269.3 651.1,269.1
					651.3,268.8 651.4,268.6 651.6,268.3 651.8,268.1 652,267.9 652.2,267.6 652.4,267.4 	"/>
				<polyline className="st5" points="652.4,267.4 652.6,267.2 652.8,267 653,266.8 653.2,266.7 653.4,266.5 653.6,266.4 653.8,266.3
					654,266.2 654.2,266.1 654.4,266 654.5,265.9 654.7,265.9 654.8,265.9 655,265.9 655.1,265.9 655.2,266 655.3,266 655.4,266.1
					655.5,266.2 655.6,266.3 655.7,266.4 655.7,266.6 655.7,266.7 655.7,266.9 655.7,267.1 655.7,267.3 655.7,267.5 655.7,267.7
					655.6,267.9 655.5,268.2 655.4,268.4 655.4,268.7 655.2,268.9 655.1,269.2 655,269.4 654.9,269.7 654.7,270 654.5,270.2
					654.4,270.5 654.2,270.7 654,271 653.8,271.2 653.6,271.4 653.4,271.7 653.2,271.9 	"/>
				<polyline className="st5" points="571,271.9 571.2,272.1 571.4,272.3 571.6,272.5 571.8,272.6 572,272.8 572.2,272.9 572.4,273
					572.6,273.1 572.8,273.2 573,273.3 573.2,273.4 573.3,273.4 573.5,273.4 573.6,273.4 573.7,273.4 573.9,273.3 574,273.3
					574.1,273.2 574.1,273.1 574.2,273 574.3,272.9 574.3,272.7 574.3,272.6 574.4,272.4 574.4,272.2 574.3,272 574.3,271.8
					574.3,271.6 574.2,271.4 574.2,271.1 574.1,270.9 574,270.6 573.9,270.4 573.7,270.1 573.6,269.9 573.5,269.6 573.3,269.3
					573.2,269.1 573,268.8 572.8,268.6 572.6,268.3 572.4,268.1 572.3,267.9 572.1,267.6 571.9,267.4 	"/>
				<polyline className="st5" points="571.9,267.4 571.6,267.2 571.4,267 571.2,266.8 571,266.7 570.8,266.5 570.6,266.4 570.4,266.3
					570.3,266.2 570.1,266.1 569.9,266 569.7,265.9 569.6,265.9 569.4,265.9 569.3,265.9 569.1,265.9 569,266 568.9,266 568.8,266.1
					568.7,266.2 568.7,266.3 568.6,266.4 568.6,266.6 568.5,266.7 568.5,266.9 568.5,267.1 568.5,267.3 568.6,267.5 568.6,267.7
					568.7,267.9 568.7,268.2 568.8,268.4 568.9,268.7 569,268.9 569.1,269.2 569.3,269.4 569.4,269.7 569.6,270 569.7,270.2
					569.9,270.5 570.1,270.7 570.2,271 570.4,271.2 570.6,271.4 570.8,271.7 571,271.9 	"/>
				<polyline className="st5" points="561,301.5 561.1,301.3 561.2,301.1 561.3,301 561.5,300.8 561.6,300.6 561.8,300.5 561.9,300.3
					562.1,300.2 562.2,300 562.4,299.9 562.6,299.8 562.7,299.7 562.9,299.6 563.1,299.5 563.3,299.5 563.5,299.4 563.6,299.4
					563.8,299.3 564,299.3 564.2,299.3 564.3,299.3 564.5,299.3 564.7,299.3 564.8,299.4 565,299.4 565.2,299.5 565.3,299.5
					565.4,299.6 565.6,299.7 565.7,299.8 565.8,299.9 566,300 566.1,300.1 566.2,300.3 566.3,300.4 566.3,300.6 566.4,300.7
					566.5,300.9 566.6,301.1 566.6,301.2 566.6,301.4 566.7,301.6 566.7,301.8 566.7,302 566.7,302.2 566.7,302.4 566.7,302.6
					566.7,302.8 566.6,303 566.6,303.2 566.5,303.5 566.4,303.7 566.4,303.9 566.3,304.1 566.2,304.3 566.1,304.5 566,304.7 	"/>
				<polyline className="st5" points="566,304.7 565.9,304.9 565.7,305 565.6,305.2 565.5,305.4 565.3,305.5 565.2,305.7 565,305.8
					564.9,306 564.7,306.1 564.6,306.2 564.4,306.3 564.2,306.4 564,306.5 563.9,306.6 563.7,306.7 563.5,306.8 563.3,306.8
					563.1,306.8 563,306.9 562.8,306.9 562.6,306.9 562.5,306.9 562.3,306.8 562.1,306.8 	"/>
				<polyline className="st5" points="562.1,306.8 562,306.8 561.8,306.7 561.7,306.6 561.5,306.6 561.4,306.5 561.2,306.4 561.1,306.3
					561,306.2 560.9,306 560.8,305.9 560.7,305.8 560.6,305.6 560.5,305.4 560.5,305.3 560.4,305.1 560.4,304.9 560.3,304.7
					560.3,304.5 560.3,304.3 560.3,304.2 560.3,303.9 560.3,303.7 560.3,303.5 560.3,303.3 560.3,303.1 560.4,302.9 560.4,302.7
					560.5,302.5 560.6,302.3 560.7,302.1 560.8,301.9 560.9,301.7 561,301.5 	"/>
				<polyline className="st5" points="558.8,274.7 558.6,275 558.5,275.2 558.3,275.5 558.1,275.7 557.9,276 557.8,276.3 557.6,276.5
					557.5,276.8 557.4,277.1 557.3,277.3 557.2,277.6 557.1,277.9 557,278.1 557,278.4 556.9,278.6 556.9,278.9 556.9,279.1
					556.9,279.3 556.9,279.5 556.9,279.7 556.9,279.9 557,280.1 557.1,280.2 557.1,280.4 557.2,280.5 557.3,280.6 557.4,280.6
					557.6,280.7 557.7,280.8 557.8,280.8 558,280.8 558.2,280.8 558.3,280.7 558.5,280.7 558.7,280.6 558.9,280.5 559.1,280.4
					559.3,280.3 559.5,280.2 559.7,280 559.9,279.8 560.1,279.6 560.3,279.5 560.5,279.2 560.7,279 	"/>
				<polyline className="st5" points="560.7,279 560.9,278.8 561.1,278.5 561.2,278.3 561.4,278 561.6,277.8 561.7,277.5 561.9,277.2
					562,277 562.1,276.7 562.2,276.4 562.3,276.1 562.4,275.9 562.5,275.6 562.5,275.4 562.6,275.1 562.6,274.9 562.6,274.6
					562.6,274.4 562.6,274.2 562.6,274 562.6,273.8 562.5,273.7 562.5,273.5 562.4,273.4 562.3,273.3 562.2,273.2 562.1,273.1
					561.9,273 561.8,273 561.7,273 561.5,273 561.3,273 561.2,273 561,273.1 560.8,273.1 560.6,273.2 560.4,273.3 560.2,273.5
					560,273.6 559.8,273.7 559.6,273.9 559.4,274.1 559.2,274.3 559,274.5 558.8,274.7 	"/>
				<polyline className="st5" points="536.4,294.2 536.2,294.4 536,294.6 535.9,294.8 535.7,295.1 535.5,295.3 535.3,295.6 535.1,295.8
					535,296.1 534.8,296.3 534.7,296.6 534.5,296.9 534.4,297.1 534.3,297.4 534.2,297.6 534.1,297.9 534,298.1 533.9,298.3
					533.9,298.6 533.8,298.8 533.8,299 533.8,299.1 533.8,299.3 533.8,299.5 533.8,299.6 533.8,299.7 533.9,299.9 533.9,300 534,300
					534.1,300.1 534.2,300.1 534.3,300.1 534.4,300.2 534.5,300.1 534.7,300.1 534.8,300.1 535,300 535.2,299.9 535.3,299.8
					535.5,299.7 535.7,299.5 535.9,299.4 536.1,299.2 536.3,299.1 536.4,298.9 536.6,298.7 	"/>
			</g>
			<path className="st6" d="M610,329.7h4.2c0.2,0,0.3-0.1,0.3-0.3c0-0.2-0.1-0.3-0.3-0.3H610c-0.2,0-0.3,0.1-0.3,0.3S609.9,329.7,610,329.7
				"/>
			<path className="st6" d="M614.2,330.4H610c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h4.2c0.2,0,0.3-0.1,0.3-0.3
				S614.4,330.4,614.2,330.4"/>
			<path className="st6" d="M614.2,331.7H610c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h4.2c0.2,0,0.3-0.1,0.3-0.3
				C614.5,331.8,614.4,331.7,614.2,331.7"/>
			<path d="M614.6,427.7l-0.5-0.3l-0.5-0.3l0.5-0.3l0.5-0.3c0.2-0.1,0.2-0.3,0-0.4l-0.5-0.3l-1.9-1.3c0,0-0.1-0.1-0.2-0.1
				c-0.1-0.1-0.3-0.1-0.4,0l-0.2,0.1l-1.9,1.3l-0.5,0.3c-0.2,0.1-0.2,0.3,0,0.4l0.5,0.3l0.5,0.3l-0.5,0.3l-0.5,0.3
				c-0.2,0.1-0.2,0.3,0,0.4l0.5,0.3l1.9,1.3c0,0,0.1,0.1,0.2,0.1c0.1,0.1,0.3,0.1,0.4,0l0.2-0.1l1.9-1.3l0.5-0.3
				C614.8,428,614.8,427.8,614.6,427.7 M611.8,424.9l1.9,1.3l-1.9,1.3l-1.9-1.3L611.8,424.9z M611.8,429.2l-1.9-1.3l0.7-0.5l0.8,0.5
				c0,0,0.1,0.1,0.2,0.1c0.1,0.1,0.3,0.1,0.4,0l0.2-0.1l0.8-0.5l0.7,0.5L611.8,429.2z"/>
			<g id="Layer_7">
				<path className="st6" d="M614.1,469.1c-0.7,0.2-1.5,0.3-2.3,0.3s-1.5-0.1-2.3-0.3c-0.8-0.3-1.4-1.1-1.2-2c0.3-1.6,1.1-2.9,2.3-4
					c0.7-0.6,1.7-0.6,2.3,0c1.1,1,1.9,2.4,2.3,4C615.5,467.9,614.9,468.8,614.1,469.1 M618.1,468.3l-4.8-8.2c-0.1-0.3-0.4-0.4-0.7-0.4
					H611c-0.3,0-0.6,0.2-0.7,0.4l-4.8,8.2c-0.1,0.3-0.1,0.6,0,0.8l0.8,1.4c0.1,0.3,0.4,0.4,0.7,0.4h9.5c0.3,0,0.6-0.2,0.7-0.4l0.8-1.4
					C618.3,468.8,618.3,468.5,618.1,468.3"/>
				<path className="st6" d="M618.4,478.7l-2.9,5.6c0,0.1-0.1,0.1-0.2,0.1h-0.9c-0.1,0-0.2-0.1-0.2-0.1l-2.9-5.6c0-0.1,0-0.2,0-0.3l0.3-0.5
					c0.1-0.1,0.2-0.2,0.3-0.2h0.3c0.1,0,0.1,0,0.2,0.1l2.4,4.8c0.1,0.1,0.2,0.1,0.2,0l2.4-4.8c0-0.1,0.1-0.1,0.2-0.1h0.3
					c0.1,0,0.2,0.1,0.3,0.2l0.3,0.5C618.5,478.5,618.5,478.6,618.4,478.7"/>
				<path className="st6" d="M604.2,478.7l-2.9,5.6c0,0.1-0.1,0.1-0.2,0.1h-0.9c-0.1,0-0.2-0.1-0.2-0.1l-2.9-5.6c-0.1-0.1,0-0.2,0-0.3
					l0.3-0.5c0.1-0.1,0.2-0.2,0.3-0.2h0.3c0.1,0,0.1,0,0.2,0.1l2.4,4.8c0,0.1,0.2,0.1,0.2,0l2.4-4.8c0-0.1,0.1-0.1,0.2-0.1h0.3
					c0.1,0,0.2,0.1,0.3,0.2l0.3,0.5C604.3,478.5,604.3,478.6,604.2,478.7"/>
				<path className="st6" d="M608.3,477.8c0,0-0.1-0.1-0.2-0.1h-0.4c-0.1,0-0.2,0.1-0.3,0.2l-0.3,0.5c0,0,0,0.1,0,0.2v5.7
					c0,0.2,0.1,0.3,0.3,0.3h0.8c0.1,0,0.3-0.1,0.3-0.3V478C608.4,477.9,608.4,477.9,608.3,477.8"/>
				<path className="st6" d="M621.6,477.9c0.1-0.1,0.2-0.2,0.3-0.2h4.1c0.1,0,0.2,0.1,0.3,0.2l0.3,0.5c0,0.1,0.1,0.2,0.1,0.2v0.1
					c0,0.1-0.1,0.2-0.2,0.2h-3.7c-0.1,0-0.1,0.1-0.1,0.1v1.3c0,0.1,0.1,0.1,0.1,0.1h2.5c0.1,0,0.2,0.1,0.2,0.2v0.7
					c0,0.1-0.1,0.2-0.2,0.2h-2.5c-0.1,0-0.1,0.1-0.1,0.1v1.3c0,0.1,0.1,0.1,0.1,0.1h3.7c0.1,0,0.2,0.1,0.2,0.2v0.1c0,0.1,0,0.2-0.1,0.2
					l-0.3,0.5c-0.1,0.1-0.2,0.2-0.3,0.2h-4.1c-0.1,0-0.2-0.1-0.3-0.2l-0.3-0.5c0-0.1-0.1-0.2-0.1-0.2v-5c0-0.1,0-0.2,0.1-0.2
					L621.6,477.9z"/>
			</g>
		</svg>
	);
}

export function PairingUIIcon_VRInkPilotEdition( bHighlightPairingControls: boolean )
{
	return (
		<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 607.8 449.3" className="VRInkPilotEditionPairingSVG">
			<path className="st0" d="M525.4,117.5c0,0,9.7,4,11.1,4.7c1.4,0.8,6.5,2,9.8,2.1c3.3,0.1,26.9-1.7,30.3-2.1s5.3-0.9,6.4-1.5
				c1.1-0.6,15.4-8.4,16.1-8.8s2.6-1.7,3.5-5.3c0.8-3.6,3.1-17.4,3.1-17.4s-1.4-53.2-1.4-55.2s-0.6-3.9-1.1-5.3
				c-0.5-1.4-7.3-18.5-7.3-18.5s-1.4-3-5.3-3.7s-17.1-3.7-17.1-3.7s-2.1-0.3-4.6,0.7s-18,6.8-18,6.8s-5.4,2.3-7.8,4.2
				c-2.4,2-31.6,28.7-31.6,28.7l-53.2-24.5c0,0-7.5-4.4-16.1-2s-26.8,7.8-26.8,7.8l-15.4,8.2c0,0-4.1,2-4.9,5.3
				c-0.8,3.2-7.3,39.5-7.3,39.5L368.9,110c0,0-11.1,56.2-68.7,92.2s-162.1,99.7-162.1,99.7s-55.1,32-83.4,60.5
				c-1,1.1-4.2,6.1-10.5,13.6c-2.9,3.5-15,17.3-15,17.3s-9,11.7-11.3,15.1c-2.3,3.4-7.5,14-7.5,14.1c-0.1,0.1-0.6,0.7-0.7,0.9
				C9.7,423.6,4.7,435.1,4,437c-0.6,2-2,7.8,3,8.4c5,0.6,15.5,1.2,18.4,1.2s25-0.9,52.7-11.6s33.2-13.8,33.2-13.8s28.5-15.3,33.8-18.7
				s116.3-75,133.4-85.4c17.1-10.4,109-69.6,109-69.6s28.7-19,41.7-31.4S525.4,117.5,525.4,117.5z"/>
			<path className="st1" d="M31.4,433.4c0,0,89.5-42.8,119-64.6c1.8-1.4,2.1-2.8,2.1-2.8l3.3-18.1c0,0,0.7-4,3.3-5.7
				c2.6-1.7,54.8-34.8,54.8-34.8s3-1.7,6.2,0.2c3.2,1.9,11.4,7.1,11.4,7.1s1.2,1,3.1-0.3c1.9-1.2,63.3-41.1,63.3-41.1s1.1-0.9,3.4,0.1
				s13.7,5.9,13.7,5.9s1.5,0.9,3.4-0.3c1.9-1.2,28.4-18.5,28.4-18.5s1.3-0.6,2.5-3.1s10-21.8,10-21.8s0.6-1.3,1.7-1.9
				s27.2-16.6,27.2-16.6s37.7-26.1,65.1-52.2c27.3-26.1,78.1-75.2,78.1-75.2l44-43.3c0,0,7.9-7,12.3-9.4s12-6.1,12-6.1s3-1.3,3.9-0.4"
				/>
			<path className="st2" d="M511.5,43.2l-40.2,31.4c0,0-3.8,3.3-4.5,3.9c-0.2,0.2-3.4,3.6-8.2,8.1c-6,5.6-14.3,13-19.7,18
				c-3.6,3.3-6.3,5.4-6.3,5.4l-9.3,8c0,0-19.3,17.1-26.8,14.5c-6.3-0.2,1.5-13.7,5.9-25.1c4-10.3,9.2-23.5,10.1-26
				c0.1-0.3,0.5-0.6,0.5-0.6s18.3-11.2,19.3-11.9c1-0.7,1.5-1.4,1.7-2.1c1.1-5.7,3.6-28.8,3.6-28.8l0.5-1.6c0,0,4.4-5,5.3-5.6
				s1.1-0.6,4.2-1.1c3.1-0.5,9.4-3.1,11.2-3.7c0.2-0.1,0.8-0.1,1-0.1c1,0,3.1,0.1,5,0.2c0.1,0,0.4,0,0.8,0.1c3.4,0.5,15.9,3.1,16.1,3.1
				"/>
			<path className="st2" d="M525.4,117.5L567.5,80l11.2-8.2c0,0,2.1-0.5,2.3,0.1c0.3,0.6,0.7,47.6,0.7,47.6s-0.6,2.2-2,2.4"/>
			<path className="st2" d="M488.5,61.2l-13.1-5.4c0,0-3.6-1.6-5.3-1.5s-3.3,0.2-4.8,0.5c-1.5,0.4-13.4,3.4-13.4,3.4s-4.4,0.8-6.1,6.1
				c-1.7,5.3-15.1,47.4-15.1,47.4"/>
			<path className="st2" d="M447.6,83.7c-0.2,0.1,9.7-3.7,9.7-3.7s1.5-0.7,2.6-0.3c1.1,0.4,3.4,1.7,3.4,1.7"/>
			<path className="st2" d="M563.1,83.9l1.3,22.9c0,0-0.2,1.5-2.1,1.8c-2,0.3-28.8,1.7-28.8,1.7"/>
			<path className="st2" d="M415.3,24.5c0,0-6.4,1.9-7.5,6.8c-2.1,7.2-20.9,60-20.9,60s-19.9,59-62,91.9"/>
			<path className="st2" d="M543.1,14.4L427.4,125.3c0,0-12.9,11.6-14.9,13.3c-2,1.7,61.6-30.4,64.7-34.6c3.1-4.2,27.9-53.1,27.9-53.1
				s59.5-32.1,60.6-32.9c1.1-0.8,7.9-3.9,7.9-3.9L588,8c0,0,4.4-1.8,5.5-0.4"/>
			<path className="st0" d="M456.8,87.1l-7.4-3.3l-2.5,0.8c0,0-1.3,0.9-2.1,3.4c-0.7,2.5-4.4,14.1-4.4,14.1L456.8,87.1z"/>
			<ellipse transform="matrix(0.9487 -0.3162 0.3162 0.9487 -94.0135 57.5569)" className="st2" cx="130.3" cy="318.4" rx="20.9" ry="6.1"/>
			<ellipse transform="matrix(0.9487 -0.3162 0.3162 0.9487 -94.0135 57.5569)" className="st1" cx="130.3" cy="318.4" rx="17.7" ry="5.2"/>
			<path className="st2" d="M229.7,262.3c5.2,3-4.6,9.7-9.4,12.7c-4.8,3-34.2,21.2-35.8,22.1s-4.3,2.2-6,2.8c-1.7,0.6-30,11.1-36.3,4.9
				c-2.9-3.2,5.8-8.3,7-8.9c1.2-0.7,31.6-19.4,41.7-25.6C204.9,261.9,224.6,259.3,229.7,262.3z"/>
			<path className="st1" d="M226.1,263.7c2,1.2,2,3.9-10.8,11.6c-14.3,8.9-29.9,18.4-31.8,19.6c-1.9,1.2-4.2,2.7-6.7,3.8
				c-2.5,1.1-24.5,10.2-30.5,4.4c-2.2-2.8,5.6-7.9,5.6-7.9s35.4-21.8,39.2-24C197.2,267.5,218.4,259.2,226.1,263.7z"/>
			<polygon className="st3" points="164.9,362.4 162.3,361 163.2,357.6 167.1,355 169.8,355.9 169.7,359.2 "/>
			<polygon className="st3" points="166,347.7 168.9,349 173.3,345.9 173.8,342.7 171,341.7 166.9,344.3 "/>
			<polygon className="st3" points="178.3,355.4 174.4,353.2 175.6,347.8 181.5,344 185.7,346.1 184.1,351.4 "/>
			<polygon className="st3" points="179,360.3 176.4,359.1 172.3,361.7 171,365.5 174.3,366.2 177.8,364 "/>
			<polygon className="st3" points="186.3,358.4 183.8,357.3 185.2,353.3 190.8,349.7 193.5,351 192.1,354.8 "/>
			<polygon className="st3" points="197.5,342.8 192.1,346.6 187.9,344.5 189.2,339.2 194.6,335.5 198.9,337.5 "/>
			<polygon className="st3" points="205,338 201.4,335.7 202.5,330.2 207.9,326.6 212.5,328.6 211,334 "/>
			<polygon className="st3" points="218.7,327.3 216.2,326.1 217.2,322.5 220.9,320 223.7,321.5 222.6,325 "/>
			<polygon className="st3" points="187.4,337.2 182,340.6 179.2,339.2 180,336.1 185.3,332.7 187.6,333.6 "/>
			<polygon className="st3" points="199.8,349.2 197.6,348.1 199,344.8 204.1,341.4 206.7,342.5 205.1,345.9 "/>
			<polygon className="st3" points="219.1,334.4 216.8,333.3 213,335.6 211.8,339.2 214.2,340.2 217.8,337.9 "/>
			<polygon className="st3" points="195.2,332.1 192.3,330.7 193.2,327.1 198.4,323.7 202,325 200.9,328.4 "/>
			<polygon className="st3" points="207.4,318.2 206.6,321.5 209.3,323.1 213.2,320.5 214.1,317 211.5,315.6 "/>
			<ellipse transform="matrix(0.9487 -0.3162 0.3162 0.9487 -67.8877 87.7272)" className="st2" cx="236.3" cy="253" rx="13.4" ry="3.9"/>
			<ellipse transform="matrix(0.9487 -0.3162 0.3162 0.9487 -67.8877 87.7272)" className="st1" cx="236.3" cy="253" rx="11.3" ry="3.3"/>
			<ellipse transform="matrix(0.9487 -0.3162 0.3162 0.9487 -54.4079 103.1643)" className="st2" cx="290.6" cy="219.2" rx="8.8" ry="2.6"/>
			{ bHighlightPairingControls && <ellipse transform="matrix(0.9487 -0.3162 0.3162 0.9487 -67.8877 87.7272)" className="st4" cx="236.3" cy="253" rx="13.4" ry="3.9"/> }
			<ellipse transform="matrix(0.9487 -0.3162 0.3162 0.9487 -54.2568 103.0851)" className="st2" cx="290.5" cy="218.7" rx="6" ry="1.8"/>
			<path className="st1" d="M10.4,422.6c0,0,6.8-5.5,15.2,7.5s0.5,16.6-0.2,16.6"/>
			<path className="st1" d="M11.7,419.9c0,0,7.6-6.1,16.9,8.3c9.3,14.4,0.6,18.4-0.2,18.4"/>
			{ bHighlightPairingControls && <ellipse transform="matrix(0.9487 -0.3162 0.3162 0.9487 -54.4079 103.1643)" className="st4" cx="290.6" cy="219.2" rx="8.8" ry="2.6"/> }
		</svg>
	);
}
